<template>
    <div class="container-fluid" id="dvcrud">
		<detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="false"></detalhespedido>
        <visualizadorestoque :idproduto="idprodutoestoque" :descricao="descproestoque"></visualizadorestoque>
        <fornecedoresproduto :idproduto="idprodutofornecedores" :descricao="descprofornecedores"></fornecedoresproduto>
        <enviarprodutocoletor v-bind:produto="produtocoletor" v-bind:qtdenviar="qtdenviarcoletor"></enviarprodutocoletor>
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>

            </div>
            <div class="col-md-12">
                <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
                <ConsultaProdutosNostaFor @mtdimportaprodutos="mtdbuscaprodutosnota"/>
                <div id="pnlista" class="card" style="display: none;"> 
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Clo se"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <button v-show="mtdverificaajusteestoque()" type="button" class="close" data-dismiss="modal" aria-label="Close" title="Ajustar estoque" style="margin-right: 10px;" @click.prevent="mtdajustarestoquerapido()"><span aria-hidden="true"><i class="fa fa-cubes"></i></span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Gerador de etiquetas" style="margin-right: 10px;" @click.prevent="mtdbaixaretiquetador()"><span aria-hidden="true"><i class="fa fa-tags"></i></span></button>
                        <button v-show="mtdverificaatualizacustoarquivo()" type="button" class="close" data-dismiss="modal" aria-label="Close" title="Ajustar custo de produtos via arquivo" style="margin-right: 10px;" @click.prevent="mtdajustarcusto()"><span aria-hidden="true"><i class="fa fa-percent"></i></span></button>
                        <button v-show="mtdverificaimportaclssencm()" type="button" class="close" data-dismiss="modal" aria-label="Close" title="Atribuir classe por NCM" style="margin-right: 10px;" @click.prevent="mtdatribuirclassencm()"><span aria-hidden="true"><i class="fa fa-file-excel-o"></i></span></button>
                        <export-excel style="display: none;" id="btexportarexcel"
                            :data   = "lstprodutosexportar"
                            :fields = "json_fields"
                            name    = "produtos.xls">
                        </export-excel>
                        <button type="button" class="close" title="Gerar catalogo de produtos" style="margin-right: 10px;" @click.prevent="mtdabremodalcatalogo()"><span aria-hidden="true"><i class="fa fa-th-large"></i></span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar cadastro de produtos" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar Produtos (NFe Entrada)" style="margin-right: 10px;" @click.prevent="mdlimportaprodutosnfentrada()"><span aria-hidden="true"><i class="fa fa-file-text"></i></span></button>
						<button v-if="!pmaisfiltros" type="button" class="close" title="Mais filtros" style="margin-right: 15px;" @click.prevent="mtdmaisfiltros()"><i class="fa fa-angle-double-down"></i></button>
						<button v-else type="button" class="close" title="Menos filtros" style="margin-right: 15px;" @click.prevent="mtdmaisfiltros()"><i class="fa fa-angle-double-up"></i></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <!-- CP FILTRO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                    <option value="2">Referência</option>
                                </select>
                            </div>
                            <!-- CP CONTEUDO -->
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <!-- CP ESPECIFICAÇÃO -->
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edespecificacaopesq">Especificação:</label>
                                <input id="edespecificacaopesq" type="text" class="form-control form-control-sm" v-model="pespecificacao" @keyup="mtdlimpar_listagem()">
                            </div>
                            <!-- CP MARCA                           -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcapesq" v-model="pidmarca"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP GRUPO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupopesqlistagem" v-model="pidgrupo"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SUBGRUPO -->
                            <div class="col-sm-12" v-bind:class="pmaisfiltros ? 'col-md-3 col-lg-3' : 'col-md-2 col-lg-2' ">
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupopesqlistagem" v-model="pidsubgrupo"
                                        data-placeholder="Selecione um subgrupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SETORPESQUISA -->
                            <div class="col-sm-12" v-bind:class="pmaisfiltros ? 'col-md-3 col-lg-3' : 'col-md-2 col-lg-2' ">
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetorpesqlistagem" v-model="pidsetor"
                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP NCM -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmpesq" data-placeholder="Selecione uma opção" v-model="pidncm"
                                     data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SITUAÇÃO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbstpropesq">Situação:</label>
                                <select name="cbstpropesq" class="form-control form-control-sm" id="cbstpropesq" v-model="pstpro" @change="mtdlimpar_listagem()" title="Situação dos produtos">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <!-- CP FRACIONADO                                                    -->
                            <div class="col-sm-12 col-md-2 col-lg-1">
                                <label for="cbfracionadopesq">Frac.:</label>
                                <select name="cbfracionadopesq" class="form-control form-control-sm" id="cbfracionadopesq" v-model="pfracionado" @change="mtdlimpar_listagem()" title="Condição para exibição dos produtos fracionados">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <!-- CP QTDREG                     -->
                            <div class="col-6 col-sm-6 col-md-2" v-bind:class="!pmaisfiltros ? 'col-lg-1' : 'col-lg-1'">
                                <label for="cbqtdreg">Reg.:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()" title="Quantidade de registros a serem exibidos">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>

                            <!-- BOTÃO PARA GERA MAIS FILTROS QUE FICA AO LADO DOS ICONES DUAS SETAS PARA BAIXO -->
                            <template v-if="pmaisfiltros">
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="cbfracionadopesq">Filtrar por:</label>
                                    <select name="cbfiltrocadastropesq" class="form-control form-control-sm" id="cbfiltrocadastropesq" v-model="pfiltrocadastropesq" @change="mtdlimpar_listagem()">
                                        <option value="0">Dt. cadastro</option>
                                        <option value="1">Dt. alteração</option>
                                        <option value="2">Dias sem movimento</option>
                                        <option value="3">Dt. vencimento</option>
                                        <option value="4">Todos</option>
                                    </select>
                                </div>
                                <div>
                                    <div v-if="pfiltrocadastropesq == 2">
                                        <label for="diasemovimento">Dias sem movimento:</label>
                                        <input type="number" min="0" name="diasemovimento" class="form-control form-control-sm" v-model="pdiasemovimento" @input="removeMinusSign">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="eddtini">De:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrocadastropesq) == 2 || parseInt(pfiltrocadastropesq) == 4 "></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="eddtfim">Até:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrocadastropesq) == 2 || parseInt(pfiltrocadastropesq) == 4"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <!-- filial localização -->
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <span class="lblselect2">F. localização:</span>
                                    <select id="cbfiliallocalizacaopesq" v-model="pidfiliallocalizacao"
                                            data-placeholder="Selecione uma filial"
                                            data-allow-clear="true" style="width:100%;">
                                    </select>
                                </div>
                                <!-- localização -->
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <span class="lblselect2">Localização:</span>
                                    <select id="cbidlocalizacaopesq" v-model="pidlocalizacao"
                                            data-placeholder="Selecione uma localização"
                                            data-allow-clear="true" style="width:100%;">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-1">
                                    <label for="cbfiltroncmpesq">Com NCM:</label>
                                    <select name="cbfiltroncmpesq" class="form-control form-control-sm" id="cbfiltroncmpesq" v-model="pfiltroncmpesq" @change="mtdlimpar_listagem()">
                                        <option value="0">Não</option>
                                        <option value="1">Sim</option>
                                        <option value="2">Todos</option>
                                    </select>
                                </div>
                            </template>
                            <div class="col-12 col-sm-12" v-bind:class="pmaisfiltros ? 'col-md-1 col-lg-1' : 'col-md-2 col-lg-2' " >
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <!-- TABELA HEADER -->
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstprodutos"
                                        :rows="lstprodutos"
                                        :columns= "columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="slot_imgproduto" slot-scope="item">
                                        <img :class="item.row.imagens.length === 0 ? 'img-lst-produto-none' : 'img-lst-produto'" title="imagem do produto" v-bind:src="mtdbuscaimagemlistapro(item.row)"> 
                                    </template>
                                    <template slot="slot_detalhes" slot-scope="item">
                                        <i @click.prevent="mtddetalhesprodutos(item.row)" class="fa fa-info-circle icon-detalhes" title="Detalhes do produto"></i>
                                    </template>		
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>
                                    <!--  -->
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="situacao_produto" slot-scope="item">
                                        <span v-if="parseInt(item.row.stpro) === 1" class="badge badge-pill badge-success">Ativo</span>
                                        <span v-else class="badge badge-pill badge-danger">Inativo</span>
                                    </template>
                                    <template slot="slot_qtd_estoque" slot-scope="item">
                                        <div>
                                            <button title="Enviar item para o coletor" type="button" class="btn btn-primary btn-sm btn-enviar-coletor" @click.prevent="mtdenviarcoletor(item.row)"><i class="fa fa-inbox"></i></button>
                                        </div>   
                                        <span v-if="parseFloat(item.row.quantidade) === 0" class="text-black-50 font-weight-bolder" style="font-size: 16px; cursor: pointer;" title="Produto sem saldo">{{ item.row.quantidade }}</span>
                                        <span v-else-if="parseFloat(item.row.quantidade) < 0" class="font-weight-bolder" style="color: #f82b54; font-size: 16px; cursor: pointer;" title="Produto com saldo negativo">{{ item.row.quantidade }}</span>
                                        <template v-else-if="parseFloat(item.row.estoqueminimo) > 0 && parseFloat(item.row.estoquemaximo) > 0">
                                            <span v-if="parseFloat(item.row.quantidade) > 0 && parseFloat(item.row.quantidade) < parseFloat(item.row.estoqueminimo)" class="font-weight-bolder" style="color: #ffbc00; font-size: 16px; cursor: pointer;" title="Produto atingiu seu estoque mínimo">{{ item.row.quantidade }}</span>
                                            <span v-else-if="parseFloat(item.row.quantidade) > parseFloat(item.row.estoquemaximo)" class="font-weight-bolder" style="color: #4250f2; font-size: 16px; cursor: pointer;" title="Produto com saldo acima do estoque máximo">{{ item.row.quantidade }}</span>
                                            <span v-else class="font-weight-bolder" style="color: #0acf97; font-size: 16px; cursor: pointer;" title="Produto com saldo">{{ item.row.quantidade }}</span>
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-bolder" style="color: #0acf97; font-size: 16px; cursor: pointer;" title="Produto com saldo">{{ item.row.quantidade }}</span>
                                        </template>
                                    </template>
                                    <template slot="slot_precos" slot-scope="item">
                                        <div class="dv-lst-precos-produto">
                                            <ul class="list-group">
                                               <li v-for="(tabela, indexf) in item.row.tabelas"
                                                    :key="indexf" class="list-group-item d-flex justify-content-between align-items-center" :class="indexf % 2 == 0 ? 'bkg-smoke' : ''" style="padding: 2px;">
                                                    <span class="lbltabelalstpro">{{ tabela.desctabela }}</span>
                                                    <span class="d-flex align-items-center">
                                                        <span class="lbltabelalstpro font-weight-bolder" style="margin-left: 0!important; padding-left: 0 !important;">
                                                            {{ formatavalores(parseFloat(tabela.prtabela), '') }}
                                                        </span>
                                                        <i v-if="tabela.vldescpromocional > 0" class="fa fa-tags ml-1" :title="'Valor do produto com desconto: R$' + formatavalores(parseFloat(tabela.prtabela) - (parseFloat(tabela.prtabela) * parseFloat(tabela.vldescpromocional) / 100))">
                                                        </i>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                    <template slot="slot_validade" slot-scope="item" > 
                                           {{item.row.dtvalidade}}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <!-- BADGE REGISTRO -->
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstprodutos.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <!-- PAGINADOR -->
                            <div class="col-8 col-sm-8 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <!-- BUTTON OUTROS -->
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">                        
                                <div class="dropdown">
                                    <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Outras
                                    </button>                                   
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaclasses()"><i class="fa fa-leanpub"></i> Atribuir/Remover classes</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaclassesfiltros()"><i class="fa fa-leanpub fa-flip-horizontal"></i> Operar classes com filtros</a>
                                        <a  v-show="parseInt(produtosporfilial) === 1" class="dropdown-item" href="#" @click.prevent="mtddefinefiliaislista()"><i class="fa fa-bank "></i> Definir filiais aos produtos</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinatabela()"><i class="fa fa-dollar"></i> Atribuir Tabela</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinacampos()"><i class="fa fa-list"></i> Atribuir campos</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaarquivo()"><i class="fa fa-file"></i> Geração de arquivos</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaoperacoestabelas()"><i class="fa fa-exchange"></i> Operações com tabelas</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaconsultaprodutoscodigo()"><i class="fa fa-search"></i> Consultar por código</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaartcashbackmassa()"><i class="fa fa-diamond"></i> Atribuir Percental de cashback</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinadescontoqtdmin()"><i class="fa fa-minus-square"></i> Atribuir desconto qtd. mínima</a>
                                    </div>
                                </div>
                            </div>
                            <!-- BUTTON LISTAR -->
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <!-- TV PRODUTO -->
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvproduto">Produto</a>
                                    </li>
                                    <!-- TB CUSTO VENDA -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcustovenda">Custo/Venda</a>
                                    </li>
                                    <!-- TB FISCAL -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfiscal">Fiscal</a>
                                    </li>
                                    <!-- TB CODIGO LOCALIZADORES -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcodigoslocalizacoes">Códigos/Localizações/Similaridades</a>
                                    </li>
                                    <!-- TB OBSERVAÇÃO -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações/Detalhes</a>
                                    </li>
                                    <!-- TAB IMAGE -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvimagens">Imagens</a>
                                    </li>
                                    <!-- TAB PROPRIEDADES -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvpropriedades">Propriedades</a>
                                    </li>
                                    <!-- TAB FILIAIS -->
                                    <li class="nav-item" v-show="parseInt(produtosporfilial) === 1">
                                        <a class="nav-link" data-toggle="tab" href="#dvfiliais">Filiais</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvproduto" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edid">Código:</label>
                                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                                       maxlength="20" style="text-transform: uppercase;" disabled/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbstpro">Situação:</label>
                                                <select class="form-control form-control-sm" id="cbstpro" v-model="vstpro" v-bind:disabled="ativadesativa">
                                                    <option value="0">Inativo</option>
                                                    <option value="1">Ativo</option>
                                                </select>
                                            </div>
                                            <div v-if="parseInt(opcrud) > 1" class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtcadastro">Dt. Cadastro:</label>
                                                <input type="text" v-model="vdtcadastro" disabled
                                                       class="form-control form-control-sm" id="eddtcadastro" maxlength="20">
                                            </div>
                                            <template v-if="parseInt(vidultimavenda) > 0">
                                                <div v-if="parseInt(opcrud) > 1 && vdtultimavenda !== null" class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="eddtultimavenda">Ult. venda:</label>
                                                    <input type="text" v-model="vdtultimavenda" disabled
                                                        class="form-control form-control-sm" id="eddtultimavenda">
                                                    <div class="dropdown dp-impressao-pedido">
                                                        <i class="fa fa-print icon-imprimir-pedido dropdown-toggle" title="Imprimir pedido" data-toggle="dropdown"></i>
                                                        <div class="dropdown-menu">
                                                            <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(vidultimavenda, 0)">Padrão</a>
                                                            <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(vidultimavenda, 1)">Cupom</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="col-sm-12 col-md-2 col-lg-2 ml-auto" style="padding-top: 10px;">
                                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                    <input type="checkbox" class="custom-control-input" id="swenviaecommerce"
                                                    name="swenviaecommerce" v-model="vecommerce" v-bind:disabled="ativadesativa"
                                                    @change="mtdcalculaprvendamedio()">
                                                    <label class="custom-control-label" for="swenviaecommerce">Exibir no e-commerce</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="eddescricao">*Descrição:</label>
                                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edreferencia">Referência:</label>
                                                <input type="text" v-model="vreferencia" v-bind:disabled="ativadesativa"
                                                       class="form-control form-control-sm" id="edreferencia" maxlength="20">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbfracionado">Fracionado:</label>
                                                <select class="form-control form-control-sm" id="cbfracionado" v-model="vfracionado"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1" selected="true">Sim</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Unidade:</span>
                                                <select id="cbunidade" v-model="vund" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione uma unidade" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddiasvalidade">Validade:</label>
                                                <input type="text" v-model="vdiasvalidade" v-bind:disabled="ativadesativa"
                                                       class="form-control form-control-sm" id="eddiasvalidade" min="0">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbtipo">Tipo:</label>
                                                <select class="form-control form-control-sm" id="cbtipo" v-model="vtipo"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0" selected="true">Comercializado</option>
                                                    <option value="1">Consumo</option>
                                                    <option value="2">Ambos</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbserie">Controla seriais:</label>
                                                <select class="form-control form-control-sm" id="cbserie" v-model="vcontrolaserial"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0" selected="true">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Marca:</span>
                                                <select id="cbmarca" v-model="vidmarca" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione uma marca" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Grupo:</span>
                                                <select id="cbgrupo" v-model="vidgrupo" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um grupo" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Subgrupo:</span>
                                                <select id="cbsubgrupo" v-model="vidsubgrupo" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um subgrupo" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Setor:</span>
                                                <select id="cbsetorproduto" v-model="vidsetorproduto" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edestoqueminimo">Estoque mínimo:</label>
                                                <money type="text" class="form-control form-control-sm" id="edestoqueminimo" v-bind="quantidade"
                                                       v-model="vestoqueminimo" v-bind:disabled="ativadesativa" min="0"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edestoquemaximo">Estoque máximo:</label>
                                                <money type="text" class="form-control form-control-sm" id="edestoquemaximo" v-bind="quantidade"
                                                       v-model="vestoquemaximo" v-bind:disabled="ativadesativa" min="0"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edestoquemaximo">Comissão:</label>
                                                <money type="text" class="form-control form-control-sm" title="Esse campo pode representar o valor($) ou o percentual(%) de comissão, dependendo da configuração na consulta do relatorio de comissão por produto no modulo de relatorio. " id="edestoquemaximo" v-bind="quantidade"
                                                       v-model="vfatcomis" v-bind:disabled="ativadesativa" min="0"></money>
                                            </div>
                                            <div class="col-sm-4 col-md-4 col-lg-4">
                                                <label for="edespecificacoes">Especificações:</label>
                                                <input type="text" v-model="vespecificacao" v-bind:disabled="ativadesativa"
                                                        class="form-control form-control-sm" id="edespecificacoes" maxlength="200">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="card" style="margin-top: 15px;">
                                                    <div class="card-header card-in">ALERTA/DESTAQUES</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-4 col-lg-4" id="devdestfil">
                                                                <span class="lblselect2">Filial:</span>
                                                                <select id="cbfilialdestaque" v-model="vidfilialdestaque"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione uma filial"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div  class="col-sm-12 col-md-6 col-lg-6" id="dvdest">
                                                                <span class="lblselect2">Destaque:</span>
                                                                <select id="cbdestaque" v-model="viddestaque"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione um destaque"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div  class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btincluirdestaque" v-bind:disabled="ativadesativa"
                                                                        class="btn btn-info btn-sm" @click="mtdincluirdestaque()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;"><i
                                                                        class="fa fa-plus-circle"></i> Incluir
                                                                </button>
                                                            </div>
                                                            <div v-if="lstdestaquesprodutos.length > 0" class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistadestques" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th width="250">Filial:</th>
                                                                            <th width="100">Destaques:</th>
                                                                            <th width="50">Adesivo:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstlocalizacaopro">
                                                                            <tr v-for="(destaque, index) in lstdestaquesprodutos" v-bind:key="index">
                                                                                <td width="250px">{{ destaque.fantasia }}</td>
                                                                                <td width="100px">{{ destaque.descdestaque }}</td>

                                                                                <td width="50px"> <i :class = "destaque.adesivo + ' ' + destaque.cor" style="font-size: 20px;"></i></td>


                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="lstdestaquesprodutos.splice(index, 1)"><i class="fa fa-trash"></i>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div id="dvcustovenda" class="container-fluid tab-pane fade">
                                        <div class="card">
                                            <div class="card-header card-in">COMPOSIÇÃO DO CUSTO</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprcompra">Pr. Compra:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edprcompra"
                                                               v-model="vprcompra" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group"
                                                               style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edipi">IPI(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edipi" v-model="vpipi"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edicms">ICMS(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edicms" v-model="vpicms"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edfrete">Frete(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edfrete"
                                                               v-model="vpfrete" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edpis">PIS(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edpis" v-model="vppis"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edcofins">COFINS(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edcofins"
                                                               v-model="vpcofins" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edoutros">Outros(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edoutros"
                                                               v-model="vpoutros" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edbcst">BC(ST):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edbcst" v-model="vbcst"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="cbcalculasubstrib">Subs. tributária:</label>
                                                        <select class="form-control form-control-sm" id="cbcalculasubstrib"
                                                                v-model="vcalculasubstributaria" v-bind:disabled="ativadesativa"
                                                                data-toggle=".ttgeral"
                                                                title="Selecione a opção 'Sim' quando for para calcular a substituição tributária.">
                                                            <option value="0" selected="true">Não</option>
                                                            <option value="1">Sim</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edaliquotast">Aliq.(ST):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edaliquotast"
                                                               v-model="vpst" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edvlst">Vl.(ST):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edvlst" v-model="vvst"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprcusto">Pr.Custo:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edprcusto"
                                                               v-model="vprcusto" v-bind="money" disabled
                                                               data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 25px;">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="swcalcularprvendamedio"
                                                            name="swcalcularprvendamedio" v-model="vcalcularprvendamedio" v-bind:disabled="ativadesativa"
                                                            @change="mtdcalculaprvendamedio()">
                                                            <label class="custom-control-label" for="swcalcularprvendamedio">Informar Pr. Venda</label>
                                                        </div>
                                                    </div>
                                                    <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprvendamedio1">Pr. venda({{ vmargemprcusto }}%):</label>
                                                        <div class="input-group" style="z-index: 1;">
                                                            <money type="text" class="form-control form-control-sm" id="edprvendamedio1" title="Este preço é utilizado apenas para o cálculo do custo. O preços preços de venda a serem utilizados deverão ser informados na listagem abaixo!"
                                                                v-model="vprvendamedio" v-bind="money" v-bind:disabled="!vcalcularprvendamedio && !ativadesativa"
                                                                data-bv-group=".group" style="text-align:right; background: #b6c5b6; color:darkgreen; font-weight:bold;"
                                                                @blur.native="mtdcalculaprvendamedio()">
                                                            </money>
                                                            <div class="input-group-append" style="height: 31px;">
                                                                <button class="btn btn-primary" v-bind:disabled="!vcalcularprvendamedio" title="Informar a margem(%)" @click.prevent="mtddefinirmargemprvenda()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-percent"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprvendamedio2">Pr.Venda:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edprvendamedio2"
                                                               v-model="vprvendamedio" v-bind="money" v-bind:disabled="true"
                                                               data-bv-group=".group" style="text-align:right; background: #b6c5b6; color:darkgreen; font-weight:bold;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprvendaminimo">Pr.Mínimo:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edprvendaminimo"
                                                               v-model="vprvendaminimo" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right; font-weight:bold;">
                                                        </money>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card" style="margin-top: 15px;">
                                            <div class="card-header card-in">*COMPOSIÇÃO DE PREÇOS DE VENDA</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <template v-if="parseInt(voptabela) === 2">
                                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                                            <span class="lblselect2">Tabela:</span>
                                                            <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab"
                                                                    data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                                            </select>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                                            <span class="lblselect2">Tabela:</span>
                                                            <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab || vidtodastb"
                                                                    data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                                            </select>
                                                        </div>
                                                    </template>
                                                    <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 25px;" v-show="parseInt(voptabela) === 1">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="swselecionatodastb"
                                                            name="swselecionatodastb" v-model="vidtodastb" v-bind:disabled="ativadesativa"
                                                            @change="mtdselecionatodastbprvenda()">
                                                            <label class="custom-control-label" for="swselecionatodastb" title="A ação será aplicada em todas as tabelas!">Todas tabelas</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2" v-show="parseInt(voptabela) === 1 && vidtodastb">
                                                        <label for="cbtipoproduto">Atribuir por:</label>
                                                        <select class="form-control form-control-sm" id="cbtipoproduto" v-model="vtipoatribuicaotbpr"
                                                            v-bind:disabled="ativadesativa">
                                                            <option value="0">Margem em cima do custo</option>
                                                            <option value="1">Valor</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2" v-show="!vidtodastb || (vidtodastb && vtipoatribuicaotbpr == 0)">
                                                        <label for="edmrgtabela">Mrg(%): <i class="fa fa-info-circle" v-show="vidtodastb" data-toggle="tooltip" data-placement="right" title="Será usada a margem correspondente ao cadastro de cada tabela "></i></label>
                                                        <money type="text" class="form-control form-control-sm" id="edmrgtabela"
                                                               v-model="vmrgtabela" v-bind="money" v-bind:disabled="ativadesativa || vidtodastb"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2" v-show="!vidtodastb || (vidtodastb && vtipoatribuicaotbpr == 1)">
                                                        <label for="edvltabela">Valor:</label>
                                                        <div class="input-group" style="z-index: 1;">
                                                            <money type="text" class="form-control form-control-sm" id="edvltabela"
                                                                v-model="vvltabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                                data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                            </money>
                                                            <div class="input-group-append" style="height: 31px;">
                                                                <button class="btn btn-primary" title="Visualizar imposto sobre valor" @click.prevent="mtdvisualizarimpostovalor()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edcomissaotabela">Comissão(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edcomissaotabela"
                                                               v-model="vcomissaotabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="eddescontotabela">Qtd. Mínima:</label>
                                                        <money type="text" class="form-control form-control-sm" id="eddescontotabela"
                                                               v-model="vqtdmintabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edqtdmintabelamin">Desc. Qtd. Min. ($):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edqtdmintabelamin"
                                                               v-model="vdescontotabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edvldescpromocional">Desc. promocional(%):</label>
                                                        <div class="input-group" style="z-index: 1;">
                                                            <money type="text" class="form-control form-control-sm" id="edvldescpromocional"
                                                                v-model="vvldescpromocional" v-bind="money" v-bind:disabled="ativadesativa"
                                                                data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                            </money>
                                                            <div class="input-group-append" style="height: 31px;">
                                                                <button class="btn btn-primary" title="Informar o valor para calcular o percentual" @click.prevent="mtdinformarvalordescpromocional()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edqtdmintabela">Pr. auxiliar($):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edqtdmintabela" title="Este preço é utilizado apenas para definir o valor de tabela para visualização na impressão/catalogo de produtos"
                                                               v-model="vvlvizu" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <button v-if="parseInt(voptabela) === 1" type="button" id="btinctabela" class="btn btn-info btn-sm"
                                                                @click.prevent="mtdgravartabela()" v-bind:disabled="ativadesativa"
                                                                style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>
                                                            Incluir
                                                        </button>
                                                        <button v-else type="button" id="btalttabela" class="btn btn-secondary btn-sm"
                                                                @click.prevent="mtdgravartabela()" v-bind:disabled="ativadesativa"
                                                                style="width:100%; margin-top: 21px;"><i class="fa fa-check"></i>
                                                            Salvar
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <button v-if="parseInt(voptabela) === 2" type="button" id="btcancelartabela" class="btn btn-secondary btn-sm"
                                                                @click.prevent="mtdcancelartabela()"
                                                                style="width:100%; margin-top: 21px;"><i class="fa fa-undo"></i>
                                                            Cancelar
                                                        </button>
                                                    </div>
                                                    <div v-if="lstTabelasPrecos.length > 0" class="col-lg-12">
                                                        <div class="table-responsive">
                                                            <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                <thead class="thead-light">
                                                                <tr>
                                                                    <th width="280">Tabela:</th>
                                                                    <th width="100">Valor:</th>
                                                                    <th width="100">Mrg(%):</th>
                                                                    <th width="100">Com.(%):</th>
                                                                    <th width="100">Qtd. Min.:</th>
                                                                    <th width="100">Pr. aux. ($):</th>
                                                                    <th width="100">Desc. Qtd. ($):</th>
                                                                    <th width="100">Desc. Promocional:</th>
                                                                    <th width="35px" style="text-align: center;">Exc:</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody id="lsttabelaspro">
                                                                    <tr v-for="(tabela, index) in lstTabelasPrecos" v-bind:key="index">
                                                                        <td width="150px">{{ tabela.desctabela }}</td>
                                                                        <td width="100px" style="text-align: right; font-weight: bold;">{{
                                                                            formatavalores(tabela.prtabela) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.mrglucro) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.pcomissao) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.qtdminima) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.vlvisualiza) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.desconto) }}
                                                                        </td>
                                                                        <td v-if="parseFloat(tabela.vldescpromocional) > 0" width="120px" style="text-align: right; color: #0acf97; font-weight: bold;">
                                                                            {{ formatavalores(tabela.vldescpromocional) }}% (${{ formatavalores(parseFloat(tabela.prtabela) - (tabela.prtabela * parseFloat(tabela.vldescpromocional) / 100)) }})
                                                                        </td>
                                                                        <td v-else width="120px">
                                                                        </td>
                                                                        <td width="80px" class="center" style="text-align: center;">
                                                                            <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtdalterartabela(tabela)"><i class="fa fa-edit"></i></a>
                                                                            <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtddeletatabela(index)"><i class="fa fa-trash"></i></a>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div class="col-12" v-if="lstTabelasPrecos.length > 0" style="display: flex; justify-content: end;">
                                                        <button class="btn btn-danger btn-sm" href="#"
                                                        @click.prevent="mtddeletatabela(0, 1)">Remover todas <i class="fa fa-trash"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card" style="margin-top: 10px;">
                                            <div class="card-header card-in">CRÉDITO ACUMULATIVO(CASH BACK)</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edvlcreditoacumulaavista">À vista:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edvlcreditoacumulaavista"
                                                               v-model="vvlcreditoacumulaavista" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edvlcreditoacumulaaprazo">À prazo:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edvlcreditoacumulaaprazo" v-model="vvlcreditoacumulaaprazo"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;"></money>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvfiscal" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-3">
                                                <span class="lblselect2">*NCM({{vidncm}}):</span>
                                                <select id="cbncm" data-placeholder="Selecione uma opção" v-model="vidncm"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-3">
                                                <span class="lblselect2">CEST({{vidcest}}):</span>
                                                <select id="cbcest" data-placeholder="Selecione uma opção" v-model="vidcest"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-3">
                                                <span class="lblselect2">St(Entrada):</span>
                                                <select id="cbsituacaotributaria" data-placeholder="Selecione uma opção" v-model="vidsituacaotributaria"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                           
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="cbtipoproduto">Tipo de produto:</label>
                                                <select class="form-control form-control-sm" id="cbtipoproduto" v-model="vtipoproduto"
                                                    v-bind:disabled="ativadesativa">
                                                    <option value="0">00 - MERCADORIA PARA REVENDA</option>
                                                    <option value="1">01 - MATERIA-PRIMA</option>
                                                    <option value="2">02 - EMBALAGEM</option>
                                                    <option value="3">03 - PRODUTO EM PROCESSO</option>
                                                    <option value="4">04 - PRODUTO ACABADO</option>
                                                    <option value="5">05 - SUBPRODUTO</option>
                                                    <option value="6">06 - PRODUTO INTERMEDIARIO</option>
                                                    <option value="7">07 - MATERIAL DE USO E CONSUMO</option>
                                                    <option value="8">08 - ATIVO IMOBILIZADO</option>
                                                    <option value="9">09 - SERVICOS</option>
                                                    <option value="10">10 - OUTROS INSUMOS</option>
                                                    <option value="99">99 - OUTRAS</option>
                                                </select>
                                            </div>         
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="cborigemproduto">Origem:</label>
                                                <select class="form-control form-control-sm" id="cborigemproduto"
                                                    v-model="vorigemproduto" v-bind:disabled="ativadesativa">
                                                    <option value="0">0 - NACIONAL, EXCETO AS INDICADAS NOS CODIGOS 3 A 5</option>
                                                    <option value="1">1 - ESTRANGEIRA - IMPORTACAO DIRETA, EXCETO A INDICADA NO
                                                        CODIGO 6
                                                    </option>
                                                    <option value="2">2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A
                                                        INDICADA NO CODIGO 7
                                                    </option>
                                                    <option value="3">3 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                                        SUPERIOR A 40% (QUARENTA POR CENTO)
                                                    </option>
                                                    <option value="4">4 - NACIONAL, CUJA PRODUCAO TENHA SIDO FEITA EM CONFORMIDADE
                                                        COM OS PROCESSOS PRODUTIVOS BASICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67 E
                                                        AS LEIS N°S 8.248/91, 8.387/91,10.176/01 e 11.484/07
                                                    </option>
                                                    <option value="5">5 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                                        INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)
                                                    </option>
                                                    <option value="6">6 - ESTRANGEIRA - IMPORTACAO DIRETA, SEM SIMILAR NACIONAL,
                                                        CONSTANTE EM LISTA DE RESOLUCAO CAMEX
                                                    </option>
                                                    <option value="7">7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR
                                                        NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX"
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-1">
                                                <label for="utrib" class="label">Und.Trib:</label>
                                                <input id="utrib" class="form-control form-control-sm" v-model="utrib" 
                                                    v-bind:disabled="ativadesativa" type="text" maxlength="2" style="text-transform: uppercase; background: beige;" title="Usar somente para casos específicos">
                                            </div>
                                            <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label for="qtrib">Qtd.Tributaria</label>
                                                <money type="text" class="form-control form-control-sm" id="qtrib" v-model="qtrib"
                                                    v-bind="money" v-bind:disabled="ativadesativa"
                                                    data-bv-group=".group" title="Usar somente para casos específicos"
                                                    style="background: beige;">
                                                </money>
                                            </div> 

                                             <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label for="cbcbenef" class="label">cBenef:</label>
                                                <input id="cbcbenef" class="form-control form-control-sm" v-model="vcbenef" 
                                                    v-bind:disabled="ativadesativa" type="text">
                                            </div>  
                                            
                                            <div :class="parseInt(vprodescala) === 1 ? 'col-sm-12 col-md-2 col-lg-2' : 'col-sm-12 col-md-4 col-lg-4'">
                                                <label for="cbprodescala">Produzido em escala:</label>
                                                <select class="form-control form-control-sm" id="cbprodescala"
                                                    v-model="vprodescala" v-bind:disabled="ativadesativa" >
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>

                                            <div v-show="parseInt(vprodescala) === 1" class="col-12 col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcnpjfab">CNPJ fabricante:</label>
                                                <input id="edcnpjfab" type="text" v-mask="'##.###.###/####-##'" class="form-control form-control-sm" v-model="vcnpjfabricante" v-bind:disabled="ativadesativa">
                                            </div> 



                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbprodutoespecifico">Produto específico:</label>
                                                <select class="form-control form-control-sm" id="cbprodutoespecifico"
                                                    v-model="vprodutoespecifico" v-bind:disabled="ativadesativa" @change.prevent="mtdlimpaespecifico()">
                                                    <option value="0"></option>
                                                    <option value="1">Veículo</option>
                                                    <option value="2">Medicamento</option>
                                                    <option value="3">Armamento</option>
                                                    <option value="4">Combustível</option>
                                                    <option value="5">Papel Imune</option>
                                                </select>
                                            </div>
                                            <div v-show="parseInt(this.vprodutoespecifico) === 4" class="col-sm-12 col-md-3 col-lg-4" style="margin-top: 10px;">
                                                <span class="lblselect2">*ANP({{vidanp}}):</span>
                                                <select id="cbanp" data-placeholder="Selecione uma opção" v-model="vidanp"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div v-show="parseInt(this.vprodutoespecifico) === 4" class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="percglp">Perc.GLP(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="percglp"
                                                        v-model="vpercglp" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div v-show="parseInt(this.vprodutoespecifico) === 4" class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="edpercgnn">Perc.GNn(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="edpercgnn"
                                                        v-model="vpercgnn" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div v-show="parseInt(this.vprodutoespecifico) === 4" class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="edpercgni">Perc.GNi(%):</label>
                                                <money type="text" class="form-control form-control-sm" id="edpercgni"
                                                        v-model="vpercgni" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div v-show="parseInt(this.vprodutoespecifico) === 4" class="col-sm-12 col-md-2 col-lg-2" style="margin-top: 10px;">
                                                <label for="edvlpartida">Valor Partida:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvlpartida"
                                                        v-model="vvlpartida" v-bind="money" v-bind:disabled="ativadesativa"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-md-12" style="margin-top: 15px;">
                                                <div class="card">
                                                    <div class="card-header card-in">CLASSES DE IMPOSTOS</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-5 col-lg-5" id="dvfilialclasse">
                                                                <span class="lblselect2">Filial:</span>
                                                                <select id="cbfilialclasse" data-placeholder="Selecione uma opção"
                                                                    v-model="vidfilialclasse" v-bind:disabled="ativadesativa"
                                                                    data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-5 col-lg-5" id="dvclasse">
                                                                <span class="lblselect2">Classe:</span>
                                                                <select id="cbclasse" data-placeholder="Selecione uma opção"
                                                                    v-model="vidclasse" v-bind:disabled="ativadesativa"
                                                                    data-allow-clear="true" style="width:100%;" :disabled="!vidfilialclasse">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btincclasse" class="btn btn-info btn-sm"
                                                                    v-bind:disabled="ativadesativa"
                                                                    style="width:100%; margin-top: 22px;" @click.prevent="mtdincluirclasse()"><i class="fa fa-plus-circle"></i>
                                                                    Incluir
                                                                </button>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistaclasses" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th width="300">Filial:</th>
                                                                                <th width="300">Classe:</th>
                                                                                <th width="35px" style="text-align: center;">Exc:</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody id="lstclassespro">
                                                                            <tr v-for="(classe, index) in lstClassesProduto" v-bind:key="index">
                                                                                <td width="300px">{{ classe.fantasia }}</td>
                                                                                <td width="300px">{{ classe.descclasse }}</td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtdexcluirclasse(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvcodigoslocalizacoes" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="card">
                                                    <div class="card-header card-in">CÓDIGOS</div>
                                                    <div class="card-body" style="height: 226px;">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                                <label for="edcodigoadd">Código:</label>
                                                                <input type="text" class="form-control form-control-sm" id="edcodigoadd"
                                                                    v-model="vcodigoinc" v-bind:disabled="ativadesativa"
                                                                    data-bv-group=".group" style="text-transform: uppercase;">
                                                            </div>
                                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                                <button type="button" id="btinccodigo" class="btn btn-info btn-sm"
                                                                        v-bind:disabled="ativadesativa" @click.prevent="mtdinccodigo()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;">
                                                                    <i class="fa fa-plus-circle"></i> Incluir</button>
                                                            </div>
                                                            <div v-if="lstCodigos.length > 0" class="col-lg-12" style="height: 123px; overflow-y: auto;">
                                                                <div class="table-responsive">
                                                                    <table id="tblistacodigospro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th>Código:</th>
                                                                            <th width="35px" style="text-align: center;">E.P:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstcodigospro">
                                                                            <tr v-for="(codigo, index) in lstCodigos" v-bind:key="index">
                                                                                <td>{{ codigo.codigo }}</td>
                                                                                <td v-if="parseInt(codigo.padraoetiqueta) === 0" style="cursor: pointer; text-align: center;" @click.prevent="mtddefinecodigoetqpadrao(codigo.codigo, 1, index)"></td>
                                                                                <td v-else style="cursor: pointer; text-align: center; font-size: 20px; color: #17a2b8;" title="Código padrão para emissão das etiquetas" @click.prevent="mtddefinecodigoetqpadrao(codigo.codigo, 0, index)"><i class="fa fa-tags"></i></td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtddelcodigo(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="card">
                                                    <div class="card-header card-in">SIMILARIDADES POR REFERÊNCIA</div>
                                                    <div class="card-body" style="height: 226px;">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                                <label for="edreferenciasimilar">Referência:</label>
                                                                <input type="text" class="form-control form-control-sm" id="edreferenciasimilar"
                                                                    v-model="vreferenciasimilarinc" v-bind:disabled="ativadesativa"
                                                                    data-bv-group=".group" style="text-transform: uppercase;">
                                                            </div>
                                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                                <button type="button" id="btincreferencia" class="btn btn-info btn-sm"
                                                                        v-bind:disabled="ativadesativa" @click.prevent="mtdincreferenciasimilar()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;">
                                                                    <i class="fa fa-plus-circle"></i> Incluir</button>
                                                            </div>
                                                            <div v-if="lstsimilaridades.length > 0" class="col-lg-12" style="height: 123px; overflow-y: auto;">
                                                                <div class="table-responsive">
                                                                    <table id="tblistasimilaridades" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th>Referência:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstsimilaridades">
                                                                            <tr v-for="(referencia, index) in lstsimilaridades" v-bind:key="index">
                                                                                <td>{{ referencia.referencia }}</td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtddelreferenciasimilar(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card" style="margin-top: 15px;">
                                                    <div class="card-header card-in">LOCALIZAÇÕES</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-3 col-lg-3" id="dvfiliallocalizacao">
                                                                <span class="lblselect2">Filial:</span>
                                                                <select id="cbfiliallocalizacao" v-model="vidfiliallocalizacao"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione uma filial"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2" id="dvestoquelocalizacao">
                                                                <span class="lblselect2">Estoque:</span>
                                                                <select id="cbestoquelocalizacao" v-model="videstoquelocalizacao"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione um estoque"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>                                                            
                                                            <div v-show="vnovalocalizacao" class="col-sm-12 col-md-3 col-lg-3">
                                                                <label for="eddescricaolocalizacao">Localização:</label>
                                                                <div class="input-group" style="z-index: 1;">
                                                                <input type="text" class="form-control form-control-sm" id="eddescricaolocalizacao"
                                                                    v-model="vdescricaolocalizacao" v-bind:disabled="ativadesativa"
                                                                    data-bv-group=".group" style="text-transform: uppercase;" maxlength="50">
                                                                    <div class="input-group-append">
                                                                        <a href="#" class="btn btn-primary btn-sm btn-grp" role="button" @click.prevent="mtdconfirmarnovalocalizacao()" style="border-radius: 0px 0px 0px 0px!important;" title="Confirmar"><i class="fa fa-check" style="padding-top: 3px;"></i></a>
                                                                        <a href="#" class="btn btn-secondary btn-sm btn-grp" role="button" @click.prevent="mtdcancelarnovalocalizacao()" style="border-radius: 0px 4px 4px 0px!important;" title="Cancelar"><i class="fa fa-close" style="padding-top: 3px;"></i></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-show="!vnovalocalizacao" class="col-sm-12 col-md-2 col-lg-2" id="dvlocalizacao">
                                                                <span class="lblselect2">Localização:</span>
                                                                <select id="cblocalizacao" v-model="vidlocalizacao"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione uma localização"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div v-show="!vnovalocalizacao" class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btinclocalizacao" v-bind:disabled="ativadesativa"
                                                                        class="btn btn-info btn-sm" @click="mtdinclocalizacao()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;"><i
                                                                        class="fa fa-plus-circle"></i> Incluir
                                                                </button>
                                                            </div>
                                                            <div v-show="!vnovalocalizacao" class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btnovalocalizacao" v-bind:disabled="ativadesativa"
                                                                        class="btn btn-secondary btn-sm" @click="mtdnovalocalizacao()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;"><i
                                                                        class="fa fa-file"></i> Nova Localização
                                                                </button>
                                                            </div>
                                                            <div v-if="lstLocalizacaoProduto.length > 0" class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistaestoque" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th width="200">Filial:</th>
                                                                            <th width="100">Estoque:</th>
                                                                            <th width="100">Localização:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstlocalizacaopro">
                                                                            <tr v-for="(localizacao, index) in lstLocalizacaoProduto" v-bind:key="index">
                                                                                <td width="200px">{{ localizacao.fantasia }}</td>
                                                                                <td width="100px">{{ localizacao.descestoque }}</td>
                                                                                <td width="100px">{{ localizacao.desclocalizacao }}</td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtddeletarlocalizacao(index)"><i class="fa fa-trash"></i>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvobservacoes" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="8" id="txtobs" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvimagens" class="container-fluid tab-pane fade">
                                        <div class="row mb-3">
                                            <div class="col-md-12">
                                                <!-- vmodel pode ser usado para preview da img -->
                                                <cmpselecionarimagem 
                                                    v-model="imgprodutocmp" 
                                                    :accepted-formats="['jpg', 'jpeg', 'png', 'webp']"
                                                    :disabled="ativadesativa"
                                                    :cropper-ratios="['1:1']"
                                                    :compression-options="{
                                                        maxSizeMB: 1,
                                                        maxWidthOrHeight: 1000,
                                                        useWebWorker: true,
                                                        initialQuality: 0.7
                                                    }"
                                                    @file-selected="mtdselecionarimagem"
                                                />
                                            </div>
                                        </div>
                                        <div class="row" style="padding: 0px 15px 0px 15px;">
                                            <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                                <div v-if="lstImagens.length > 0" class="row">
                                                    <div v-for="(imagem, index) in lstImagens" v-bind:key="index" style="margin-inline: 10px; margin-bottom: 15px; position: relative;">
                                                        <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgproduto" @click.prevent="mtdexcluirimgproduto(imagem.patharquivo)"><i class="fa fa-trash"></i></button>
                                                        <img class="img-thumbnail img-produto" v-bind:src="pathimgview+imagem.patharquivo">
                                                    </div>
                                                </div>
                                                <div v-else class="row">
                                                    <div class="col-md-12 text-center">
                                                        <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div v-if="parseInt(opcrud) < 3" class="col-md-12 text-center" style="margin-top: 15px;">
                                                <input
                                                    type="file"
                                                    id="ipselecionarimg"
                                                    accept="image/png, image/jpeg"
                                                    @change="mtdselecionarimagem"
                                                    style="display: none;"
                                                    ref="if_imgproduto">
                                                <button type="button" @click="$refs.if_imgproduto.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar imagem</button>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div id="dvpropriedades" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">Unidade maior:</span>
                                                <select id="edmaioruni" v-model="vunimaior" v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione uma unidade" data-allow-clear="true"  style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbfatorconver">Fator conversão:</label>
                                                <money type="text" class="form-control form-control-sm"
                                                v-model="vfatorconver" v-bind:disabled="ativadesativa" min="0"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edestoquemaximo">Data de validade:</label>
                                                <div class="input-group">
                                                    <date-picker id="dtini" v-model="vdtvalidade" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options"></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>								
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" >
                                            <div class="col-md-12">
                                                <div class="card" style="margin-top: 15px;">
                                                    <div class="card-header card-in">DIMENSÕES</div>
                                                    <div class="card-body">
                                                        <div class="row" >
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edestoquemaximo">Altura(M):</label>
                                                                <money type="text" class="form-control form-control-sm" title="Esse valor representa em metros(m) a altura desse produto."
                                                                       v-model="valtura" v-bind="moneyD" v-bind:disabled="ativadesativa" min="0"></money>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edestoquemaximo">Largura(M):</label>
                                                                <money type="text" class="form-control form-control-sm" title="Esse valor representa em metros(m) a largura desse produto."
                                                                       v-model="vlargura" v-bind="moneyD" v-bind:disabled="ativadesativa" min="0"></money>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edestoquemaximo">Profundidade(M):</label>
                                                                <money type="text" class="form-control form-control-sm" title="Esse valor representa em metros(m) a profundidade desse produto."
                                                                       v-model="vprofundidade" v-bind="moneyD" v-bind:disabled="ativadesativa" min="0"></money>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edestoquemaximo">Peso(Kg):</label>
                                                                <money type="text" class="form-control form-control-sm" title="Esse valor representa em quilograma(kg) o peso desse produto."
                                                                       v-model="vpeso" v-bind="moneyD" v-bind:disabled="ativadesativa" min="0"></money>
                                                            </div>
                                                            <!-- <div class="col-sm-12 col-md-6 col-lg-4">
                                                                <label for="edestoquemaximo">Diametro(M):</label>
                                                                <money type="text" class="form-control form-control-sm" title="Esse valor representa em metros(m) o diametro do produto."
                                                                    v-model="vdiametro" v-bind:disabled="ativadesativa" min="0"></money>
                                                            </div> -->
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <label for="edformato" class="form-label d-block mb-2">Embalagem p/ frete:</label>
                                                                <div class="d-flex justify-content-center gap-3">
                                                                    <!-- Caixa -->
                                                                    <button 
                                                                        class="btn p-2 border-0 bg-transparent formato-btn caixa-btn"
                                                                        :class="{ active: tpObjeto === '2' }"
                                                                        @click="DefineTpObjeto('2')">
                                                                        <span class="formato-icon" style="height: 100px; display: block;"></span>
                                                                    </button>
                                                                    <!-- Envelope -->
                                                                    <button 
                                                                        class="btn p-2 border-0 bg-transparent formato-btn envelope-btn"
                                                                        :class="{ active: tpObjeto === '1' }"
                                                                        @click="DefineTpObjeto('1')">
                                                                        <span class="formato-icon" style="height: 100px; display: block;"></span>
                                                                    </button>
                                                                    <!-- rolo -->
                                                                    <!-- <button 
                                                                        class="btn p-2 border-0 bg-transparent formato-btn rolo-btn"
                                                                        :class="{ active: tpObjeto === '3' }"
                                                                        @click="DefineTpObjeto('3')">
                                                                        <span class="formato-icon" style="height: 100px; display: block;"></span>
                                                                    </button> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- container da variação vai aqui -->
                                         <div class="row" id="id-variacoes">
                                            <!-- Bloco de Variações -->
                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <div class="card" style="margin-top: 15px;">
                                                    <div class="card-header card-in">VARIAÇÕES</div>
                                                    <div class="card-body">
                                                        <div class="mb-3 d-flex">
                                                            <button 
                                                                type="button" 
                                                                class="btn btn-success btn-sm ml-auto" 
                                                                @click.prevent="mtdadicionarvariacao()">
                                                                <i class="fa fa-plus"></i> Adicionar Variação
                                                            </button>
                                                        </div>
                                                        <div class="table-responsive2">
                                                            <table class="table table-bordered table-sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Produto</th>
                                                                        <th width="120px">Cor</th>
                                                                        <th width="150px">Tamanho</th>
                                                                        <th width="100px" style="text-align: center;">Opções</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <!-- Primeira linha sempre visível - Produto Atual -->
                                                                    <tr>
                                                                        <td style="width: auto; display: flex; align-items: center; height: 48px;">
                                                                            <div class="cont-tooltip-var-cor">
                                                                                <div class="d-flex align-items-center">
                                                                                    <i class="fa fa-star text-warning mr-2" title="Produto atual"></i>
                                                                                    <strong class="text-primary">PRODUTO ATUAL</strong>
                                                                                    <span v-if="vid" class="ml-2 text-muted">(ID: {{ vid }})</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <select class="form-control form-control-sm" v-model="produtoAtualCor">
                                                                                <option value="">Selecione uma cor...</option>
                                                                                <option value="BRANCO" style="background-color: #FFFFFF; color: #000;">BRANCO</option>
                                                                                <option value="PRETO" style="background-color: #000000; color: #FFF;">PRETO</option>
                                                                                <option value="CINZA" style="background-color: #808080; color: #FFF;">CINZA</option>
                                                                                <option value="CINZA CLARO" style="background-color: #D3D3D3; color: #000;">CINZA CLARO</option>
                                                                                <option value="CINZA ESCURO" style="background-color: #696969; color: #FFF;">CINZA ESCURO</option>
                                                                                <option value="VERMELHO" style="background-color: #FF0000; color: #FFF;">VERMELHO</option>
                                                                                <option value="VERMELHO ESCURO" style="background-color: #8B0000; color: #FFF;">VERMELHO ESCURO</option>
                                                                                <option value="ROSA" style="background-color: #FFC0CB; color: #000;">ROSA</option>
                                                                                <option value="ROSA PINK" style="background-color: #FF1493; color: #FFF;">ROSA PINK</option>
                                                                                <option value="AZUL" style="background-color: #0000FF; color: #FFF;">AZUL</option>
                                                                                <option value="AZUL CLARO" style="background-color: #87CEEB; color: #000;">AZUL CLARO</option>
                                                                                <option value="AZUL ESCURO" style="background-color: #00008B; color: #FFF;">AZUL ESCURO</option>
                                                                                <option value="AZUL MARINHO" style="background-color: #000080; color: #FFF;">AZUL MARINHO</option>
                                                                                <option value="VERDE" style="background-color: #008000; color: #FFF;">VERDE</option>
                                                                                <option value="VERDE CLARO" style="background-color: #90EE90; color: #000;">VERDE CLARO</option>
                                                                                <option value="VERDE ESCURO" style="background-color: #006400; color: #FFF;">VERDE ESCURO</option>
                                                                                <option value="VERDE MILITAR" style="background-color: #556B2F; color: #FFF;">VERDE MILITAR</option>
                                                                                <option value="AMARELO" style="background-color: #FFFF00; color: #000;">AMARELO</option>
                                                                                <option value="AMARELO OURO" style="background-color: #FFD700; color: #000;">AMARELO OURO</option>
                                                                                <option value="LARANJA" style="background-color: #FFA500; color: #000;">LARANJA</option>
                                                                                <option value="LARANJA ESCURO" style="background-color: #FF8C00; color: #FFF;">LARANJA ESCURO</option>
                                                                                <option value="ROXO" style="background-color: #800080; color: #FFF;">ROXO</option>
                                                                                <option value="LILÁS" style="background-color: #DDA0DD; color: #000;">LILÁS</option>
                                                                                <option value="VIOLETA" style="background-color: #8A2BE2; color: #FFF;">VIOLETA</option>
                                                                                <option value="MARROM" style="background-color: #8B4513; color: #FFF;">MARROM</option>
                                                                                <option value="MARROM CLARO" style="background-color: #D2B48C; color: #000;">MARROM CLARO</option>
                                                                                <option value="BEGE" style="background-color: #F5F5DC; color: #000;">BEGE</option>
                                                                                <option value="CREME" style="background-color: #FFFDD0; color: #000;">CREME</option>
                                                                                <option value="NUDE" style="background-color: #E3C9A2; color: #000;">NUDE</option>
                                                                                <option value="PRATA" style="background-color: #C0C0C0; color: #000;">PRATA</option>
                                                                                <option value="DOURADO" style="background-color: #FFD700; color: #000;">DOURADO</option>
                                                                                <option value="BRONZE" style="background-color: #CD7F32; color: #FFF;">BRONZE</option>
                                                                                <option value="TURQUESA" style="background-color: #40E0D0; color: #000;">TURQUESA</option>
                                                                                <option value="CIANO" style="background-color: #00FFFF; color: #000;">CIANO</option>
                                                                                <option value="MAGENTA" style="background-color: #FF00FF; color: #FFF;">MAGENTA</option>
                                                                                <option value="CORAL" style="background-color: #FF7F50; color: #000;">CORAL</option>
                                                                                <option value="SALMÃO" style="background-color: #FA8072; color: #000;">SALMÃO</option>
                                                                                <option value="VINHO" style="background-color: #722F37; color: #FFF;">VINHO</option>
                                                                                <option value="BORDÔ" style="background-color: #800020; color: #FFF;">BORDÔ</option>
                                                                                <option value="MOSTARDA" style="background-color: #FFDB58; color: #000;">MOSTARDA</option>
                                                                                <option value="OLIVA" style="background-color: #808000; color: #FFF;">OLIVA</option>
                                                                                <option value="MULTICOLORIDO" style="background: linear-gradient(45deg, #ff0000, #ff8000, #ffff00, #80ff00, #00ff00, #00ff80, #00ffff, #0080ff, #0000ff, #8000ff, #ff00ff, #ff0080); color: #FFF;">MULTICOLORIDO</option>
                                                                                <option value="ESTAMPADO" style="background-color: #F0F0F0; color: #000;">ESTAMPADO</option>
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select class="form-control form-control-sm" v-model="produtoAtualTamanho">
                                                                                <option value="">Selecione...</option>
                                                                                <option value="PP">PP</option>
                                                                                <option value="P">P</option>
                                                                                <option value="M">M</option>
                                                                                <option value="G">G</option>
                                                                                <option value="GG">GG</option>
                                                                                <option value="XG">XG</option>
                                                                                <option value="XXG">XXG</option>
                                                                                <option value="34">34</option>
                                                                                <option value="36">36</option>
                                                                                <option value="38">38</option>
                                                                                <option value="40">40</option>
                                                                                <option value="42">42</option>
                                                                                <option value="44">44</option>
                                                                                <option value="46">46</option>
                                                                                <option value="48">48</option>
                                                                                <option value="50">50</option>
                                                                                <option value="ÚNICO">TAMANHO ÚNICO</option>
                                                                            </select>
                                                                        </td>
                                                                        <td style="text-align: center;">
                                                                            <span class="text-muted" title="Produto atual não pode ser excluído">
                                                                                <i class="fa fa-lock"></i>
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <!-- Variações adicionais -->
                                                                    <tr v-for="(variacao, index) in variacoesProduto" :key="'variacao-' + index">
                                                                        <td style="padding: 8px; position: relative;">
                                                                            <!-- Produtos de variação -->
                                                                            <template v-if="loadervariacaoproduto">
                                                                                <div style="margin-inline: auto" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                                                                            </template>
                                                                            <template v-else>
                                                                                <div v-if="variacao.produto && variacao.produto.id" 
                                                                                     class="produto-variacao-linha"
                                                                                     @mouseover="$set(variacao, 'showTooltip', true)" 
                                                                                     @mouseleave="$set(variacao, 'showTooltip', false)"
                                                                                     @click.prevent="mtdconsultarprodutovariacoes(index)"
                                                                                     style="cursor: pointer; position: relative;">
                                                                                    
                                                                                    <!-- Tooltip com imagem ampliada -->
                                                                                    <transition name="fade">
                                                                                        <div v-show="variacao.showTooltip" class="tooltip-variacao-imagem">
                                                                                            <img v-if="variacao.produto.imagens && variacao.produto.imagens[0]"
                                                                                                 :src="'https://'+$store.state.usuario.adrsrv+'/'+variacao.produto.imagens[0].patharquivo" 
                                                                                                 alt="Imagem do produto">
                                                                                            <div v-else class="sem-imagem">
                                                                                                <i class="fa fa-image" style="font-size: 40px; color: #ccc;"></i>
                                                                                                <p>Sem imagem</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </transition>
                                                                                    
                                                                                    <!-- Miniatura + ID + Descrição na mesma linha -->
                                                                                    <div class="produto-linha-completa">
                                                                                        <!-- Miniatura -->
                                                                                        <div class="miniatura-produto">
                                                                                            <img v-if="variacao.produto.imagens && variacao.produto.imagens[0]"
                                                                                                 :src="'https://'+$store.state.usuario.adrsrv+'/'+variacao.produto.imagens[0].patharquivo" 
                                                                                                 alt="Miniatura"
                                                                                                 class="img-miniatura">
                                                                                            <div v-else class="sem-miniatura">
                                                                                                <i class="fa fa-image"></i>
                                                                                            </div>
                                                                                        </div>
                                                                                        
                                                                                        <!-- ID - Descrição -->
                                                                                        <div class="info-produto">
                                                                                            <span class="produto-id-inline">{{ variacao.produto.id }}</span>
                                                                                            <span class="separador"> - </span>
                                                                                            <span class="produto-desc-inline">{{ variacao.produto.descricao }}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-else style="text-align: center;">
                                                                                    <button type="button" 
                                                                                            class="btn btn-info btn-sm" 
                                                                                            @click.prevent="mtdconsultarprodutovariacoes(index)">
                                                                                        <i class="fa fa-search"></i> Selecionar Produto
                                                                                    </button>
                                                                                </div>
                                                                            </template>
                                                                        </td>
                                                                        <td>
                                                                            <select class="form-control form-control-sm" v-model="variacao.cor">
                                                                                <option value="">Selecione uma cor...</option>
                                                                                <option value="BRANCO" style="background-color: #FFFFFF; color: #000;">BRANCO</option>
                                                                                <option value="PRETO" style="background-color: #000000; color: #FFF;">PRETO</option>
                                                                                <option value="CINZA" style="background-color: #808080; color: #FFF;">CINZA</option>
                                                                                <option value="CINZA CLARO" style="background-color: #D3D3D3; color: #000;">CINZA CLARO</option>
                                                                                <option value="CINZA ESCURO" style="background-color: #696969; color: #FFF;">CINZA ESCURO</option>
                                                                                <option value="VERMELHO" style="background-color: #FF0000; color: #FFF;">VERMELHO</option>
                                                                                <option value="VERMELHO ESCURO" style="background-color: #8B0000; color: #FFF;">VERMELHO ESCURO</option>
                                                                                <option value="ROSA" style="background-color: #FFC0CB; color: #000;">ROSA</option>
                                                                                <option value="ROSA PINK" style="background-color: #FF1493; color: #FFF;">ROSA PINK</option>
                                                                                <option value="AZUL" style="background-color: #0000FF; color: #FFF;">AZUL</option>
                                                                                <option value="AZUL CLARO" style="background-color: #87CEEB; color: #000;">AZUL CLARO</option>
                                                                                <option value="AZUL ESCURO" style="background-color: #00008B; color: #FFF;">AZUL ESCURO</option>
                                                                                <option value="AZUL MARINHO" style="background-color: #000080; color: #FFF;">AZUL MARINHO</option>
                                                                                <option value="VERDE" style="background-color: #008000; color: #FFF;">VERDE</option>
                                                                                <option value="VERDE CLARO" style="background-color: #90EE90; color: #000;">VERDE CLARO</option>
                                                                                <option value="VERDE ESCURO" style="background-color: #006400; color: #FFF;">VERDE ESCURO</option>
                                                                                <option value="VERDE MILITAR" style="background-color: #556B2F; color: #FFF;">VERDE MILITAR</option>
                                                                                <option value="AMARELO" style="background-color: #FFFF00; color: #000;">AMARELO</option>
                                                                                <option value="AMARELO OURO" style="background-color: #FFD700; color: #000;">AMARELO OURO</option>
                                                                                <option value="LARANJA" style="background-color: #FFA500; color: #000;">LARANJA</option>
                                                                                <option value="LARANJA ESCURO" style="background-color: #FF8C00; color: #FFF;">LARANJA ESCURO</option>
                                                                                <option value="ROXO" style="background-color: #800080; color: #FFF;">ROXO</option>
                                                                                <option value="LILÁS" style="background-color: #DDA0DD; color: #000;">LILÁS</option>
                                                                                <option value="VIOLETA" style="background-color: #8A2BE2; color: #FFF;">VIOLETA</option>
                                                                                <option value="MARROM" style="background-color: #8B4513; color: #FFF;">MARROM</option>
                                                                                <option value="MARROM CLARO" style="background-color: #D2B48C; color: #000;">MARROM CLARO</option>
                                                                                <option value="BEGE" style="background-color: #F5F5DC; color: #000;">BEGE</option>
                                                                                <option value="CREME" style="background-color: #FFFDD0; color: #000;">CREME</option>
                                                                                <option value="NUDE" style="background-color: #E3C9A2; color: #000;">NUDE</option>
                                                                                <option value="PRATA" style="background-color: #C0C0C0; color: #000;">PRATA</option>
                                                                                <option value="DOURADO" style="background-color: #FFD700; color: #000;">DOURADO</option>
                                                                                <option value="BRONZE" style="background-color: #CD7F32; color: #FFF;">BRONZE</option>
                                                                                <option value="TURQUESA" style="background-color: #40E0D0; color: #000;">TURQUESA</option>
                                                                                <option value="CIANO" style="background-color: #00FFFF; color: #000;">CIANO</option>
                                                                                <option value="MAGENTA" style="background-color: #FF00FF; color: #FFF;">MAGENTA</option>
                                                                                <option value="CORAL" style="background-color: #FF7F50; color: #000;">CORAL</option>
                                                                                <option value="SALMÃO" style="background-color: #FA8072; color: #000;">SALMÃO</option>
                                                                                <option value="VINHO" style="background-color: #722F37; color: #FFF;">VINHO</option>
                                                                                <option value="BORDÔ" style="background-color: #800020; color: #FFF;">BORDÔ</option>
                                                                                <option value="MOSTARDA" style="background-color: #FFDB58; color: #000;">MOSTARDA</option>
                                                                                <option value="OLIVA" style="background-color: #808000; color: #FFF;">OLIVA</option>
                                                                                <option value="MULTICOLORIDO" style="background: linear-gradient(45deg, #ff0000, #ff8000, #ffff00, #80ff00, #00ff00, #00ff80, #00ffff, #0080ff, #0000ff, #8000ff, #ff00ff, #ff0080); color: #FFF;">MULTICOLORIDO</option>
                                                                                <option value="ESTAMPADO" style="background-color: #F0F0F0; color: #000;">ESTAMPADO</option>
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select class="form-control form-control-sm" v-model="variacao.tamanho">
                                                                                <option value="">Selecione...</option>
                                                                                <option value="PP">PP</option>
                                                                                <option value="P">P</option>
                                                                                <option value="M">M</option>
                                                                                <option value="G">G</option>
                                                                                <option value="GG">GG</option>
                                                                                <option value="XG">XG</option>
                                                                                <option value="XXG">XXG</option>
                                                                                <option value="34">34</option>
                                                                                <option value="36">36</option>
                                                                                <option value="38">38</option>
                                                                                <option value="40">40</option>
                                                                                <option value="42">42</option>
                                                                                <option value="44">44</option>
                                                                                <option value="46">46</option>
                                                                                <option value="48">48</option>
                                                                                <option value="50">50</option>
                                                                                <option value="ÚNICO">TAMANHO ÚNICO</option>
                                                                            </select>
                                                                        </td>
                                                                        <td style="text-align: center;">
                                                                            <button type="button" 
                                                                                class="btn btn-danger btn-sm" 
                                                                                @click.prevent="mtdexcluirvariacao(index)"
                                                                                title="Excluir variação">
                                                                                <i class="fa fa-trash"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvfiliais" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="card" style="margin-top: 15px;">
                                                    <div class="card-header card-in">FILIAIS</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-4 col-lg-4" id="dvfiliaisproduto">
                                                                <span class="lblselect2">Filial:</span>
                                                                <select id="cbfilialproduto" v-model="vidfilialproduto"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione uma filial"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btincfilialproduto" v-bind:disabled="ativadesativa"
                                                                        class="btn btn-info btn-sm" @click="mtdincfilialproduto()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;"><i
                                                                        class="fa fa-plus-circle"></i> Incluir
                                                                </button>
                                                            </div>
                                                            <div v-if="lstfiliaisproduto.length > 0" class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistaestoque" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th width="300">Filial:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstfiliaisproduto">
                                                                            <tr v-for="(filial, index) in lstfiliaisproduto" v-bind:key="index">
                                                                                <td width="300px">{{ filial.fantasia }}</td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtddeletarfilialproduto(index)"><i class="fa fa-trash"></i>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">IMPORTAÇÃO DE CADASTRO DE PRODUTOS</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">Importação de cadastro</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cbimportarcodigos" v-model="vimportarcodigos">
                                        <label class="custom-control-label" for="cbimportarcodigos" style="color: #f82b54;">Manter códigos</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div v-if="vlimpardados" class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cbreconstruirchaves" v-model="vreconstruirchaves" title="Em caso de erro durante o processo de importação, marcar esta opção pra reconstruir as chaves estrageiras da tabela de produtos.">
                                        <label class="custom-control-label" for="cbreconstruirchaves" style="color: #f82b54;">Reconstruir chaves</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file"
                                        id="ipselecionararquivo"
                                        accept=".xls"
                                        @change="mtdselecionararquivo"
                                        style="display: none;"
                                        ref="if_selecionarquivo">
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input type="file" id="btselecionararquivo" accept=".xls" style="display: none;">
                                    <div class="dropdown">
                                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                            <i class="fa fa-list-ol"></i> Códigos
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" @click.prevent="mtdbaixarmatrizcodigos()">Baixar matriz</a>
                                            <a class="dropdown-item" href="#" @click.prevent="mtdarquivocodigos()">Enviar arquivo</a>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Ajustar estoque -->
        <div class="modal fade" id="mdajuste" tabindex="-1">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-cubes" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">AJUSTE DE ESTOQUE</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidproduto">Código:</label>
                                <input type="text" v-model="vidproduto" disabled="disabled"
                                    class="form-control form-control-sm" id="edidproduto">
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescpro">Descrição do produto:</label>
                                <input type="text" v-model="vdescpro" disabled="disabled"
                                        class="form-control form-control-sm" id="eddescpro" maxlength="50"
                                        style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdanterior">Estoque anterior:</label>
                                <money class="form-control form-control-sm" id="edqtdanterior"
                                    v-bind="quantidade" v-model="vqtdanterior"
                                    value="0,00" data-bv-group=".group" disabled="disabled"
                                    style="text-align:right; font-weight: bold; background-color: honeydew; color: darkgreen;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edund">Unidade:</label>
                                <input type="text" v-model="vundanterior" disabled="disabled"
                                    class="form-control form-control-sm" id="edund" maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbestoque">Estoque:</label>
                                <select id="cbestoque" v-model="videstoque"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdmov">Quantidade:</label>
                                <money class="form-control form-control-sm" id="edqtdmov"
                                    v-bind="quantidade" v-model="vqtdmov"
                                    value="0,00" data-bv-group=".group"
                                    style="text-align:right; font-weight: bold; background-color: honeydew; color: darkgreen;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edund">Unidade:</label>
                                <input type="text" v-model="vunidadepro" disabled="disabled"
                                    class="form-control form-control-sm" id="edund" maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edvlmov">Vl. Custo:</label>
                                <money class="form-control form-control-sm" id="edvlmov" disabled="disabled"
                                    v-bind="money" v-model="vvlmov"
                                    value="0,00" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddocmov">Documento:</label>
                                <input type="text" v-model="vdocmov"
                                    class="form-control form-control-sm" id="eddocmov" maxlength="20"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtmov">Dt. Movimento:</label>
                                <date-picker id="eddtmov" v-model="vdtmov" :config="options"
                                        class="form-control form-control-sm"></date-picker>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbtpmov">Tipo de movimento:</label>
                                <select class="form-control form-control-sm" id="cbtpmov" v-model="vtpmov">
                                    <option value="0">Entrada</option>
                                    <option value="1">Saída</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbperda">Lançar como perda:</label>
                                <select class="form-control form-control-sm" id="cbperda" v-model="vperda">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="cbfilialajuste">Filial:</label>
                                <select id="cbfilialajuste" v-model="vidfilialajuste"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 10px;">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edobsmov">Motivo/Justificativa:</label>
                                <div class="form-group">
                                    <textarea class="form-control"
                                        rows="3" id="edobsmov" v-model="vobsmov" style="text-transform: uppercase;"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmarajuste()" class="btn btn-primary btn-sm">Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Ajustar estoque -->
        <div class="modal fade" id="mdajusterapido" tabindex="-1">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-cubes" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">AJUSTE (RÁPIDO) DE ESTOQUE</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidprodutoajuste">Código:</label>
                                <input type="text" v-model="vcodpescajuste"  v-on:keyup.13="mtdlocalizarproduto(vcodpescajuste)"
                                    class="form-control form-control-sm" id="edidprodutoajuste">
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescpror">Descrição do produto:</label>
                                <input type="text" v-model="vdescpror" disabled="disabled"
                                        class="form-control form-control-sm" id="eddescpror" maxlength="50"
                                        style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdanteriorr">Estoque anterior:</label>
                                <money class="form-control form-control-sm" id="edqtdanteriorr"
                                    v-bind="quantidade" v-model="vqtdanteriorr"
                                    value="0,00" data-bv-group=".group" disabled="disabled"
                                    style="text-align:right; font-weight: bold; background-color: honeydew; color: darkgreen;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edundr">Unidade:</label>
                                <input type="text" v-model="vundanteriorr" disabled="disabled"
                                    class="form-control form-control-sm" id="edundr" maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbestoquerap">Estoque:</label>
                                <select id="cbestoquerap" v-model="videstoquer"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdmovr">Quantidade:</label>
                                <money class="form-control form-control-sm" id="edqtdmovr"
                                    v-bind="quantidade" v-model="vqtdmovr"
                                    value="0,00" data-bv-group=".group"
                                    style="text-align:right; font-weight: bold; background-color: honeydew; color: darkgreen;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edund">Unidade:</label>
                                <input type="text" v-model="vunidadepror" disabled="disabled"
                                    class="form-control form-control-sm" id="edund" maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edvlmovr">Vl. Custo:</label>
                                <money class="form-control form-control-sm" id="edvlmovr" disabled="disabled"
                                    v-bind="money" v-model="vvlmovr"
                                    value="0,00" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddocmovr">Documento:</label>
                                <input type="text" v-model="vdocmovr"
                                    class="form-control form-control-sm" id="eddocmovr" maxlength="20"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtmovr">Dt. Movimento:</label>
                                <date-picker id="eddtmovr" v-model="vdtmovr" :config="options"
                                        class="form-control form-control-sm"></date-picker>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbtpmovr">Tipo de movimento:</label>
                                <select class="form-control form-control-sm" id="cbtpmovr" v-model="vtpmovr">
                                    <option value="0">Entrada</option>
                                    <option value="1">Saída</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbperdar">Lançar como perda:</label>
                                <select class="form-control form-control-sm" id="cbperdar" v-model="vperdar">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="cbfilialajusterap">Filial:</label>
                                <select id="cbfilialajusterap" v-model="vidfilialajuster"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 10px;">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edobsmovr">Motivo/Justificativa:</label>
                                <div class="form-group">
                                    <textarea class="form-control"
                                        rows="3" id="edobsmovr" v-model="vobsmovr" style="text-transform: uppercase;"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" :disabled="!vachouprodutoajuste" @click.prevent="mtdconfirmarajusterapido()" class="btn btn-primary btn-sm">Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Atribuir classe -->
        <div class="modal fade" id="mdatribuirclasse" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir/Remover Classe de imposto a produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbopcaoclasse">Opção:</label>
                                <select name="cbopcaoclasse" class="form-control form-control-sm" id="cbopcaoclasse" v-model="vopcaoclasseatribuir">
                                    <option value="0">Atribuir</option>
                                    <option value="1">Remover</option>
                                </select>
                            </div>
                            <div class="col-md-12" id="dvfilialatribuir">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialatribuir"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-md-12" id="dvclasseatribuir">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbclasseatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidclasseatribuir"
                                    data-allow-clear="true" style="width:100%;" :disabled="!vidfilialatribuir">
                                </select>
                            </div>
                            <div class="col-md-12" style="padding-top: 10px; padding-bottom: 15px;">
                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                    <input type="checkbox" class="custom-control-input" id="swctodosprodutos" name="swctodosprodutos" v-model="vatribuitodosprodutos">
                                    <label class="custom-control-label" for="swctodosprodutos">Aplicar a todos os produtos</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirclasse()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Atribuir cashback -->
        
        <div class="modal fade" id="mdatribuircb" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir/Remover casback a produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="cbopcaoclasse">Opção:</label>
                                <select name="cbopcaoclasse" class="form-control form-control-sm" id="cbopcaoclasse" v-model="vopcaocbatribuir">
                                    <option value="0">Atribuir</option>
                                    <option value="1">Remover</option>
                                </select>
                            </div>
                
                           <!-- CP MARCA                           -->
                            <div class="col-md-6">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcaatrcb" v-model="vidmarcaatribuircb"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP GRUPO -->
                            <div class="col-md-6">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupoatrcb" v-model="vidgrupoatribuircb"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SUBGRUPO -->
                            <div class="col-md-6" >
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupoatrcb" v-model="vidsubgrupoatribuircb"
                                        data-placeholder="Selecione um subgrupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SETORPESQUISA -->
                            <div class="col-md-6" >
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetoratrcb" v-model="vidsetoratribuircb"
                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP NCM -->
                            <div class="col-md-6" >
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmatrcb" data-placeholder="Selecione uma opção" v-model="vidncmatribuircb"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SITUAÇÃO -->
                            <div class="col-md-6">
                                <label for="cbsituacaoatr">Situação:</label>
                                <select name="cbsituacaoatrcb" class="form-control form-control-sm" id="cbsituacaoatr" v-model="vistproatribuircb"  title="Situação dos produtos">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>

                            <div class="col-md-12" >
                                <span class="lblselect2">Tabela de preço:</span>
                                <select id="cbtabelaatribuircashback" data-placeholder="Selecione uma opção" v-model="vidtabelacbatr"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>

                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircbavmassa" v-model="vatribuircbavistamassa">
                                    <label class="custom-control-label" for="cbatribuircbavmassa"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label for="edatrcomiscb">Cashback a vista %:</label>
                                <money type="text" class="form-control form-control-sm" id="edcbmassacb"
                                        v-model="valcashbackavistamassa" v-bind="money" v-bind:disabled="!vatribuircbavistamassa"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircbapmassa" v-model="vatribuircbaprazomassa">
                                    <label class="custom-control-label" for="cbatribuircbapmassa"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label for="edcbmassa">Cashback a prazo %:</label>
                                <money type="text" class="form-control form-control-sm" id="edcbmassa"
                                        v-model="valcashbackaprazomassa" v-bind="money" v-bind:disabled="!vatribuircbaprazomassa"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                     
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuircashbackmassa()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>


           <div class="modal fade" id="mdatribuirfil" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-bank" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir filiais aos produtos.</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="cbopcaoclasse">Opção:</label>
                                <select name="cbopcaoclasse" class="form-control form-control-sm" id="cbopcaoclasse" v-model="vopcaoatribuirfilial">
                                    <option value="0">Atribuir</option>
                                    <option value="1">Remover</option>
                                </select>
                            </div>

                            <div class="col-md-12" id="dvfilialatribuir">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialatribuirpro" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialatribuirpro"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                
                           <!-- CP MARCA                           -->
                            <div class="col-md-6">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcaatrfil" v-model="vidmarcaatribuirfilial"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP GRUPO -->
                            <div class="col-md-6">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupoatrfil" v-model="vidgrupoatribuirfilial"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SUBGRUPO -->
                            <div class="col-md-6" >
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupoatrfil" v-model="vidsubgrupoatribuirfilial"
                                        data-placeholder="Selecione um subgrupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SETORPESQUISA -->
                            <div class="col-md-6" >
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetoratrfil" v-model="vidsetoratribuirfilial"
                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP NCM -->
                            <div class="col-md-6" >
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmatrfil" data-placeholder="Selecione uma opção" v-model="vidncmatribuirfilial"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SITUAÇÃO -->
                            <div class="col-md-6">
                                <label for="cbsituacaoatr">Situação:</label>
                                <select name="cbsituacaoatrfil" class="form-control form-control-sm" id="cbsituacaofil" v-model="vistproatribuirfilial"  title="Situação dos produtos">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div> 
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmadefinefiliaislista()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>


         <!-- Atribuir classe por NCM com planilha -->
         <div class="modal fade" id="mdatribuirclassencm" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir/Remover Classe de imposto a produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row" >
                            <div class="col-12" >
                                <ul class="nav nav-tabs" role="tablist">
                                    <!-- NCM -->
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvncmimport">Por NCM</a>
                                    </li>
                                    <!-- IDPRODUTO -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcodigoimport">Por código</a>
                                    </li>
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvncmimport" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-md-12" style="padding-bottom: 15px!important;">
                                                <h1 style="color: #0acf97!important;" class="text-info">Importação de classe de imposto</h1>
                                            </div>
                                            <div class="col-md-12">
                                                <p style="text-indent: 1.5em; font-size: 16px; color: #f82b54;">
                                                    Atenção: não realize este procedimento se não tiver certeza de como executá-lo corretamente.</p>
                                                <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                                    É importante adicionar o cabeçalho.
                                                </p>
                                                <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                                Importe uma planilha no formato xls contendo as informações de NCM, codigo da classe e codigo da filial conforme diagrama abaixo: 
                                                </p>
                                            </div>
                                            <div class="col-md-12" >
                                                <table class="table table-bordered">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">CODNCM</th>
                                                        <th scope="col">CODCLASSE</th>
                                                        <th scope="col">IDFILIAL</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>02023000</td>
                                                        <td>1</td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>02071100</td>
                                                        <td>1</td>
                                                        <td>1</td>
                                                    </tr>
                                                    
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <input
                                                type="file"
                                                id="ipselecionararquivoncm"
                                                accept=".xls"
                                                @change="(event) => mtdselecionararquivoncm(event, 1)"
                                                style="display: none;"
                                                ref="if_selecionarquivoncm1">
                                                <button type="button" @click="$refs.if_selecionarquivoncm1.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                                    Enviar arquivo
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvcodigoimport" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-md-12" style="padding-bottom: 15px!important;">
                                                <h1 style="color: #0acf97!important;" class="text-info">Importação de classe de imposto</h1>
                                            </div>
                                            <div class="col-md-12">
                                                <p style="text-indent: 1.5em; font-size: 16px; color: #f82b54;">
                                                    Atenção: não realize este procedimento se não tiver certeza de como executá-lo corretamente.</p>
                                                <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                                    É importante adicionar o cabeçalho.
                                                </p>
                                                <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                                Importe uma planilha no formato xls contendo as informações de código de produto, codigo da classe e codigo da filial conforme diagrama abaixo: 
                                                </p>
                                            </div>
                                            <div class="col-md-12" >
                                                <table class="table table-bordered">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">IDPRODUTO</th>
                                                        <th scope="col">CODCLASSE</th>
                                                        <th scope="col">IDFILIAL</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>400289</td>
                                                        <td>1</td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>4515521</td>
                                                        <td>1</td>
                                                        <td>1</td>
                                                    </tr>
                                                    
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <input
                                                type="file"
                                                id="ipselecionararquivoncm"
                                                accept=".xls"
                                                @change="(event) => mtdselecionararquivoncm(event, 2)"
                                                style="display: none;"
                                                ref="if_selecionarquivoncm">
                                                <button type="button" @click="$refs.if_selecionarquivoncm.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                                    Enviar arquivo
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Atribuir classe com filtro-->
        <div class="modal fade" id="mdatribuirclassefiltro" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir/Remover Classe de imposto a produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbopcaoclasse">Opção:</label>
                                <select name="cbopcaoclasse" class="form-control form-control-sm" id="cbopcaoclasse" v-model="vopcaoclasseatribuirfiltro">
                                    <option value="0">Atribuir</option>
                                    <option value="1">Remover</option>
                                </select>
                            </div>
                            <div class="col-md-12" id="dvfilialatribuir">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilialatribuirclasse" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialatribuirclasse"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-md-12" id="dvclasseatribuirclasse">
                                <span class="lblselect2">*Classe:</span>
                                <select id="cbclasseatribuirclasse" data-placeholder="Selecione uma opção"
                                    v-model="vidclasseatribuirclasse"
                                    data-allow-clear="true" style="width:100%;" :disabled="!vidfilialatribuirclasse">
                                </select>
                            </div>
                           <!-- CP MARCA                           -->
                            <div class="col-md-6">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcaatr" v-model="vidmarcaatribuirclasse"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP GRUPO -->
                            <div class="col-md-6">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupoatr" v-model="vidgrupoatribuirclasse"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SUBGRUPO -->
                            <div class="col-md-6" >
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupoatr" v-model="vidsubgrupoatribuirclasse"
                                        data-placeholder="Selecione um subgrupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SETORPESQUISA -->
                            <div class="col-md-6" >
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetoratr" v-model="vidsetoratribuirclasse"
                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP NCM -->
                            <div class="col-md-12" >
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmatr" data-placeholder="Selecione uma opção" v-model="vidncmatribuirclasse"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- CP SITUAÇÃO -->
                            <div class="col-md-6">
                                <label for="cbsituacaoatr">Situação:</label>
                                <select name="cbsituacaoatr" class="form-control form-control-sm" id="cbsituacaoatr" v-model="vistproatribuirclasse"  title="Situação dos produtos">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <!-- CP FRACIONADO                                                    -->
                            <div class="col-md-6">
                                <label for="cbfracionadoatr">Fracionado:</label>
                                <select name="cbfracionadoatr" class="form-control form-control-sm" id="cbfracionadoatr" v-model="vidfracionadoatribuirclasse" @change="mtdlimpar_listagem()" title="Condição para exibição dos produtos fracionados">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirclassefiltro()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Atribuir campos -->
        <div class="modal fade" id="mdatribuircampos">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir campos aos produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body" style="padding-top: 5px;">
                        <div class="row">
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirsituacao" v-model="vatribuirsituacao">
                                    <label class="custom-control-label" for="cbatribuirsituacao"></label>
                                </div>
                            </div>
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="cbsituacaocampos">Situação:</label>
                                <select class="form-control form-control-sm" id="cbsituacaocampos" v-model="vsituacaocampos" v-bind:disabled="!vatribuirsituacao">
                                    <option value="0">Inativo</option>
                                    <option value="1">Ativo</option>
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirreferencia" v-model="vatribuirreferencia">
                                    <label class="custom-control-label" for="cbatribuirreferencia"></label>
                                </div>
                            </div>
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="edreferenciacampos">Referência:</label>
                                <input type="text" v-model="vreferenciacampos"
                                        class="form-control form-control-sm" id="edreferenciacampos" maxlength="20" v-bind:disabled="!vatribuirreferencia">
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirfracionado" v-model="vatribuirfracionado">
                                    <label class="custom-control-label" for="cbatribuirfracionado"></label>
                                </div>
                            </div>
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="cbfracionadocampos">Fracionado:</label>
                                <select class="form-control form-control-sm" id="cbfracionadocampos" v-model="vfracionadocampos" v-bind:disabled="!vatribuirfracionado">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridunidade" v-model="vatribuiridunidade">
                                    <label class="custom-control-label" for="cbatribuiridunidade"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <span class="lblselect2">Unidade:</span>
                                <select id="cbunidadecampos" data-placeholder="Selecione uma opção"
                                    v-model="vidunidadecampos" v-bind:disabled="!vatribuiridunidade"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridmarca" v-model="vatribuiridmarca">
                                    <label class="custom-control-label" for="cbatribuiridmarca"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcacampos" data-placeholder="Selecione uma opção"
                                    v-model="vidmarcacampos" v-bind:disabled="!vatribuiridmarca"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridgrupo" v-model="vatribuiridgrupo">
                                    <label class="custom-control-label" for="cbatribuiridgrupo"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupocampos" data-placeholder="Selecione uma opção"
                                    v-model="vidgrupocampos" v-bind:disabled="!vatribuiridgrupo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridsubgrupo" v-model="vatribuiridsubgrupo">
                                    <label class="custom-control-label" for="cbatribuiridsubgrupo"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupocampos" data-placeholder="Selecione uma opção"
                                    v-model="vidsubgrupocampos" v-bind:disabled="!vatribuiridsubgrupo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirsetor" v-model="vatribuirsetor">
                                    <label class="custom-control-label" for="cbatribuirsetor"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetorprodutoatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidsetorprodutoatribuir" v-bind:disabled="!vatribuirsetor"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridncm" v-model="vatribuiridncm">
                                    <label class="custom-control-label" for="cbatribuiridncm"></label>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmcampos" data-placeholder="Selecione uma opção"
                                    v-model="vidncmcampos" v-bind:disabled="!vatribuiridncm"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridcest" v-model="vatribuiridcest">
                                    <label class="custom-control-label" for="cbatribuiridcest"></label>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <span class="lblselect2">CEST:</span>
                                <select id="cbcestcampos" data-placeholder="Selecione uma opção"
                                    v-model="vidcestcampos" v-bind:disabled="!vatribuiridcest"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircomis" v-model="vatribuircomis">
                                    <label class="custom-control-label" for="cbatribuircomis"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label for="edcomis">A. de comissão %:</label>
                                <money type="text" class="form-control form-control-sm" id="edcomis"
                                        v-model="valcomis" v-bind="money" v-bind:disabled="!vatribuircomis"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirvalidade" v-model="vatribuirvalidade">
                                    <label class="custom-control-label" for="cbatribuirvalidade"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label for="eddiasvalidadeatr">Validade:</label>
                                <input type="number" v-model="vdiasvalidadeatr" v-bind:disabled="!vatribuirvalidade"
                                        class="form-control form-control-sm" id="eddiasvalidadeatr" min="0">
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirecommerce" v-model="vatribuirecommerce">
                                    <label class="custom-control-label" for="cbatribuirecommerce"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label for="cbecommerceatribuir">Exibir no e-commerce:</label>
                                <select class="form-control form-control-sm" id="cbecommerceatribuir" v-model="vecommerceatr" v-bind:disabled="!vatribuirecommerce">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                              
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircb" v-model="vatribuircbavista">
                                    <label class="custom-control-label" for="cbatribuircb"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label for="edatrcomis">Cashback a vista %:</label>
                                <money type="text" class="form-control form-control-sm" id="edatrcomis"
                                        v-model="valcashbackavista" v-bind="money" v-bind:disabled="!vatribuircbavista"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircbap" v-model="vatribuircbaprazo">
                                    <label class="custom-control-label" for="cbatribuircbap"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <label for="edatrcomis">Cashback a prazo %:</label>
                                <money type="text" class="form-control form-control-sm" id="edatrcomis"
                                        v-model="valcashbackaprazo" v-bind="money" v-bind:disabled="!vatribuircbaprazo"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card" style="margin-top: 15px;">
                                    <div class="card-header card-in text-center" style="padding: 5px;">LOCALIZAÇÃO</div>
                                    <div class="card-body" style="padding: 5px 15px 15px 15px;">
                                        <div class="row">
                                            <div class="col-sm-1 col-md-1 col-lg-1">
                                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                                    <input type="checkbox" class="custom-control-input" id="cbatribuirlocalizacao" v-model="vatribuirlocalizacao">
                                                    <label class="custom-control-label" for="cbatribuirlocalizacao"></label>
                                                </div>
                                            </div>
                                            <div class="col-md-11">
                                                <span class="lblselect2">Filial:</span>
                                                <select id="cbfilialatribuirloc" data-placeholder="Selecione uma opção"
                                                    v-model="vidfilialatribuirloc" v-bind:disabled="!vatribuirlocalizacao"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-1 col-md-1 col-lg-1">
                                            </div>
                                            <div class="col-md-11">
                                                <span class="lblselect2">Localização:</span>
                                                <select id="cblocalizacaoatribuir" data-placeholder="Selecione uma opção"
                                                    v-model="vidlocalizacaoatribuir" v-bind:disabled="!vatribuirlocalizacao"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuircampos()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Atribuir tabela -->
        <div class="modal fade" id="mdatribuirtabela" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir tabela de preço à produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div :class="vopatribuicaotabela == 0 ? 'col-sm-12 col-md-7 col-lg-7' : 'col-sm-12 col-md-12 col-lg-12'">
                                <label for="cbtipoatribuirtabela">Tipo de atribuição:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbtipoatribuirtabela" v-model="vopatribuicaotabela">
                                    <option value="0">Atribuição direta</option>
                                    <option value="1">Atribuir com base em outra tabela</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5" style="padding-top: 25px;" v-show="vopatribuicaotabela == 0">
                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                    <input type="checkbox" class="custom-control-input" id="swatribuitodastb"
                                    name="swatribuitodastb" v-model="vidatribuitodastb"
                                    @change="mtdselecionatodastbprvenda()">
                                    <label class="custom-control-label" for="swatribuitodastb" title="A ação será aplicada em todas as tabelas!">Todas tabelas</label>
                                </div>
                            </div>
                            <!-- atribuição direta: -->
                            <div class="col-sm-12 col-md-12 col-lg-12 mt-2 mt-2" v-show="vopatribuicaotabela == 0">
                                <span class="lblselect2">Tabela: <i class="fa fa-info-circle" v-show="vidatribuitodastb" data-toggle="tooltip" data-placement="right" title="A atribuição será feita a todas as tabelas!"></i></span>
                                <select id="cbtabelaatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidtabelaatribuir"
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="vidatribuitodastb">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 mt-2" v-show="vopatribuicaotabela == 0">
                                <label for="cbtipoatribuirtabela">Atribuir:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbtipoatribuirtabela" v-model="vtipoatribuirtabela">
                                    <option value="0">Margem em cima do custo</option>
                                    <option value="1">Valor</option>
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoatribuirtabela) === 1" class="col-sm-12 col-md-6 col-lg-6 mt-2">
                                <label for="edprecoatribuir">Valor:</label>
                                <money type="text" class="form-control form-control-sm" id="edprecoatribuir"
                                        v-model="vprecoatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div v-show="parseInt(vtipoatribuirtabela) === 0 && vopatribuicaotabela == 0 " class="col-sm-12 col-md-6 col-lg-6 mt-2">
                                <label for="edmrgtabelaatribuir">Margem(%): <i class="fa fa-info-circle" v-show="vidatribuitodastb" data-toggle="tooltip" data-placement="right" title="Será usada a margem correspondente ao cadastro de cada tabela "></i></label>
                                <money type="text" class="form-control form-control-sm" id="edmrgtabelaatribuir"
                                        v-model="vmrgtabelaatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;" v-bind:disabled="vtipoatribuirtabela == 0 && vidatribuitodastb">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 mt-2" v-show="vopatribuicaotabela == 0">
                                <label for="edcomissaotabelaatribuir">Comissão(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edcomissaotabelaatribuir"
                                        v-model="vcomissaotabelaatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 mt-2" v-show="vopatribuicaotabela == 0">
                                <label for="edqtdmintabelaatribuir">Desconto %:</label>
                                <money type="text" class="form-control form-control-sm" id="edqtdmintabelaatribuir"
                                        v-model="vdescontotabelaatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 mt-2" v-show="vopatribuicaotabela == 0">
                                <label for="eddescontotabelaatribuir">Qtd. Mínima:</label>
                                <money type="text" class="form-control form-control-sm" id="eddescontotabelaatribuir"
                                        v-model="vqtdmintabelaatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            
                            <!-- atribuir com base em outra tabela -->
                            <div class="col-12" v-show="vopatribuicaotabela == 1">
                                <span class="lblselect2">Tabela origem:</span>
                                <select id="cbtabelaatribuirorigem" data-placeholder="Selecione uma opção"
                                    v-model="vidtabelaatribuirorigem"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- <div class="col-12" v-show="vopatribuicaotabela == 1">
                                <span class="lblselect2">Tabela à atribuir:</span>
                                <select id="cbtabelaatribuirdestino" data-placeholder="Selecione uma opção"
                                    v-model="vidtabelaatribuirdestino"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> -->
                            <!-- <div class="col-12" v-show="vopatribuicaotabela == 1 && vidtabelaatribuirorigem != null">
                                <div class="container text-center">
                                    <div class="row" v-for="(coluna, index) in vdatatabelaatribuirdestino" :key="index">
                                        <div class="col-6">{{ coluna.descricao }}</div>
                                        <div class="col-6">{{ coluna.margem }}</div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-lg-12" style="height: 200px; overflow-y: auto;" v-show="vopatribuicaotabela == 1 && vidtabelaatribuirorigem != null">
                                <div class="table-responsive">
                                    <table id="tblistatabelasatribuidas"
                                            class="table table-bordered table-sm table-hover"
                                            style="margin-top: 10px">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="5px" style="text-align: center;">
                                                    <input type="checkbox" v-model="vSelecionaTodasTabelas" @change="mtdSelecionarTodasTabelas">
                                                </th>
                                                <th>Descrição</th>
                                                <th width="100px" style="text-align: center;">Margem (%)</th>
                                            </tr>
                                        </thead>
                                        <tbody id="lsttabelasatribuir">
                                            <tr v-for="(tabela, index) in vdatatabelaatribuirdestino.filter(t => t.id != vidtabelaatribuirorigem)" :key="index">
                                                <td class="text-center">
                                                    <input type="checkbox" v-model="tabela.selecionado">
                                                </td>
                                                <td>{{ tabela.descricao }}</td>

                                                <td class="text-center">
                                                    <input v-if="tabela.selecionado" type="number" step="1" min = "0" v-model="tabela.margem"
                                                        class="form-control form-control-sm text-center"
                                                        style="width: 80px; display: inline-block;">
                                                    <span v-else>{{ tabela.margem }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <!-- <div v-show="vopatribuicaotabela == 1" class="col-sm-12 col-md-6 col-lg-6 mt-2">
                                <label for="edmrgtabelaatribuirbaseoutra">Margem(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edmrgtabelaatribuirbaseoutra"
                                        v-model="vmrgtabelabaseoutra" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div> -->
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirtabela()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Atribuir qtd. min -->
        <div class="modal fade" id="mdatribuiqtdmin" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir desconto quantidade mínima</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <span class="lblselect2">Tabela:</span>
                                <select id="cbatribuidescqtdmin" data-placeholder="Selecione uma opção"
                                    v-model="vidatribuirdescontoqtdmin"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edqtdmindescatribuir">Desconto %:</label>
                                <money type="text" class="form-control form-control-sm" id="edqtdmindescatribuir"
                                        v-model="vdescontodescatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddescontodescatribuir">Qtd. Mínima:</label>
                                <money type="text" class="form-control form-control-sm" id="eddescontodescatribuir"
                                        v-model="vqtdmindescatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirdescqtdmin()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Geração de arquivos -->
        <div class="modal fade" id="mdgerararquivo" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-file" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Geração de arquivos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbtipoarquivo">Tipo de arquivo:</label>
                                <select name="cbtipoarquivo" class="form-control form-control-sm" id="cbtipoarquivo" v-model="vtipoarquivo">
                                    <option value="0">Balanças</option>
                                    <option value="1">Buscador de preços</option>
                                    <option value="2">Exportar cadastros</option>
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) < 2" class="col-md-12">
                                <span class="lblselect2">Tabela:</span>
                                <select id="cbtabelaarquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidtabelaarquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialarquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialarquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmarquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidncmarquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbclassearquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidclassearquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">Estoque:</span>
                                <select id="cbestoquearquivo" data-placeholder="Selecione uma opção"
                                    v-model="videstoquearquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcaarquivo" v-model="vidmarcaarquivo"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupoarquivo" v-model="vidgrupoarquivo"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupoarquivo" v-model="vidsubgrupoarquivo"
                                        data-placeholder="Selecione um subgrupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetorarquivo" v-model="vidsetorarquivo"
                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbstprorquivo">Sit.:</label>
                                <select name="cbstprorquivo" class="form-control form-control-sm" id="cbstprorquivo" v-model="vstproarquivo" title="Situação dos produtos">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbfracionadoarquivo">Frac.:</label>
                                <select name="cbfracionadoarquivo" class="form-control form-control-sm" id="cbfracionadopesq" v-model="vfracionadoarquivo" title="Condição para exibição dos produtos fracionados">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cblayoutbalanca">Layout arquivo:</label>
                                <select name="cblayoutbalanca" class="form-control form-control-sm" id="cblayoutbalanca" v-model="vlayoutbalanca">
                                    <option value="0">Filizola</option>
                                    <option value="1">Toledo</option>
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbestoquearquivo">Estoque:</label>
                                <select name="cbestoquearquivo" class="form-control form-control-sm" id="cbestoquearquivo" v-model="vestoquearquivo">
                                    <option value="0">Com saldo</option>
                                    <option value="1">Sem saldo</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdgerararquivo()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Menu do produto -->
		<div class="modal fade" id="mdmenuproduto" tabindex="-1">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(produtomenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(produtomenu)" data-dismiss="modal"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(produtomenu)" data-dismiss="modal"><i class="fa fa-trash"></i> EXCLUIR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(produtomenu)" data-dismiss="modal"><i class="fa fa-clone"></i> CLONAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdajustarestoque(produtomenu)" data-dismiss="modal"><i class="fa fa-cubes"></i> AJUSTAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizarestoque(produtomenu)" data-dismiss="modal"><i class="fa fa-cube"></i> ESTOQUE(S)</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizarfornecedores(produtomenu)" data-dismiss="modal"><i class="fa fa-user-secret"></i> FORNECEDORES</li>
                                
                                <!--Luiz Trindade - Botão de vendas-->
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizarvendas(produtomenu)" data-dismiss="modal"><i class="fa fa-shopping-basket"></i> HISTÓRICO DE VENDAS</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
		</div>

        <!-- Consulta por códigos -->
        <div class="modal fade" id="mdconsultaporcodigo" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-search" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Consultar produtos por código</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
							<div class="col-sm-12 col-md-8 col-lg-8">
								<label for="edcodigoconsultar">Informe o código à consultar:</label>
								<div class="input-group" style="z-index: 1;">
                                    <div class="input-group-append" id="dv-btn-camera">
                                        <a href="#" class="btn btn-success btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdscannearcode()"><i class="fa fa-barcode" style="padding-top: 3px;"></i></a>
                                    </div>
									<input type="text" class="form-control form-control-sm" id="edcodigoconsultar" v-model="pcodigoconsultar" maxlength="20" v-on:keyup.13="mtdlistarprodutosporcodigo()" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdlistarprodutosporcodigo()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-light">
                                        <tr>
                                            <th>Código:</th>
                                            <th>Descrição:</th>
                                            <th>Und:</th>
                                            <th>Código:</th>
                                            <th>Referência:</th>
                                            <th width="160px" style="text-align: center;">Opções</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(produto, index) in lstprodutoconsultacodigo" v-bind:key="index">
                                                <td>{{ produto.codigo }}</td>
                                                <td>{{ produto.descricao }}</td>
                                                <td>{{ produto.und }}</td>
                                                <td>{{ produto.id }}</td>
                                                <td>{{ produto.referência }}</td>
                                                <td width="180px" class="center" style="text-align: center;">
                                                    <a class="btn btn-primary btn-sm btn-opcrud ajt-btn" data-dismiss="modal" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdalterar(produto)"><i class="fa fa fa-edit"></i></a>
                                                    <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" data-dismiss="modal" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdajustarestoque(produto)"><i class="fa fa fa-cubes"></i></a>
                                                    <a class="btn btn-warning btn-sm btn-opcrud ajt-btn" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdvisualizarestoque(produto)"><i class="fa fa-cube"></i></a>
                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" data-dismiss="modal" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdexcluir(produto)"><i class="fa fa-trash"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal do scannercode -->
        <div class="modal static" id="mdlscannercode"  >
            <div class="modal-dialog modal-lg static">
                <div class="modal-content">
                    <div id="#dvcamera">
                        <v-quagga v-if="mostrandomodal==true" :onDetected="mtdprocessacodbar" :readerSize="readerSize"
                            :readerTypes="
                            ['code_128_reader',
                            'ean_reader',
                            'ean_8_reader']">
                        </v-quagga>
                    </div>
                </div>
            </div>
        </div>

        <!-- Operações com tabelas -->
        <div class="modal fade" id="mdoperacoestabelas" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-exchange" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Operações com tabelas</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="cbtpoperacao">Tipo de operação:</label>
                                <select name="cbtpoperacao" class="form-control form-control-sm" id="cbtpoperacao" v-model="otpoperacao">
                                    <option value="0">Atribuir tabela baseada em outra</option>
                                    <option value="1">Excluir tabela</option>
                                    <option value="2">Atribuir tabela com base no preço de custo</option>
                                    <option value="3">Ajustar valor da tabela</option>
                                </select>
                            </div>
                            <div v-show="parseInt(otpoperacao) === 0 || parseInt(otpoperacao) === 3" class="col-md-12">
                                <span class="lblselect2">Tabela origem:</span>
                                <select id="cbtabelaorigem" data-placeholder="Selecione uma opção"
                                    v-model="oidtabelaorigem"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-lg-12" style="height: 200px; overflow-y: auto;" v-show="(parseInt(otpoperacao) === 0 || parseInt(otpoperacao) === 2)">
                                <div class="table-responsive">
                                    <table id="tblistatabelasatribuidas"
                                            class="table table-bordered table-sm table-hover"
                                            style="margin-top: 10px">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="5px" style="text-align: center;">
                                                    <input type="checkbox" v-model="vSelecionaTodasOperacoesTabelas" @change="mtdSelecionarTodasOperacoesTabelas">
                                                </th>
                                                <th>Descrição</th>
                                                <th width="100px" style="text-align: center;">Margem (%)</th>
                                            </tr>
                                        </thead>
                                        <tbody id="lsttabelasatribuir">
                                            <tr v-for="(tabela, index) in vdataoperacoestabela.filter(t => t.id != oidtabelaorigem)" :key="index">
                                                <td class="text-center">
                                                    <input type="checkbox" v-model="tabela.selecionado">
                                                </td>
                                                <td>{{ tabela.descricao }}</td>

                                                <td class="text-center">
                                                    <input v-if="tabela.selecionado" type="number" step="1" min = "0" v-model="tabela.margem"
                                                        class="form-control form-control-sm text-center"
                                                        style="width: 80px; display: inline-block;">
                                                    <span v-else>{{ tabela.margem }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-show="parseInt(otpoperacao) === 1" class="col-md-12">
                                <span class="lblselect2">Tabela à atribuir:</span>
                                <select id="cbtabelaatribuirop" data-placeholder="Selecione uma opção"
                                    v-model="oidtabelaatribuirop"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <!-- <div v-show="parseInt(otpoperacao) === 2" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edmargematribuirop">Margem(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edmargematribuirop" v-model="omrgtabelaatribuirop"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                            </div> -->
                            <div v-show="parseInt(otpoperacao) === 3" class="col-sm-12 col-md-8 col-lg-8">
                                <label for="cbtpfatorajuste">Tipo de operação:</label>
                                <select name="cbtpfatorajuste" class="form-control form-control-sm" id="cbtpfatorajuste" v-model="otpfatorajuste">
                                    <option value="0">Percentual(%)</option>
                                    <option value="1">Valor($)</option>
                                </select>
                            </div>
							<div v-show="parseInt(otpoperacao) === 3" class="col-sm-12 col-md-4 col-lg-4">
                                <label v-if="parseInt(otpfatorajuste) === 0" for="edfatoratribuirop">Fator(%):</label>
                                <label v-else for="edfatoratribuirop">Fator($):</label>
                                <money type="text" class="form-control form-control-sm" id="edfatoratribuirop" v-model="ofatortabelaajuste"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-in" style="padding: 5px;">OPÇÕES DE FILTROS</div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <span class="lblselect2">Marca:</span>
                                                <select id="cbmarcaatribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidmarcaatribuirop"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="lblselect2">Grupo:</span>
                                                <select id="cbgrupoatribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidgrupoatribuirop"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="lblselect2">Subgrupo:</span>
                                                <select id="cbsubgrupoatribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidsubgrupoatribuirop"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="lblselect2">Setor:</span>
                                                <select id="cbsetoratribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidsetoratribuirop"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmaroperacaotabelas()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Visualiza o imposto sobre o valor -->
        <div class="modal fade" id="mdimpostovalor" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-dollar" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Imposto sobre o valor</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edivalorbase">Valor base:</label>
                                <div class="input-group" style="z-index: 1;">
                                    <money type="text" class="form-control form-control-sm" id="edivalorbase" v-model="ivalorbase"
                                            v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                                    <div class="input-group-append" style="height: 31px;">
                                        <button class="btn btn-primary" title="Atualizar cálculo" @click.prevent="mtdcalculavalorimpostoclasse()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-refresh"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbiclasse" data-placeholder="Selecione uma opção"
                                    v-model="iidclasse"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-12">
                                <label for="edivalorimposto">Imposto:</label>
                                <input type="text" class="form-control form-control-sm text-info" id="edivalorimposto"
                                    v-bind:value="mtdformatavalordecimal(parseFloat(ivalorimposto), 2)"
                                    data-bv-group=".group" style="text-align:right;" disabled>
                            </div>
                            <div class="col-12">
                                <label for="edivalorbase">Valor com imposto:</label>
                                <money type="text" class="form-control form-control-sm" id="edivalorbase" v-model="ivalorcomimposto"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdselecionavalorbase()" style="width: 100px;"><i class="fa fa-check"></i> Ok</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Atribuir margem para preço de venda na composição do custo -->
        <div class="modal fade" id="mdatribuirmargem" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-percent" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir margem</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edaprcusto">Pr. Custo:</label>
                                <money type="text" class="form-control form-control-sm" id="edaprcusto" v-model="vprcusto"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>
                            <div class="col-12">
                                <label for="edamargem">Margem(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edamargem" v-model="amargem"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;" @change.native="mtdcalculamargemprvendamedio()"></money>
                            </div>
                            <div class="col-12">
                                <label for="edavalor">Valor:</label>
                                <money type="text" class="form-control form-control-sm" id="edavalor" v-model="avalor"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdaplicarvalorprvenda()" style="width: 100px;"><i class="fa fa-check"></i> Aplicar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Informar o valor para calcular o percentual da margem de desconto promocional -->
        <div class="modal fade" id="mdinformarvalordescpromocional" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-percent" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff; font-size: 12px; margin-top: 5px;">Calcular percentual do descto promocional</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edvalorsemdescpromocional">Valor sem desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorsemdescpromocional" v-model="avalorsemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>
                            <div class="col-12">
                                <label for="edvalorcomdescpromocional">Valor com desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorcomdescpromocional" v-model="avalorcomdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" @change.native="mtdcalcularvalordescpromocional()"></money>
                            </div>
                            <div class="col-12">
                                <label for="edamargem">Percentual do desconto(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edamargem" v-model="amargemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdaplicarpercentualdescpromocional()" style="width: 100px;"><i class="fa fa-check"></i> Aplicar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- gerar catalogo de produtos -->
        <div class="modal fade container-fluid" id="mdcatalogo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Gerando catalogo</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="col-12">
                    <span class="lblselect2">Filial:</span>
                    <select id="cbfilialcatalogo" data-placeholder="Selecione uma opção"
                        v-model="vidfilialcatalogo"
                        data-allow-clear="true" style="width:100%;">
                    </select>
                </div>
                <div class="col-12">
                    <span class="lblselect2">Tabela:</span>
                    <select id="cbtabelacatalogo" data-placeholder="Selecione uma opção"
                        v-model="vidtabelacatalogo"
                        data-allow-clear="true" style="width:100%;">
                    </select>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-6">
                            <span class="lblselect2">Grupo:</span>
                            <select id="cbgrupocatalogo" data-placeholder="Selecione uma opção"
                                v-model="vidgrupocatalogo"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-6">
                            <span class="lblselect2">Subgrupo:</span>
                            <select id="cbsubgrupocatalogo" data-placeholder="Selecione uma opção"
                                v-model="vidsubgrupocatalogo"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>

                        <!--Luiz Trindade - Adicionar mais de uma marca na geração do catálogo-->
                        <div class="col-7">
                            <span class="lblselect2">Marca:</span>
                            <select id="cbmarcacatalogo"
                                v-model="vidmarcacatalogo"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>

                        <div class="col-5">
                            <label for="cbopestoque">Referencia:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="opref">
                                <option value="0">Sim</option>
                                <option value="1">Não</option>
                            </select>
                        </div>
                        <div class="col-12">
                            <label for="cbopsaldo">Somente com saldo:</label>
                            <select class="form-control form-control-sm" id="cbopsaldo" v-model="opsaldo">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="row">
                        <div class="col-5">
                            <label for="cbopestoque">Preço:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="oppreco">
                                <option value="0">Tabela</option>
                                <option value="1">Auxiliar</option>
                            </select>
                        </div>
                        <div class="col-5">
                            <label for="cbopestoque">Valores:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="opvalor">
                                <option value="0">Sim</option>
                                <option value="1">Não</option>
                            </select>
                        </div>

                        <div style="padding-top: 20px;" class="col-2">
                            <button  v-show="vlink === ''" type="button" @click.prevent="mtdgerarlink()" class="btn btn-primary btn-sm btn-block" ><i class="fa fa-link" aria-hidden="true"></i></button>
                            <button v-show="vlink !== ''" type="button" @click.prevent="mtdcopiarlink()" class="btn btn-primary btn-sm ver" ><i class="fa fa-clipboard"></i></button>
                        </div>
                    </div>
                </div>

                <div  v-if="vlink!==''"  style="padding-top: 10px;" class="col-sm-12 col-md-12 col-lg-12">
                    <div class="col-sm-12">
                    </div>
                    <label for="edobsmov">Link gerado</label>
                    <div class="form-group">
                        <textarea class="form-control"
                            rows="3"  v-model="vlink" v-bind:disabled="vhab" id="textolink"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button v-show="vlink !== ''" type="button" @click.prevent="abrirlink()" class="btn btn-sm ver" >Abrir</button>
                <button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdgerarcatalogo()"><i class="fa fa-print"></i> Imprimir</button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
            </div>
            </div>
        </div>
        </div>

        <!-- - Modal para exibir vendas-->
        <div class="modal fade" id="mdlvendas" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-hist-vendas">
                <div class="modal-content" style="max-height: 85vh;">
                    <!--Cabeçalho do modal-->
                    <div class="modal-header">
                        <i class="fa fa-shopping-basket" style="margin-top: 8px; margin-right: 7px"></i>
                        <h3 class="modal-title" style="color: #fff;">
                            Histórico de Vendas
                        </h3>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="container-fluid" style="margin-block: 10px;">
                        <div class="row mb-2">
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edconteudopesq">Código:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="vidprodutohisvendas" disabled>
                            </div>
                            <div class="col-sm-12 col-md-9 col-lg-9">
                                <label for="edconteudopesq">Descrição do produto:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="vdescprodutohisvendas"  disabled>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialhisvendas" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialhisvendas"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-4">
                                <span class="lblselect2">Vendedor:</span>
                                <select id="cbvendedorhisvendas" data-placeholder="Selecione uma opção"
                                    v-model="vidvendedorhisvendas"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbagruparhisvendas">Agrupar?</label>
                                <select name="cbagruparhisvendas" class="form-control form-control-sm" id="cbagruparhisvendas" v-model="pagruparhisvendas">
                                    <option value="0" selected>Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbperiodovendas">Período:</label>
                                <select name="cbperiodovendas" class="form-control form-control-sm" id="cbperiodovendas" v-model="pfiltrodatavenda">
                                    <option value="0">Não</option>
                                    <option value="1" selected>Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtinivenda" :config="options" 
                                    class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrodatavenda) == 0"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>

                            <!--Luiz Trindade - Período final-->
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddtfim">Até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfimvenda" :config="options" 
                                    class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrodatavenda) == 0"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                            </div>

                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdpesquisahistoricovendas()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                        </div>
                    </div>

                    <!--Corpo do modal-->
                    <div class="modal-body" style="max-height: 400px; overflow-y: auto;">
                        <div v-show="!isLoadingHisVendas" class="col-md-12" style="margin-top: 10px;">
                            <vue-bootstrap4-table ref="reflstvendasproduto"
                                    :rows="lstVendasProduto"
                                    :columns="columns2"
                                    :config="config2"
                                    :classes="classes">
                                <template slot="empty-results">
                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                </template>
                                <!-- ícones de ordenação da table -->
                                <template slot="sort-asc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                </template>
                                <template slot="sort-desc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                </template>
                                <template slot="no-sort-icon">
                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                </template>
                                <template slot="slot_dtfatura" slot-scope="item">
                                    <i class="fa fa-calendar-o" aria-hidden="true"></i> {{ item.row.dtfatura }}
                                </template>
                                <!--  -->
                                <template slot="slot_nomecli" slot-scope="item">
                                    <template v-if="parseInt(item.row.idcliente) > 0">
                                        {{ item.row.idcliente }} - {{ item.row.nomecli }}
                                    </template>
                                    <template v-else>
                                        <span class="badge badge-warning">Cliente não encontrado</span>
                                    </template>
                                </template>
                                <template slot="slot_vltotal" slot-scope="item">
                                    {{mtdformatavalordecimal(parseFloat(item.row.vltotal), 2)}}
                                </template>
                                <template slot="opcoes" slot-scope="item">
                                    <button type="button" class="btn btn-info btn-sm" @click.prevent="mtdinfohistvendas(item.row.idpedido)" style="width: 35px; margin-right: 8px">
                                        <i class="fa fa-info" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdimprimirhistvendas(item.row.idpedido)" style="width: 35px;">
                                        <i class="fa fa-print" aria-hidden="true"></i>
                                    </button>
                                </template>
                            </vue-bootstrap4-table>
                        </div>
                        <div v-show="isLoadingHisVendas" class="col-md-12" style="margin-top: 10px;">
                            <vue-bootstrap4-table ref="reflstvendasproduto"
                                    :rows="[{}, {}, {}]"
                                    :columns="columns2"
                                    :config="config2"
                                    :classes="classes">
                                <template slot="empty-results">
                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                </template>
                                <!-- ícones de ordenação da table -->
                                <template slot="sort-asc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                </template>
                                <template slot="sort-desc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                </template>
                                <template slot="no-sort-icon">
                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                </template>
                                <!--  -->
                                <template slot="opcoes" slot-scope="item">
                                    <skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" />
                                    <skeleton-loader-vue type="rect" :width="40" :height="20" animation="fade" />
                                </template>
                                <template slot="slot_nomecli" slot-scope="item">
                                    <skeleton-loader-vue type="rect" :width="300" :height="20" animation="fade" />
                                </template>
                                <template slot="slot_qtditem" slot-scope="item">
                                    <skeleton-loader-vue type="rect" :width="50" :height="20" animation="fade" />
                                </template>
                                <template slot="slot_vltotal" slot-scope="item">
                                    <skeleton-loader-vue type="rect" :width="100" :height="20" animation="fade" />
                                </template>
                                <template slot="slot_dtfatura" slot-scope="item">
                                    <skeleton-loader-vue type="rect" :width="100" :height="20" animation="fade" />
                                </template>
                            </vue-bootstrap4-table>
                        </div>
                    </div>
                    
                    <!--Rodapé do modal-->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm corverde" style="width: 100px;" @click.prevent="mtdgerarpdf(0)"><i class="fa fa-file-excel-o"></i> Excel </button>
					    <button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdgerarpdf(1)"><i class="fa fa-print"></i> Imprimir</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="mddetalhesproduto" tabindex="-1" aria-labelledby="mdldetalhesproduto" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdldetalhesproduto"><i class="fa fa-info-circle"></i> DETALHES DO PRODUTO {{vdetprodutos.id}} - {{vdetprodutos.descricao}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding: 10px 0px 10px 0px;">
                        <div class="container-fluid" >
                            <div class="col-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <!-- detalhes -->
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvdetalhes">Detalhes</a>
                                    </li>
                                    <!-- classes de imposto -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvclassesdet">Classes</a>
                                    </li>
                                    <!-- detalhes -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" @click.prevent="mtdvisualizarsimilares()" href="#dvsimilaridades">Similaridades</a>
                                    </li>
                                    <!-- imagens -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvimagensdet">Imagens</a>
                                    </li>
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvdetalhes" class="container-fluid tab-pane active">
                                        <div class="row" id="conteudodet" >
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Código:</label>
                                                <input type="text" class="form-control form-control-sm" v-model="vdetprodutos.id" style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label>Descriçao:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.descricao" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>   
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Referência:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.referencia" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label>Und:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.und" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Marca:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.descmarca" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Grupo:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.descgrupo" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Subgrupo:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.descsubgrupo" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Setor:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.descsetor" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Dt cadastro:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.dtcadastro" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="eddtultimavenda">Ult. venda:</label>
                                                <input type="text" v-bind:value="vdetprodutos.dtultimavenda" disabled
                                                    class="form-control form-control-sm" id="eddtultimavenda">
                                                <div class="dropdown dp-impressao-pedido">
                                                    <i v-show="parseInt(vdetprodutos.idultimavenda) > 0" class="fa fa-print icon-imprimir-pedido dropdown-toggle" title="Imprimir pedido" data-toggle="dropdown"></i>
                                                    <div class="dropdown-menu">
                                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(vdetprodutos.idultimavenda, 0)">Padrão</a>
                                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(vdetprodutos.idultimavenda, 1)">Cupom</a>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label>Frac.:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="parseInt(vdetprodutos.fracionado) === 1 ? 'Sim' : 'Não'" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Ncm:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.idncm" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Cest:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.idcest" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div style="padding-top: 20px;" class="col-sm-2 col-md-1 col-lg-1">
                                                <span v-if="parseInt(vdetprodutos.stpro) === 1" style="background-color: #0acf97;" class="badge badge-primary btn-block badge-pill">Ativo</span>
                                                <span v-else  class="badge badge-danger btn-block badge-pill">Inativo</span>
                                            </div>
                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <label>Especificações:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="vdetprodutos.especificacao" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div style="padding-top: 20px;" class="col-sm-12 col-md-6 col-lg-6">
                                                <div class="row">
                                                    <div style="width: 100%; padding: 20px; border: none;" class="card">
                                                        <div class="card-body">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Códigos</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="vdetprodutos.codigos.length === 0">
                                                                        <td colspan="1">Sem códigos</td>
                                                                    </tr>
                                                                    <tr v-for="(codigo, indexc) in vdetprodutos.codigos" :key="indexc" v-else>
                                                                        <td>{{codigo.codigo}}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="padding-top: 20px;" class="col-sm-12 col-md-6 col-lg-6">
                                                <div class="row">
                                                    <div style="width: 100%; padding: 20px; border: none;" class="card">
                                                        <div class="card-body">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Filial</th>
                                                                        <th>Estoque</th>
                                                                        <th>Localização</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="vdetprodutos.localizacoes.length === 0">
                                                                        <td colspan="3">Sem localizações</td>
                                                                    </tr>
                                                                    <tr v-for="(localiza, indexl) in vdetprodutos.localizacoes" :key="indexl" v-else>
                                                                        <td>{{localiza.fantasia}}</td>
                                                                        <td>{{localiza.descestoque}}</td>
                                                                        <td>{{localiza.desclocalizacao}}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <label>Observações:</label>
                                                        <textarea class="form-control center" rows="8" id="txtobs" v-model="vdetprodutos.observacoes" disabled></textarea>
                                                    </div>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                    <div id="dvsimilaridades" class="container-fluid tab-pane">
                                        <!-- similaridades -->   
                                        <div class="col-md-12">
                                            <div class="card card-in">
                                                <div class="card-header">PRODUTOS SIMILARES À: {{ vdetprodutos.id }} - {{ vdetprodutos.descricao }}</div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                    <thead class="thead-light">
                                                    <tr>
                                                        <th>Código:</th>
                                                        <th>Descrição:</th>
                                                        <th>Und:</th>
                                                        <th>Referência:</th>
                                                        <th>Pr. Tabela:</th>
                                                        <th>Estoque</th>                                                                                                
                                                    </tr>
                                                    </thead>
                                                    <tbody v-show="isloadingtable" style="font-weight: normal;">
                                                        <tr>                                                          
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /> </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-show="!isloadingtable" style="font-weight: normal;">
                                                        <tr v-for="(produto, index) in lstsimilares" v-bind:key="index">                                                        
                                                            <td>{{ produto.id }}</td>
                                                            <td>{{ produto.descricao }}</td>
                                                            <td>{{ produto.und }}</td>
                                                            <td>{{ produto.referencia }}</td>
                                                            <td style="text-align: right;"><strong>{{formatavalores(produto.prtabela)}}</strong></td>
                                                            <td style="text-align: right;">{{ produto.quantidade }}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-show="lstsimilares.length === 0 && !isloadingtable" style="font-weight: normal;">
                                                        <tr >                                                        
                                                            <td colspan="6" style="text-align: center;" >Sem similaridades</td>
                                                        </tr>
                                                    </tbody>
                                                    
                                                </table>
                                            </div>                                                        
                                        </div>                        
                                        <div class="col-md-10">
                                        </div>                  
                                    </div>

                                    <div id="dvclassesdet" class="container-fluid tab-pane">
                                        <div style="width: 100%; padding: 20px; border: none;" class="card">
                                            <div class="card-body">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Filial</th>
                                                            <th>Classe</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="vdetprodutos.classes.length === 0">
                                                            <td colspan="2" style="text-align: center;">Sem classes de imposto definidas</td>
                                                        </tr>
                                                        <tr v-for="(classe, indexc) in vdetprodutos.classes" :key="indexc" v-else>
                                                            <td>{{classe.fantasia}}</td>
                                                            <td>{{classe.idcfop +" - "+ classe.descclasse}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
            
                                    <div id="dvimagensdet" class="container-fluid tab-pane">
                                        <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                            <div v-if="vdetprodutos.imagens.length > 0" class="row">
                                                <div v-for="(imagem, index) in vdetprodutos.imagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">
                                                    <img style="object-fit: cover; width: 200px !important; height: 200px; padding: 30px;"  v-bind:src="pathimgview+imagem.patharquivo">
                                                </div>
                                            </div>
                                            <div v-else class="row">
                                                <div class="col-md-12 text-center">
                                                    <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>					                            
                        </div>
					</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>					
				</div>
			</div>
		</div>

         <!-- Atribuir classe por NCM com planilha -->
         <div class="modal fade" id="mdajustarcusto" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Ajustar custo dos produtos via arquivo</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                
                        <div class="row">
                            <div class="col-md-12" style="padding-bottom: 15px!important;">
                                <h1 style="color: #0acf97!important;" class="text-info">Ajuste de preço de custo via arquivo</h1>
                            </div>
                            <div class="col-md-12">
                                <p style="text-indent: 1.5em; font-size: 16px; color: #f82b54;">
                                    Atenção: não realize este procedimento se não tiver certeza de como executá-lo corretamente.</p>
                                <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                    É importante adicionar o cabeçalho.
                                </p>
                                <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                    Esse módulo atualizará o preço de custo dos produtos com base em seu cadastro e na fórmula da filial informada no arquivo
                                </p>
                                <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                Importe uma planilha no formato xls contendo as informações de CÓDIGO DE PRODUTO e CÓDIGO DA FILIAL conforme diagrama abaixo: 
                                </p>
                            </div>
                            <div class="col-md-12" >
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th scope="col">IDPRODUTO</th>
                                        <th scope="col">IDFILIAL</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        
                                        <td>121</td>
                                        <td>1</td>
                                    </tr>
                                    <tr>
                                        <td>122</td>
                                        <td>1</td>
                                    </tr>
                                    
                                    </tbody>
                                </table>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-12">
                                <input
                                type="file"
                                id="ipselecionararquivocusto"
                                accept=".xls"
                                @change="(event) => mtdselecionararquivocusto(event, 1)"
                                style="display: none;"
                                ref="if_selecionarquivocusto">
                                <button type="button" @click="$refs.if_selecionarquivocusto.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                    Enviar arquivo
                                </button>
                            </div>
                        </div>
                              
               




                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL DE EXPORTAÇÂO DE NOTA FORNECEDORES -->
         <div class="modal fade" id="mdlexportanota" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <span>Exportar notas de entrada</span>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="ednumeropesq">Número:</label>
                                <input id="ednumeropesq" type="text" class="form-control form-control-sm" v-model="pnumeronota" @keyup="mtdlimpar_listagem()" v-mask="'###########'">
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" @click.prevent="mtdexportarnota()"><i class="fa fa-download"></i> Exportar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
	import DetalhesPedido from '../components/cmpdetalhespedido.vue'
    import Consultanotafor from '../components/cmpconsultanotasfor.vue'	
    import DetalhesProdutos from '../components/cmpdetalhesprodutos'
    import VisualizadorEstoque from '../components/cmpvisualizadorestoque'
    import FornecedoresProduto from '../components/cmpfornecedoresproduto'
    import ConsultaProdutosNostaFor from '../components/cmpconsultaprodutosnotafor.vue'
    import cmpselecionarimagem from '../components/cmpselecionarimagem.vue'
    import util from '../utilitarios/util.js'
    import Enviarprodutocoletor from '../components/cmpenviaprodutocoletor.vue'

    export default {
        name: 'cadprodutos',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'            : BreadCrumb,
            'visualizadorestoque'   : VisualizadorEstoque,
            'fornecedoresproduto'   : FornecedoresProduto,
			'detalhespedido'  		: DetalhesPedido,
            'detalhesprodutos'      : DetalhesProdutos,
            'consultanotafor'       : Consultanotafor,
            'consultaprodutos'      : ConsultarProdutos,
            ConsultaProdutosNostaFor,
            cmpselecionarimagem,
            'enviarprodutocoletor'     : Enviarprodutocoletor,
        },
        data: function() {
            return {
                //variável para detalhes do pedido
                popDetVariacaoCor : false,
				vidpedidodet : '',
                imgprodutocmp: null,

                //detalhes produtos
                vdetprodutos    : {
                    id          : '',
                    descricao   : '',
                    referencia  : '',
                    codigos     : [],
                    localizacoes: [],
                    imagens     : [],
                    classes     : [],
                    observacoes : '',
                    
                    dtcadastro    : '',
                    descmarca     : '',
                    descgrupo     : '',
                    descsubgrupo  : '',
                    descsetor     : '',
                    und           : '',
                    especificacao : '',
                    idncm         : 0,
                    idcest        : 0,
                    tipo          : '',
                    fracionado    : '',
                    stpro         : '',
                    idultimavenda : 0,
                    dtultimavenda : '',
                },
                lstsimilares    : [], 
                isloadingtable  : false,

                isLoadingHisVendas: false,
                //variáveis do leitor de código de barras
                mostrandomodal      : false,
                readerSize: {
                    width: 640,
                    height: 480
                },
                detecteds    : [],
                produto      : [],
                produtomenu  : [],
                lstprodutos  : [],
                pfiltro      : 1,
                pconteudo     : '',
                pespecificacao: '',
                pstpro       : 2,
                pidmarca     : null,
                pidgrupo     : null,
                pidsubgrupo  : null,
                pidsetor     : null,
                pidncm       : null,
                pidfiliallocalizacao: null,
                pidlocalizacao: null,
                pfracionado  : 2,
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,
                pmaisfiltros : false,
                pdtini       : util.DataAtual(true),
				pdtfim       : util.DataAtual(true),
                pfiltrocadastropesq : 4,
                pdiasemovimento     : 0,
                pfiltroncmpesq      : 2,
                pfiltrodtvencimento : 3,

                //variáveis do crud
                opcrud                  : 0,
                vid                     : '',
                vdescricao              : '',
                vreferencia             : '',
                vstpro                  : 1,
                vdtcadastro             : '',
                vdtultimavenda          : null,
                vidultimavenda          : 0,
                vecommerce              : false,
                vidmarca                : null,
                vidgrupo                : null,
                vidsubgrupo             : null,
                vidsetorproduto         : null,
                vund                    : null,
                vdiasvalidade           : 0,
                vreg                    : 0,
                vfracionado             : 0,
                vtipo                   : 0,
                vcontrolaserial         : 0,
                vestoqueminimo          : 0,
                vestoquemaximo          : 0,
                vespecificacao          : '',
                vprcompra               : 0,
                vpipi                   : 0,
                vpicms                  : 0,
                vpfrete                 : 0,
                vppis                   : 0,
                vfatcomis               : 0,
                vpcofins                : 0,
                vpoutros                : 0,
                vbcst                   : 0,
                vcalculasubstributaria  : 0,
                vpst                    : 0,
                vvst                    : 0,
                vprcusto                : 0,
                vcalcularprvendamedio   : false,
                vmargemprcusto          : 0,
                vprvendamedio           : 0,
                vidncm                  : null,
                vidcest                 : null,
                vidsituacaotributaria   : null,
                vtipoproduto            : 0,
                vorigemproduto          : 0,
                vprodutoespecifico      : 0,
                vprodescala             : 0,
                vcnpjfabricante         : '',
                vpercglp                : 0,
                vpercgnn                : 0,
                vpercgni                : 0,
                vvlpartida              : 0,
                vidanp                  : null,
                vpathimagens            : '',
                vobservacoes            : '',
                utrib                 : '',
                qtrib                 : 1,
                vprvendaminimo          : 0,
                lstTabelasPrecos        : [],
                lstCodigos              : [],
                lstLocalizacaoProduto   : [],
                lstClassesProduto       : [],
                lstsimilaridades        : [],
                positionscroll          : 0,
                vfatorconver            : 0,
                vunimaior               : null,
                vdtvalidade             : '',
                vpeso                   : 0,
                vdiametro               : 0,

                lstfiliaisproduto       : [],

                //Luiz Trindade - Variáveis referntes à vendas
                lstVendasProduto        : [],

                //variáveis do cashback
                vvlcreditoacumulaavista : 0,
                vvlcreditoacumulaaprazo : 0,

                //variaveis geração de catalogo
                vidfilialcatalogo       : null,
                vidtabelacatalogo       : null,
                vlink                   : '',
                vhab                    : true,
                oppreco                 : 0,
                opvalor                 : 0,  //0 - sim    1 - não
                vidmarcacatalogo        : [],
                vidgrupocatalogo        : null,
                vidsubgrupocatalogo     : null,
                opref                   : 0,
                opsaldo                 : 0, 

                //variável para habilitação dos campos
                ativadesativa           : true,

                //variáveis da rotina de tabelas de preços
                habdestab               : false,
                voptabela               : 1,
                vidtabelapreco          : null,
                vmrgtabela              : 0,
                vtipoatribuicaotbpr     : 0,
                vvltabela               : 0,
                vvlnf                   : 0,
                vcomissaotabela         : 0,
                vqtdmintabela           : 0,
                vdescontotabela         : 0,
                vvldescpromocional      : 0,
                vvlvizu                 : 0,
                vidtodastb              : false,
                todastabelas            : [],

                // Variáveis para pesquisa de data para filtro de período de venda
                prodAtualHisVendas      : [],
                vidprodutohisvendas     : 0,
                vdescprodutohisvendas   : '',
                pagruparhisvendas       : "0",
                pdtinivenda             : util.DataAtual(true, false),
                pdtfimvenda             : util.DataAtual(true, false),
                pfiltrodatavenda        : "1",
                vidfilialhisvendas      : null,
                vidvendedorhisvendas    : null,

                //variaveis da consulta de produtos
				vshowprtabela			    : false,//oculta a visualização do preço do produto na listagem
				vidtabela				    : 1,//informo somente pq o componente exige
                tipopropesquisa             : '',
                vindicevariacoproduto       : null,
                vtpvariacaoproduto          : '', // 'cor', 'tamanho'
                loadervariacaoproduto       : false,


                //volume do produto
                
                valtura                 : 0,
                vlargura                : 0,
                vprofundidade           : 0,
                tpObjeto      : null,


                //códigos
                vcodigoinc              : '',
                ///////////////////////////////////
                //localizações
                vidfiliallocalizacao : null,
                videstoquelocalizacao: null,
                vidlocalizacao       : null,
                //classes
                vidclasse            : null,
                vidfilialclasse      : null,

                //destaques de produtos
                vidfilialdestaque    : null,
                viddestaque          : null,
                lstdestaquesprodutos : [],

                vadesivodestaque     : '',
                vcordestaque         : '',


                //similaridades
                vreferenciasimilarinc: '',

                //rotina imagens
                arqimgselecionado    : null,
                lstImagens           : [],

                //pega o path do diretorio padrão das imagens
                pathimgview          : this.$store.state.configpaths.pathimagens,

                //ajuste de estoque
                vidfilialajuste      : null,
                vidproduto           : null,
                vdescpro             : '',
                vunidadepro          : '',
                videstoque           : null,
                vqtdmov              :  1,
                vvlmov               :  0,
                vdocmov              : '',
                vdtmov               : util.DataAtual(true),
                vtpmov               :  0,
                vperda               :  0,
                vobsmov              : '',
                vqtdanterior         :  0,
                vundanterior         : '',
                vqtdatualizada       :  0,
                msgTitAjuste         : '',
                vprofracionado       :  0,


                //ajuste de estoque rápido
                vidfilialajuster      : null,
                vcodpescajuste        : '',
                vidprodutor           : null,
                vdescpror             : '',
                vunidadepror          : '',
                videstoquer           : null,
                vqtdmovr              :  1,
                vvlmovr               :  0,
                vdocmovr              : '',
                vdtmovr               : util.DataAtual(true),
                vtpmovr               :  0,
                vperdar               :  0,
                vobsmovr              : '',
                vqtdanteriorr         :  0,
                vundanteriorr         : '',
                vqtdatualizadar       :  0,
                msgTitAjuster         : '',
                vprofracionador       :  0,
                vachouprodutoajuste   : false,


                //atribuição de classe para os produtos
                vopcaoclasseatribuir        : 0,
                vidfilialatribuir           : null,
                vidclasseatribuir           : null,
                vatribuitodosprodutos       : false,

                vopcaoclasseatribuirfiltro  : 0,
                
                vidfilialatribuirclasse     : null,
                vidclasseatribuirclasse     : null,
                vidmarcaatribuirclasse      : null,
                vidgrupoatribuirclasse      : null,
                vidsubgrupoatribuirclasse   : null,
                vidsetoratribuirclasse      : null,
                vidncmatribuirclasse        : null,
                vistproatribuirclasse       : 2,
                vidfracionadoatribuirclasse : 2,

                // Exportação de notas de entrada
                pidfornecedor               : null,
                pnumeronota                 : "",

                //atribuição de campos
                vatribuirsituacao   : false,
                vsituacaocampos     : 1,
                vatribuirreferencia : false,
                vreferenciacampos   : '',

                vatribuirfracionado : false,
                vfracionadocampos   : 1,

                vatribuiridunidade  : false,
                vidunidadecampos    : null,

                vatribuiridmarca    : false,
                vidmarcacampos      : null,

                vatribuiridgrupo    : false,
                vidgrupocampos      : null,

                vatribuiridsubgrupo : false,
                vidsubgrupocampos   : null,

                vatribuiridncm      : false,
                vidncmcampos        : null,

                vatribuiridcest     : false,
                vidcestcampos       : null,

                vatribuircomis      : false,//guga atribuir comissão
                valcomis            : 0,
                
                vatribuirvalidade   : false, 
	            vdiasvalidadeatr    : 0,

                vatribuirecommerce  : false,
                vecommerceatr       : 0,


                vatribuirlocalizacao  : false,
                vidfilialatribuirloc  : null,
                vidlocalizacaoatribuir: null,

                vatribuirsetor        : false,
                vidsetorprodutoatribuir: null,
                
                vatribuircbavista      : false,
                valcashbackavista      : 0,

                vatribuircbaprazo      : false,
                valcashbackaprazo      : 0,


                consultarprodutos   : false,

                //variaveis atribuição de tabelas
                vidtabelaatribuir               : null,
                vtipoatribuirtabela             : 0,
                vmrgtabelaatribuir              : 0,
                vprecoatribuir                  : 0,
                vcomissaotabelaatribuir         : 0,
                vqtdmintabelaatribuir           : 0,
                vdescontotabelaatribuir         : 0,

                vopatribuicaotabela             : 0,
                vidtabelaatribuirorigem         : null,
                vidtabelaatribuirdestino        : null,
                vmrgtabelabaseoutra             : 0,
                vidatribuitodastb               : false,

                vdatatabelaatribuirdestino      : [],
                vSelecionaTodasTabelas          : false,
                vdataoperacoestabela            : [],
                vSelecionaTodasOperacoesTabelas : false,


                // atrubuir Desconto qtd. min em massa

                vidatribuirdescontoqtdmin    : null,
                vqtdmindescatribuir          : 0,
                vdescontodescatribuir        : 0,


                  //atribuir CASHBACK em massa 

                vopcaocbatribuir      : 0,
                vidtabelacbatr        : null, 
                vidmarcaatribuircb    : null,
                vidgrupoatribuircb    : null,
                vidsubgrupoatribuircb : null,
                vidsetoratribuircb    : null,
                vidncmatribuircb      : null,
                vistproatribuircb     : 2,
                valcashbackavistamassa: 0,
                valcashbackaprazomassa: 0,
                vatribuircbaprazomassa: false,
                vatribuircbavistamassa: false,

                //id do produto para visualização
                idprodutoestoque    : 0,
                descproestoque      : '',

                //para visualização dos fornecedores
                idprodutofornecedores    : 0,
                descprofornecedores       : '',

                //variável da importação
                vlimpardados            : false,
                arqselecionado          : null,
                vimportarcodigos        : false,
                vreconstruirchaves      : false,

                //variáveis para variações de produto - inicialmente vazio
                variacoesProduto        : [],
                produtoAtualCor         : '',
                produtoAtualTamanho     : '',

                //variáveis para geração de arquivos
                vtipoarquivo             : 0,
                vidfilialarquivo         : null,
                vidncmarquivo            : null,
                vidclassearquivo         : null,
                videstoquearquivo        : null,
                vidtabelaarquivo         : null,
                vidmarcaarquivo          : null,
                vidgrupoarquivo          : null,
                vidsubgrupoarquivo       : null,
                vidsetorarquivo          : null,
                vstproarquivo            : 0,
                vfracionadoarquivo       : 2,
                vlayoutbalanca           : 1,
                vestoquearquivo          : 2,

                //Variaveis para atribuir filiais aos produtos

                vidfilialatribuirpro     : null,
                vidmarcaatribuirfilial   : null, 
                vidgrupoatribuirfilial   : null,
                vidsubgrupoatribuirfilial: null,
                vidsetoratribuirfilial   : null,
                vidncmatribuirfilial     : null,


                //variaveis da consulta por código
                pcodigoconsultar        : '',
                lstprodutoconsultacodigo: [],

                //variáveis de operações com tabelas
                otpoperacao             : 0,
                oidtabelaorigem         : null,
                oidtabelaatribuirop     : null,
                omrgtabelaatribuirop    : 0,
                oidmarcaatribuirop      : null,
                oidgrupoatribuirop      : null,
                oidsubgrupoatribuirop   : null,
                oidsetoratribuirop      : null,
                otpfatorajuste          : 0,
                ofatortabelaajuste      : 0,

                lstfornecedoresproduto  : [],

                //cadastro da localização
                vnovalocalizacao        : false,
                vdescricaolocalizacao   : '',
                vidnovalocalizacao      : '',

                //variáveis para processar arquivo de códigos
                vnomearquivo            : '',

                //variáveis do calculo do imposto sobre o valor
                ivalorbase              : 0,
                iidclasse               : null,
                iclasse                 : [],
                ivalorimposto           : 0,
                ivalorcomimposto        : 0,

                vistproatribuirfilial    : "2",
                vopcaoatribuirfilial     : "0",

                //variáveis para atribuição da margem
                amargem                  : 0,
	            avalor                   : 0,

                //variáveis para atruibuir percentual do desconto promocional
                avalorsemdescpromocional : 0,
                avalorcomdescpromocional : 0,
                amargemdescpromocional   : 0,

                //variáveis para exportação para o excel
                //caso queira exportar todo o conteúdo não informar o json_fields na declaração do componente

                produtosporfilial           : 0,

                vidfilialproduto            : null, 
                
                produtocoletor              : [],
                qtdenviarcoletor            : 1,

                lstprodutosexportar         : [],
                json_fields: {
                            'Código'        : 'id',
                            'Descricão'     : 'descricao',
                            'Und'           : 'und',
                            'Referência'    : 'referencia',
                            'Especifições'  : 'especificacao',
                            'Marca'         : 'descmarca',
                            'Grupo'         : 'descgrupo',
                            'Subgrupo'      : 'descsubgrupo',
                            'Setor'         : 'descsetor',
                            'Estoque mínimo': 'estoqueminimo',
                            'Estoque máximo': 'estoquemaximo',
                            'Estoque'       : 'quantidadeexp',
                            'Pr. Custo'     : 'prcustoexp'  ,
                            'Pr. Venda'     : 'prvendamedioexp',
                            'Localização'   : 'localizacao',
                            'NCM'           : 'idncm',
                            'CEST'          : 'idcest',
                            'cst'           : 'cst',
                            'Perc. ICMS'    : 'picms',
                            'Perc. IPI'     : 'pipi',
                            'Perc. COFINS'  : 'pcofins',
                            'Perc. ST'      : 'pst',
                            'Valor. ST'     : 'vst',
                            'cfop'          : 'cfop',
                            'cstpiscofins'  : 'cstpiscofins',
                            'ppis'          : 'ppis',
                            'pcofins'       : 'pcofins',
                            'ppisst'        : 'ppisst',
                            'pcofinsst'     : 'pcofinsst',
                            'codigobarras'  : 'codigobarras',

                            //Luiz Trindade - comissão
                            'Comissão'      : 'fatcomissao'
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
                ///////////////////////////////
				options: {
					format          : 'DD/MM/YYYY',
					useCurrent      : false,
					locale          : 'pt-BR'
				},
                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                moneyD: {
                    decimal         : '.',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                quantidade: {
                    decimal       : ',',
                    thousands     : '.',
                    prefix        : '',
                    precision     : 3,
                    masked        : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PRODUTOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-produto",
                        sort: false
                    },
                    {
                        label: "",
                        name: "stpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "",
                        name: "imagemproduto",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: false,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "slot_imgproduto",
                        row_classes: "def-col-img-lst-produto"
                    },   
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Situação",
                        name: "stpro",
                        sort: true,
                        slot_name: "situacao_produto"
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Especificações",
                        name: "especificacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Marca",
                        name: "descmarca",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Grupo",
                        name: "descgrupo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Subgrupo",
                        name: "descsubgrupo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Setor",
                        name: "descsetor",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Localização",
                        name: "localizacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Estoque",
                        name: "quantidade",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: "slot_qtd_estoque",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "NCM",
                        name: "idncm",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    //Luiz Trindade - Exibição da comissão de venda do produto na tabela 
                    {
                        label: "Comissão",
                        name: "fatcomissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Preços",
                        name: "precos",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_precos",
                        row_classes: "def-col-slot-precos"
                    },
                    {
                        label: "Dt. Validade",
                        name: "Dtvalidade",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_validade",
                        row_classes: "def-col-slot-validade"
                    }
                ],
                columns2: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-hist-vendas",
                        sort: false
                    },
                    {
                        label: "Nome do cliente",
                        name: "nomecli",
                        initial_sort_order: 'asc',
                        sort: false,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_nomecli"
                    },
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",
                        slot_name: "slot_qtditem"
                    },
                    {
                        label: "Total vendido",
                        name: "vltotal",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",
                        slot_name: "slot_vltotal"
                    },
                    {
                        label: "Data da venda",
                        name: "dtfatura",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: false,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",
                        slot_name: "slot_dtfatura"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },

                    show_refresh_button : false,
                    show_reset_button : false
                },
                config2: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },

                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdConsultaOperacoesTabelas(){
                let vself = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    // {parametro: 'filtro',       valor : ' and id='+vself.vidtabelapreco},
                    {parametro: 'limit',        valor : 999999},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                retorno.then(function (response) {
                    // if (parseInt(vself.voptabela) === 1) {
                        vself.vdataoperacoestabela = response.data.map(t => ({
                            ...t,
                            selecionado: false,
                            margem: t.margem ?? 0
                        }));
                    // }
                    loader.hide();
                }).catch(function (response) {
                    console.log(response);
                    loader.hide();
                });
            },
            mtdSelecionarTodasOperacoesTabelas() {
                this.vdataoperacoestabela
                    .filter(t => t.id != this.oidtabelaorigem)
                    .forEach(t => {
                        t.selecionado = this.vSelecionaTodasOperacoesTabelas;
                    });
            },
            mtdSelecionarTodasTabelas() {
                this.vdatatabelaatribuirdestino
                    .filter(t => t.id != this.vidtabelaatribuirorigem)
                    .forEach(t => {
                        t.selecionado = this.vSelecionaTodasTabelas;
                    });
            },
            mtdConsultaTabelasAtribuir(){''
                let vself = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    // {parametro: 'filtro',       valor : ' and id='+vself.vidtabelapreco},
                    {parametro: 'limit',        valor : 999999},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                retorno.then(function (response) {
                    if (parseInt(vself.voptabela) === 1) {
                        vself.vdatatabelaatribuirdestino = response.data.map(t => ({
                            ...t,
                            selecionado: false,
                            margem: t.margem ?? 0
                        }));
                    }
                    loader.hide();
                }).catch(function (response) {
                    console.log(response);
                    loader.hide();
                });
            },

            // Métodos para variações de produto
            mtdadicionarvariacao() {
                // Adiciona uma nova linha vazia ao array
                this.variacoesProduto.push({ 
                    cor: '', 
                    tamanho: '',
                    showTooltip: false 
                });
            },

            mtdexcluirvariacao(index) {
                // Remove a variação
                this.variacoesProduto.splice(index, 1);
            },

            mtdconsultarprodutovariacoes(index) {
                this.vtpvariacaoproduto = 'variacao';
                this.vindicevariacoproduto = index;
                let payload = {
                    abrirtela: true			
                };
                this.$store.commit('CONSULTA_PRODUTO_CHANGE', payload);
                let payloadx = {
                    idproduto: null			
                };
                this.$store.commit('PRODUTO_RETORNO_CHANGE', payloadx);
            },


            mtddefinefiliaislista(){

                if(!util.opcaousuario('002Z.002M.009M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    return;
                }

                $('#cbfilialatribuirpro').val(null).trigger('change');
                $('#cbmarcaatrfil').val(null).trigger('change');
                $('#cbsubgrupoatrfil').val(null).trigger('change');
                $('#cbsetoratrfil').val(null).trigger('change');
                $('#cbncmatrfil').val(null).trigger('change');

                this.vidfilialatribuirpro      = null;
                this.vidmarcaatribuirfilial    = null;
                this.vidgrupoatribuirfilial    = null;
                this.vidsubgrupoatribuirfilial = null;
                this.vidsetoratribuirfilial    = null;
                this.vidncmatribuirfilial      = null;



                $('#mdatribuirfil').modal('show');

            },

            mtdconfirmadefinefiliaislista(){
                let vself = this;
        
                let rfiltro    = '';

            

                if(vself.vidfilialatribuirpro === null){
                    vself.$toastr.w('Selecione a filial para atribuir!', 'Informação!');
                    return
                }
                if (parseInt(vself.vistproatribuirfilial) < 2){
                    rfiltro = rfiltro + ' and p.stpro='+vself.vistproatribuirfilial;
                }
                if (vself.vidmarcaatribuirfilial !== null){
                    rfiltro = rfiltro + ' and p.idmarca='+vself.vidmarcaatribuirfilial;
                }
                if (vself.vidgrupoatribuirfilial !== null){
                    rfiltro = rfiltro + ' and p.idgrupo='+vself.vidgrupoatribuirfilial;
                }
                if (vself.vidsubgrupoatribuirfilial !== null){
                    rfiltro = rfiltro + ' and p.idsubgrupo='+vself.vidsubgrupoatribuirfilial;
                }
                if (vself.vidsetoratribuirfilial !== null){
                    rfiltro = rfiltro + ' and p.idsetor='+vself.vidsetoratribuirfilial;
                }
                if (vself.vidncmatribuirfilial !== null){
                    rfiltro = rfiltro + ' and p.idncm='+vself.vidncmatribuirfilial;
                }
                
            
                let loader     = vself.$loading.show();
                let parametros      = [
                    {parametro: 'op',               valor  : 'atribuirfiliaisfiltros'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtroupdate',     valor  : rfiltro},
                    {parametro: 'opatribuir',       valor  : vself.vopcaocbatribuir},
                    {parametro: 'idfilialatribuir', valor  : vself.vidfilialatribuirpro},
                    {parametro: 'idfilial',         valor  : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor  : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor  : '002Z.002M.010M'},

                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        $('#mdatribuirfil').modal('hide');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },

            mtddeletarfilialproduto(index){
                this.lstfiliaisproduto.splice(index, 1);
            },
            
            mtdincfilialproduto(){
                  if (this.vidfilialproduto === null){
                    this.$toastr.i('Filial deve ser informada!', 'Informação!');
                    $("#btincfilialproduto").focus();
                    return;
                }
                if (!util.findValInArray(this.lstfiliaisproduto, 'id', this.vidfilialproduto)) {
                    let plano_tmp = {
                        'idfilial'   : this.vidfilialproduto,
                        'fantasia'  : $('#cbfilialproduto').select2('data')[0]['text']
                    };
                    this.lstfiliaisproduto.push(plano_tmp);
                    $("#cbfilialproduto").val('').trigger('change');
                    this.vidfilialproduto  = null;
                }else{
                    this.$toastr.w('Filial já informada!', 'Warning!'); 
                }

            },
            DefineTpObjeto(format) {
                this.tpObjeto = format;
            },
            mtdrotinaartcashbackmassa(){
                $('#cbtabelaatribuircashback').val(null).trigger('change');
                $('#cbmarcaatrcb').val(null).trigger('change');
                $('#cbgrupoatrcb').val(null).trigger('change');
                $('#cbsubgrupoatrcb').val(null).trigger('change');
                $('#cbsetoratrcb').val(null).trigger('change');
                $('#cbncmatrcb').val(null).trigger('change');
               

                this.vopcaocbatribuir       = 0;
                this.vidtabelacbatr         = null;
                this.vidmarcaatribuircb     = null;
                this.vidgrupoatribuircb     = null;
                this.vidsubgrupoatribuircb  = null;
                this.vidsetoratribuircb     = null;
                this.vidncmatribuircb       = null;
                this.vistproatribuircb      = 2;
                this.valcashbackavistamassa = 0;
                this.valcashbackaprazomassa = 0;
                this.vatribuircbaprazomassa = false;
                this.vatribuircbavistamassa = false;


                $('#mdatribuircb').modal('show');
            },
            mtdatribuircashbackmassa(){
                let vself = this;
                
                let rfiltro    = '';

                if(vself.vidtabelacbatr === null){
                    vself.$toastr.w('Selecione a tabela para atribuir!', 'Informação!');
                    return
                }
                if (parseInt(vself.vistproatribuircb) < 2){
                    rfiltro = rfiltro + ' and p.stpro='+vself.vistproatribuircb;
                }
                if (vself.vidmarcaatribuircb !== null){
                    rfiltro = rfiltro + ' and p.idmarca='+vself.vidmarcaatribuircb;
                }
                if (vself.vidgrupoatribuircb !== null){
                    rfiltro = rfiltro + ' and p.idgrupo='+vself.vidgrupoatribuircb;
                }
                if (vself.vidsubgrupoatribuircb !== null){
                    rfiltro = rfiltro + ' and p.idsubgrupo='+vself.vidsubgrupoatribuircb;
                }
                if (vself.vidsetoratribuircb !== null){
                    rfiltro = rfiltro + ' and p.idsetor='+vself.vidsetoratribuircb;
                }
                if (vself.vidncmatribuircb !== null){
                    rfiltro = rfiltro + ' and p.idncm='+vself.vidncmatribuircb;
                }
                
            
                let loader     = vself.$loading.show();
                let parametros      = [
                    {parametro: 'op',               valor : 'atribuircashbackfiltros'},
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtroupdate',     valor : rfiltro},
                    {parametro: 'opatribuir',       valor : vself.vopcaocbatribuir},
                    {parametro: 'vpcashbackavista', valor : vself.valcashbackavistamassa},
                    {parametro: 'vpcashbackaprazo', valor : vself.valcashbackaprazomassa},
                    {parametro: 'tabelaatr',        valor : vself.vidtabelacbatr},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : '002Z.002M.010M'},

                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        $('#mdatribuircb').modal('hide');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdgerarpdf(exc){
                let vself   = this;
                let filtro  = vself.mtdpreparafiltrohisvendas();

                let filial  = vself.vidfilialhisvendas === null ? 'TODAS AS FILIAIS' : $('#cbfilialhisvendas').select2('data')[0]['text'];

				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadprodutos.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&oprelatorio=2'+
                            '&filtro='+filtro+
                            '&filial='+filial+
                            '&idproduto='+vself.vidprodutohisvendas+
                            '&dtini='+vself.pdtinivenda+
                            '&dtfim='+vself.pdtfimvenda+
                            '&agrupar='+vself.pagruparhisvendas+
                            '&excel='+exc+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');					                
            },
            mtdClasseSimples(regime){
                if(parseInt(regime) === 0){
                    return false;
                }
                if(parseInt(regime) === 1){
                    return true;
                }
            },
            mtdFilialSimples(regime){
                console.log(regime);
                if(parseInt(regime) === 1 || parseInt(regime) === 2){
                    return true;
                }
                if(parseInt(regime) === 3){
                    return false;
                }
            },
            mtdincluirdestaque(){
                if (this.vidfilialdestaque == null) {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialdestaque").focus();
                    return;
                }
                if (this.viddestaque == null) {
                    this.$toastr.w('O destaque de produto deve ser informada!', 'Atenção!');
                    $("#cbdestaque").focus();
                    return;
                }
                let destaques = {
                    'idfilial'             : this.vidfilialdestaque,
                    'fantasia'             : $('#cbfilialdestaque').select2('data')[0]['text'],
                    'iddestaque'           : this.viddestaque,
                    'adesivo'              : this.vadesivodestaque,
                    'cor'                  : this.vcordestaque,
                    'descdestaque'         : $('#cbdestaque').select2('data')[0]['text']
                };
                if (!this.AchaLocalizacaoFil(this.lstdestaquesprodutos, destaques)){
                    this.lstdestaquesprodutos.push(destaques);


                    this.vidfilialdestaque = null;
                    this.viddestaque       = null;
                    this.vadesivodestaque  = '';
                    this.vcordestaque      = ''; 

                    $('#cbfilialdestaque').val(null).trigger('change');
                    $('#cbdestaque').val(null).trigger('change');

                    $('#cbfilialdestaque').select2('open');

                }else{
                    this.$toastr.w('Já existe um destaque definido para a filial!', 'Atenção!');
                    $('#cbfilialdestaque').select2('open');
                }
            },
            mtddefaultajuste(){

                this.vcodpescajuste       = '';
                this.vidprodutor          = null;
                this.vdescpror            = '';
                this.vunidadepror         = '';
                this.vqtdmovr             = 1;
                this.vvlmovr              = 0;
                this.vdtmovr              = util.DataAtual(true);
                this.vtpmovr              = 0;
                this.vperdar              = 0;
                this.vobsmovr             = '';
                this.vqtdanteriorr        = 0;
                this.vundanteriorr        = '';
                this.vprofracionador      = 0;

                this.vachouprodutoajuste  = false;


                setTimeout(() => {
                    $('#edidprodutoajuste').focus();            
                }, 500);
            },
            mtdpegaquantidadeestoque(){
                let vself = this;
                if (vself.videstoquer != null) {
                    let loader      = vself.$loading.show();
                    let parametros  = [
                        {parametro: 'op',           valor : 'buscarestoque'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : ' and ep.idproduto='+vself.vidprodutor+ ' and ep.idestoque='+vself.videstoquer}
                    ];
                    let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        vself.vqtdanteriorr = parseFloat(response.data[0].quantidade);
                        loader.hide();
                    }).catch(function (response) {
                        console.log(response);
                        loader.hide();
                    });
                } else {
                    vself.vqtdanteriorr = 0;
                }  
            },
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
                    // console.log(coddig);
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',    valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ' and p.tipo in (0, 2)'},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let item = response.data[0];		
                            vself.vachouprodutoajuste  = true;
                            vself.vidprodutor          = item.id;
                            vself.vdescpror            = item.descricao;
                            vself.vunidadepror         = item.und;
                            vself.vqtdmovr             = 1;
                            vself.vvlmovr              = item.prcusto;
                            vself.vdtmovr              = util.DataAtual(true);
                            vself.vtpmovr              = 0;
                            vself.vperdar              = 0;
                            vself.vobsmovr             = '';
                            vself.vqtdanteriorr        = 0;
                            vself.vundanteriorr        = item.und;
                            vself.vprofracionador      = item.fracionado;

                            vself.mtdpegaquantidadeestoque()
				   
                            setTimeout(() => {
                                $('#edqtdmovr').focus();            
                            }, 500);
						
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							$('#edidprodutoajuste').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					$('#edidprodutoajuste').focus();
				}
            },
            mtdlocalizarprodutovariacao(idproduto){

                var vself       = this;
                vself.loadervariacaoproduto = true;
                let parametros  = [
                    {parametro: 'op',               valor : 'listaprodutovariacao'},
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idproduto',        valor : idproduto},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    vself.loadervariacaoproduto = false;
                    if (vself.vtpvariacaoproduto == 'variacao' && response.data.id > 0){
                        // Usando $set para garantir reatividade
                        vself.$set(vself.variacoesProduto[vself.vindicevariacoproduto], 'produto', response.data);
                    }
                }).catch(function (response) {
                    vself.loadervariacaoproduto = false;
                });
            },
            mtdverificaatualizacustoarquivo(){
                if(util.opcaousuario('002Z.002M.021M', this.$store.state.perfilusuario)){
                    return true;
                }else{
                    return false;
                }
            },
            mtdselecionararquivocusto(event, op){
                let vself            = this;
                vself.arqselecionado = event.target.files[0];
                let oparquivo = op;

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstprodutos= [];
                        vself.pqtd_paginas   = 0;
                    
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/ajustarprecocusto.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+
                                               '&op='+oparquivo+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&codop=002Z.002M.021M';
                        vself.arqselecionado = null;
                        window.open(url, '_blank');
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivocusto').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivocusto').val('');
                });
            },  
            mtdprocessaretornocud(produto){
                let vself       = this;
                let idproduto   = parseInt(produto);
               
                let filtro      = ' and p.id='+idproduto;
                let parametros  = [
                    {parametro: 'idclientesac',             valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens',         valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                       valor : 'listagem'},
                    {parametro: 'idusuario',                valor : vself.$store.state.usuario.id},
                    {parametro: 'todastabelas',             valor : vself.$store.state.usuario.todastabelas},
                    {parametro: 'filtro',                   valor : filtro},
                    {parametro: 'idestoque',                valor : vself.$store.state.filialpadrao.idestoque},
                    {parametro: 'limit',                    valor : '999999999'},
                    {parametro: 'offset',                   valor : '0'},
                    {parametro: 'reserva',                  valor : util.opcaousuario('002Z.002M.020M', vself.$store.state.perfilusuario) ? 1 : 0},
                    {parametro: 'estoquegeralconsultas',    valor : vself.$store.state.usuario.estoquegeralconsultas},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    let produtos = JSON.parse(JSON.stringify(vself.lstprodutos));

                    let indp = util.getArrayIndexForKey(produtos, 'id', idproduto);

                    produtos[indp] = response.data[0];
                    vself.lstprodutos = JSON.parse(JSON.stringify(produtos))

                    window.scrollTo(0, parseInt(vself.positionscroll, 10)); // Restaura a posição
                }).catch(function (response) {
                   
                });        
            },
            mtdvisualizarsimilares(){                                
                let vself           = this;
                let referencias = '';

                this.isloadingtable = true;
            
                for (let i = 0; i < vself.vdetprodutos.similaridades.length; i++) {
                    referencias = referencias + vself.vdetprodutos.similaridades[i].referencia + "', '";
                }
                referencias = "'"+referencias.slice(0, referencias.length - 3);
                let parametros      = [
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'listarsimilares'},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idtabela',         valor : vself.$store.state.filialpadrao.idtabela},
                    {parametro: 'idestoque',        valor : vself.$store.state.filialpadrao.idestoque},                    
                    {parametro: 'referencias',      valor : referencias},
                    {parametro: 'idproduto',        valor : vself.vdetprodutos.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    if (response.data.length === 0){
                        vself.isloadingtable = false;
                    }else{
                        vself.lstsimilares = [];
                        vself.lstsimilares = JSON.parse(JSON.stringify(response.data));
                        vself.isloadingtable = false;
                    }
                }).catch(function (response) {
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.isloadingtable = false;
                    vself.lstsimilares = [];
                });
            },
            mtddetalhesprodutos(produtos){
                this.vdetprodutos = JSON.parse(JSON.stringify(produtos));
                $('#mddetalhesproduto').modal('show');  
			},
            mtdbuscaimagemlistapro(produto){
                if(produto.imagens.length === 0){
                    ///retorna o sem foto
                    return this.pathimgview + '/imagens/semimagem.png';
                }else{
                    return this.pathimgview + produto.imagens[0].patharquivo;
                }

            },
            mtdverificaimportaclssencm(){
                if(util.opcaousuario('002Z.002M.008M', this.$store.state.perfilusuario)){
                    return true;
                }else{
                    return false;
                }
            },
            mtdverificaajusteestoque(){
                if(util.opcaousuario('002Z.002M.004M', this.$store.state.perfilusuario)){
                    return true;
                }else{
                    return false;
                }
            },
            mtdatribuirclassencm(){
                $("#mdatribuirclassencm").modal('show');
            },
            mtdajustarcusto(){
                $("#mdajustarcusto").modal('show');
            },
            mtdselecionararquivoncm(event, op){
                let vself            = this;
                vself.arqselecionado = event.target.files[0];
                let oparquivo = op;

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstprodutos= [];
                        vself.pqtd_paginas   = 0;
                    
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarclassencm.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+
                                               '&op='+oparquivo+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&codop=002Z.002M.008M';
                        vself.arqselecionado = null;
                        window.open(url, '_blank');
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivoncm').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivoncm').val('');
                });
            },  
            mtdrotinaclassesfiltros(){
                $('#cbfilialatribuirclasse').val(null).trigger('change');
                $('#cbclasseatribuirclasse').val(null).trigger('change');
                $('#cbmarcaatr').val(null).trigger('change');
                $('#cbgrupoatr').val(null).trigger('change');
                $('#cbsubgrupoatr').val(null).trigger('change');
                $('#cbsetoratr').val(null).trigger('change');
                $('#cbncmatr').val(null).trigger('change');
               


                this.vidfilialatribuirclasse     = null;
                this.vidclasseatribuirclasse     = null;
                this.vidmarcaatribuirclasse      = null;
                this.vidgrupoatribuirclasse      = null;
                this.vidsubgrupoatribuirclasse   = null;
                this.vidsetoratribuirclasse      = null;
                this.vidncmatribuirclasse        = null;
                this.vistproatribuirclasse       = 2;
                this.vidfracionadoatribuirclasse = 2;
                this.vopcaoclasseatribuirfiltro  = 0;


                $('#mdatribuirclassefiltro').modal('show');
            },
            mtdatribuirclassefiltro(){
                let vself = this;
    
                
                let rfiltro    = '';


                if(vself.vidfilialatribuirclasse === null){
                    vself.$toastr.w('Selecione a filial para atribuir!', 'Informação!');
                    return
                }

                
                if(vself.vidclasseatribuirclasse === null){
                    vself.$toastr.w('Selecione a classe para atribuir!', 'Informação!');
                    return
                }
                

                if (parseInt(vself.vistproatribuirclasse) < 2){
                    rfiltro = rfiltro + ' and p.stpro='+vself.vistproatribuirclasse;
                }
                if (vself.vidmarcaatribuirclasse !== null){
                    rfiltro = rfiltro + ' and p.idmarca='+vself.vidmarcaatribuirclasse;
                }
                if (vself.vidgrupoatribuirclasse !== null){
                    rfiltro = rfiltro + ' and p.idgrupo='+vself.vidgrupoatribuirclasse;
                }
                if (vself.vidsubgrupoatribuirclasse !== null){
                    rfiltro = rfiltro + ' and p.idsubgrupo='+vself.vidsubgrupoatribuirclasse;
                }
                if (vself.vidsetoratribuirclasse !== null){
                    rfiltro = rfiltro + ' and p.idsetor='+vself.vidsetoratribuirclasse;
                }
                if (vself.vidncmatribuirclasse !== null){
                    rfiltro = rfiltro + ' and p.idncm='+vself.vidncmatribuirclasse;
                }
                if (parseInt(vself.vidfracionadoatribuirclasse) < 2){
                    rfiltro = rfiltro + ' and p.fracionado='+vself.vidfracionadoatribuirclasse;
                }
                if (vself.vRegimeClasse !== vself.vCrtFilial) {
                    vself.$toastr.w('A classe selecionada não corresponde à filial selecionada. Por favor, selecione outra classe.', 'Atenção!');
                    $("#cbclasseatribuirclasse").val(null).trigger('change');
                    return;
                } 
               
                let loader     = vself.$loading.show();
                let parametros      = [
                    {parametro: 'op',               valor  : 'atribuirclassefiltro'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtroupdate',     valor  : rfiltro},
                    {parametro: 'idfilialatr',      valor  : vself.vidfilialatribuirclasse},
                    {parametro: 'idclasseatr',      valor  : vself.vidclasseatribuirclasse},
                    {parametro: 'opcaoclasse',      valor  : vself.vopcaoclasseatribuirfiltro},

                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        $('#mdatribuirclassefiltro').modal('hide');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                   
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdgerarcatalogo(){
                let vself       = this;
                let filtro      = "";
                let filialElement = $('#cbfilialcatalogo').select2('data')[0];

                let idtabelacat = vself.vidtabelacatalogo === null ? 0 : vself.vidtabelacatalogo;
                
                if(!filialElement){
                    vself.$toastr.w('Informe a filial!', 'Atenção!');
                    return
                }
                let filial = filialElement.text;

                if(vself.vidtabelacatalogo === null){
                    vself.$toastr.w('Informe a tabela de preço!', 'Atenção!');
                    return
                }

                if (vself.vidtabelacatalogo !== null){
                    filtro = filtro + ' and tp.idtabela='+vself.vidtabelacatalogo;
                }
                if (vself.vidgrupocatalogo !== null){
                    filtro = filtro + ' and g.id='+vself.vidgrupocatalogo;
                } 
                if (vself.vidsubgrupocatalogo !== null){
                    filtro = filtro + ' and sg.id='+vself.vidsubgrupocatalogo;
                } 
                // if (vself.vidmarcacatalogo !== null){
                //     filtro = filtro + ' and m.id='+vself.vidmarcacatalogo;
                // }

                //Luiz Trindade - Lógica para tratar multiplas marcas na consulta SQL 
                if (vself.vidmarcacatalogo !== []){
                    if (vself.vidmarcacatalogo.length > 0) {
                        let marcastring = vself.vidmarcacatalogo.join(',');
                        // console.log(marcastring);
                        filtro = filtro + ' and m.id in (' + marcastring + ')';
                    }
                }     
                
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadprodutos.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&oprelatorio=1'+
                            '&filtro='+filtro+
                            '&filial='+filial+
                            '&pathimg='+vself.$store.state.configpaths.pathimagens+
                            '&dirimagens='+vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente+
                            '&oppreco='+vself.oppreco+
                            '&idtabela='+idtabelacat+
                            '&opvalor='+vself.opvalor+
                            '&opref='+vself.opref+
                            '&opsaldo='+vself.opsaldo+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&ordem='+vself.pordem, '_blank');					                
            },
            removeMinusSign() {
                // Remove o caractere "-" do valor do input
                this.pdiasemovimento = this.pdiasemovimento.replace(/-/g, "");
            },
            mtdprocessanovocomcodigo(){
                var cod = this.pcodigoconsultar;
                this.mtdnovo();
                this.vcodigoinc = cod;
                this.mtdinccodigo();
                $("#mdconsultaporcodigo").modal('hide');
            },
            mtdescondescanner(){
                $("#mdlscannercode").modal('hide');
                this.mostrandomodal = false
            },
            mtdprocessacodbar(data){
                var codpro = data.codeResult.code

                this.pcodigoconsultar = codpro
                this.mtdlistarprodutosporcodigo();
                this.mtdescondescanner();
            },
            mtdscannearcode(){
                $("#mdlscannercode").modal('show');
                this.mostrandomodal = true
            },
            abrirlink(){
                window.open(this.vlink, '_blank');
            },
            mtdcopiarlink(){
                let vself = this;
                this.vhab = false;
                let textoCopiado = document.getElementById("textolink");
                setTimeout(() => {
                    textoCopiado.select();
                    document.execCommand("copy");
                }, 100);

                setTimeout(() => {
                    vself.vhab = true;
                }, 500);

                vself.$toastr.s('Copiado com sucesso!', 'Informação!');
            },
            mtdgerarlink(){
                //Luiz Trindade - Verificar se há mais de 1 marca, se sim, bloquear a geração de links
                if (this.vidmarcacatalogo.length > 1) {
                    this.$toastr.w('Não é posspivel usar o catálogo interativo com mais de uma marca, utilize o impresso!', 'Atenção!');
                    return
                }

                if(this.vidfilialcatalogo === null){
                    this.$toastr.w('Informe a filial!', 'Atenção!');
                    return
                }
                if(this.vidtabelacatalogo === null){
                    this.$toastr.w('Informe a tabela de preço!', 'Atenção!');
                    return
                }

                var marca    = this.vidmarcacatalogo.length === 0 ? 0 : this.vidmarcacatalogo
                var grupo    = this.vidgrupocatalogo === null ? 0 : this.vidgrupocatalogo
                var subgrupo = this.vidsubgrupocatalogo === null ? 0 : this.vidsubgrupocatalogo

                this.vlink =    this.$store.state.configpaths.pathcontrole+'catalago/boss.php?idcliente='+
								this.$store.state.filialpadrao.idcliente+
								'&idtabelapreco='+this.vidtabelacatalogo+
                                '&adrserver=https://'+this.$store.state.usuario.adrsrv+'/'+
                                '&idfilial='+this.vidfilialcatalogo+
                                '&oppreco='+this.oppreco+
                                '&opvalor='+this.opvalor+
                                '&marca='+marca+
                                '&grupo='+grupo+
                                '&subgrupo='+subgrupo+
                                '&opref='+this.opref+
                                '&opsaldo='+this.opsaldo+
                                '&pathimgpro='+this.$store.state.configpaths.pathimgprodutos+this.$store.state.filialpadrao.idcliente;
            },
            mtdabremodalcatalogo(){
                if (parseInt(this.$store.state.filialpadrao.plnc) < 2){
                    this.$swal.fire({
                                        position: 'bottom-end',
                                        //icon: 'success',
                                        title: 'Atenção!',
                                        html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                        showConfirmButton: false,
                                        showCloseButton: true,
                                        backdrop: false
                                    });
                    return;
                }
                $('#cbfilialcatalogo').val(null).trigger('change');
                $('#cbtabelacatalogo').val(null).trigger('change');
                $('#cbmarcacatalogo').val(null).trigger('change');
                $('#cbgrupocatalogo').val(null).trigger('change');
                $('#cbsubgrupocatalogo').val(null).trigger('change');
                this.vidfilialcatalogo       = null;
                this.vidtabelacatalogo       = null;
                this.vidmarcacatalogo        = [];
                this.vidgrupocatalogo        = null;
                this.vidsubgrupocatalogo     = null;
                this.opref                   = 0;
                this.opsaldo                 = 0;
                this.vlink                   = '';
                this.vhab                    = true;
                this.oppreco                 = 0;
                this.opvalor                 = 0;  //0 - sim    1 - não
                $('#mdcatalogo').modal('show');
            },
			mtdmostrarmenu(produto){
				this.produtomenu = produto;
				$('#mdmenuproduto').modal('show');
			},
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
            mtdconsultarproduto(){
                this.consultarprodutos = true;
				let payload = {
					abrirtela    : true,
					idprodutoret : null
				};
				this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
            },
            mtdselecionarimagem(file){
                let vself = this;
                let loader      = vself.$loading.show();
                vself.arqimgselecionado = file;
                let localsalvar = vself.$store.state.configpaths.pathimgprodutos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;
                let extarquivo = vself.arqimgselecionado.name.split('.').pop()
                let nomearquivo = '1.' + extarquivo;
                if(vself.lstImagens.length > 0){
                    nomearquivo = (parseInt(vself.lstImagens.pop().arquivo.split('.')[0]) + 1) + '.' + extarquivo;
                }

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : nomearquivo},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = vself.mtdordenaimagens(response.data.arquivos);
                        vself.arqimgselecionado = null;
                        vself.imgprodutocmp = '';

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });

            },
            mtdordenaimagens(lstimagens){
                let lstordenada = lstimagens.sort((a, b) => {
                    if (a.arquivo < b.arquivo) {
                        return -1;
                    }
                    if (a.arquivo > b.arquivo) {
                        return 1;
                    }
                    return 0;
                });
                return lstordenada;
            },
            mtdexcluirimgproduto(patharquivo){
                let vself = this;
                let loader       = vself.$loading.show();
                let localarquivo = vself.$store.state.configpaths.pathimgprodutos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}

                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem excluída com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = vself.mtdordenaimagens(response.data.arquivos);
                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},
            mtdselect2_def(){
                let vself = this;

             
                //selects das pesquisas

                $('#btselecionararquivo').change(function() {
                    vself.mtdrotinaprocessacodigos();
                });
                $('#mdlscannercode').on('hide.bs.modal', function (e) {
                    vself.mostrandomodal = false
                });
          
                $("#cbmarcapesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidmarca = $("#cbmarcapesq").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbgrupopesqlistagem").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidgrupo = $("#cbgrupopesqlistagem").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbsubgrupopesqlistagem").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidsubgrupo = $("#cbsubgrupopesqlistagem").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbsetorpesqlistagem").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidsetor = $("#cbsetorpesqlistagem").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbncmatr").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmatribuirclasse = $("#cbncmatr").val();
                });

                //selects do crud
                $("#cbunidade").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbunidades',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vund = $("#cbunidade").val();
                });
                $("#edmaioruni").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbunidades',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vunimaior = $("#edmaioruni").val();
                });
                $("#cbmarca").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarca = $("#cbmarca").val();
                });
                $("#cbgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupo = $("#cbgrupo").val();
                });
                $("#cbsubgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupo = $("#cbsubgrupo").val();
                });
                $("#cbsetorproduto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsetorproduto = $("#cbsetorproduto").val();
                });

                //select da tabelela de preços
                $("#cbtabelapreco").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelapreco = $("#cbtabelapreco").val();
                    if (vself.vidtabelapreco != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtabelapreco},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            if (parseInt(vself.voptabela) === 1){
                                vself.vmrgtabela = parseFloat(response.data[0].margem);
                                vself.vcomissaotabela = parseFloat(response.data[0].comissao);
                                vself.mtdcalculaprtabela();
                            }
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vmrgtabela = 0;
                        vself.vvlvtabela = 0;
                    }
                });
                $("#cbncmpesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidncm = $("#cbncmpesq").val();
                });

                //selects das localizações
                $("#cbfiliallocalizacao").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfiliallocalizacao = $("#cbfiliallocalizacao").val();
                });

                $("#cbestoquelocalizacao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbestoques',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.videstoquelocalizacao = $("#cbestoquelocalizacao").val();
                });                
                $("#cblocalizacao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tblocalizacoes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidlocalizacao = $("#cblocalizacao").val();
                });

                   //selects dos destques
                $("#cbfilialdestaque").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialdestaque = $("#cbfilialdestaque").val();
                });
                $("#cbdestaque").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbdestaqueprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.viddestaque = $("#cbdestaque").val();


                    if (vself.viddestaque!==null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.viddestaque},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddestaqueprodutos.php');
                        retorno.then(function (response) {

                            if(response.data.length > 0){
                                vself.vadesivodestaque = response.data[0].adesivo;
                                vself.vcordestaque     = response.data[0].cor;
                            }
                 
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                        
                    }
                });


                //selects da parte fiscal
                $("#cbncm").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncm = $("#cbncm").val();
                });
                $("#cbcest").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcests',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcest = $("#cbcest").val();
                });
                $("#cbsituacaotributaria").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsituacaotributaria',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsituacaotributaria = $("#cbsituacaotributaria").val();
                });

                $("#cbanp").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbanps',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {               
                    vself.vidanp = $("#cbanp").val();
                });


                $("#cbfilialproduto").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialproduto = $("#cbfilialproduto").val();
                });


                //selects das classes
                $("#cbclasse").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidclasse = $("#cbclasse").val();
                    if (!vself.vidclasse) return;
                    $.ajax({
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: {
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbclassesimpostos',
                            c1: 'id',
                            c2: 'regime',
                            q: vself.vidclasse 
                        },
                        success: function (data) {
                            if (data && Array.isArray(data) && data.length > 0) {
                                var itemSelecionado = data.find(function(item) {
                                    return item.id === vself.vidclasse;  
                                });

                                if (itemSelecionado) {
                                    var regimevalor = itemSelecionado.text;  // O "text" aqui é o valor "regime"
                                    vself.vRegimeClasse = vself.mtdClasseSimples(regimevalor);  
                                }
                                if (vself.vRegimeClasse !== vself.vCrtFilial) {
                                    vself.$toastr.w('A classe selecionada não corresponde à filial selecionada. Por favor, selecione outra classe.', 'Atenção!');
                                    $("#cbclasse").val(null).trigger('change');
                                    return;
                                } 
                            } else {
                                console.error("Item não encontrado ou resposta inválida:", data);
                            }
                        },
                        error: function (error) {
                            console.error("Erro ao buscar o CRT:", error);
                        }
                    });
                });
                $("#cbfilialclasse").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialclasse = $("#cbfilialclasse").val();
                    $.ajax({
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: {
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbfiliais',
                            c1: 'codfil',
                            c2: 'crt',
                            q: vself.vidfilialclasse 
                        },
                        success: function (data) {
                            if (data && Array.isArray(data) && data.length > 0) {
                                var itemSelecionado = data.find(function(item) {
                                    return item.id === vself.vidfilialclasse;  
                                });

                                if (itemSelecionado) {
                                    var crtValor = itemSelecionado.text;  // O "text" aqui é o valor "crt"
                                    vself.vCrtFilial = vself.mtdFilialSimples(crtValor);  
                                }
                            } else {
                                console.error("Item não encontrado ou resposta inválida:", data);
                            }
                        },
                        error: function (error) {
                            console.error("Erro ao buscar o CRT:", error);
                        }
                    });
                });
				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.videstoque = $("#cbestoque").val();

                    if (vself.videstoque != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'buscarestoque'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and ep.idproduto='+vself.vidproduto+ ' and ep.idestoque='+vself.videstoque}
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                        retorno.then(function (response) {
                            vself.vqtdanterior = parseFloat(response.data[0].quantidade);
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {
                        vself.vqtdanterior = 0;
                    }
                });
                $("#cbestoquerap").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.videstoquer = $("#cbestoquerap").val();

                    vself.mtdpegaquantidadeestoque();    
                });
				$("#cbfilialajuste").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
								c1: 'codfil',
								c2: 'descfil'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialajuste = $("#cbfilialajuste").val();
				});

                $("#cbfilialajusterap").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
								c1: 'codfil',
								c2: 'descfil'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialajuster = $("#cbfilialajusterap").val();
				});

                //define métodos ao sair dos campos
                $("#edmrgtabela").blur(function(){
                    vself.mtdcalculaprtabela();
                });
                $("#edvltabela").blur(function(){
                    vself.mtdcalculamrgtabela();
                });

                //atribuição de classes
                $("#cbclasseatribuir").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidclasseatribuir = $("#cbclasseatribuir").val();
                    if (!vself.vidclasseatribuir) return;
                    $.ajax({
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: {
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbclassesimpostos',
                            c1: 'id',
                            c2: 'regime',
                            q: vself.vidclasseatribuir 
                        },
                        success: function (data) {
                            if (data && Array.isArray(data) && data.length > 0) {
                                var itemSelecionado = data.find(function(item) {
                                    return item.id === vself.vidclasseatribuir;  
                                });

                                if (itemSelecionado) {
                                    var regimevalor = itemSelecionado.text;  // O "text" aqui é o valor "regime"
                                    vself.vRegimeClasse = vself.mtdClasseSimples(regimevalor);  
                                }
                                if (vself.vRegimeClasse !== vself.vCrtFilial ) {
                                    vself.$toastr.w('A classe selecionada não corresponde à filial selecionada. Por favor, selecione outra classe.', 'Atenção!');
                                    $("#cbclasseatribuir").val(null).trigger('change');
                                    return;
                                }
                            } else {
                                console.error("Item não encontrado ou resposta inválida:", data);
                            }
                        },
                        error: function (error) {
                            console.error("Erro ao buscar o CRT:", error);
                        }
                    });
                });
                $("#cbfilialatribuir").select2({
                    id: function (e) { return e.codfil },
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac: vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbfiliais',
                                c1: 'codfil',
                                c2: 'fantasia'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidfilialatribuir = $("#cbfilialatribuir").val();  

                    $.ajax({
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: {
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbfiliais',
                            c1: 'codfil',
                            c2: 'crt',
                            q: vself.vidfilialatribuir 
                        },
                        success: function (data) {
                            if (data && Array.isArray(data) && data.length > 0) {
                                var itemSelecionado = data.find(function(item) {
                                    return item.id === vself.vidfilialatribuir;  
                                });

                                if (itemSelecionado) {
                                    var crtValor = itemSelecionado.text;  // O "text" aqui é o valor "crt"
                                    vself.vCrtFilial = vself.mtdFilialSimples(crtValor);  
                                }
                            } else {
                                console.error("Item não encontrado ou resposta inválida:", data);
                            }
                        },
                        error: function (error) {
                            console.error("Erro ao buscar o CRT:", error);
                        }
                    });
                });
                
                //atribuição de classes
                $("#cbclasseatribuirclasse").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbclassesimpostos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidclasseatribuirclasse = $("#cbclasseatribuirclasse").val();
                    if (!vself.vidclasseatribuirclasse) return;
                    $.ajax({
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: {
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbclassesimpostos',
                            c1: 'id',
                            c2: 'regime',
                            q: vself.vidclasseatribuirclasse 
                        },
                        success: function (data) {
                            if (data && Array.isArray(data) && data.length > 0) {
                                var itemSelecionado = data.find(function(item) {
                                    return item.id === vself.vidclasseatribuirclasse;  
                                });

                                if (itemSelecionado) {
                                    var regimevalor = itemSelecionado.text;  // O "text" aqui é o valor "regime"
                                    vself.vRegimeClasse = vself.mtdClasseSimples(regimevalor);  
                                }
                                
                                if (vself.vRegimeClasse !== vself.vCrtFilial) {
                                    vself.$toastr.w('A classe selecionada não corresponde à filial selecionada. Por favor, selecione outra classe.', 'Atenção!');
                                    $("#cbclasseatribuirclasse").val(null).trigger('change');
                                    return;
                                }
                            } else {
                                console.error("Item não encontrado ou resposta inválida:", data);
                            }
                        },
                        error: function (error) {
                            console.error("Erro ao buscar o CRT:", error);
                        }
                    });
                });
                $("#cbfilialatribuirclasse").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialatribuirclasse = $("#cbfilialatribuirclasse").val();
                    $.ajax({
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: {
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbfiliais',
                            c1: 'codfil',
                            c2: 'crt',
                            q: vself.vidfilialatribuirclasse 
                        },
                        success: function (data) {
                            if (data && Array.isArray(data) && data.length > 0) {
                                var itemSelecionado = data.find(function(item) {
                                    return item.id === vself.vidfilialatribuirclasse;  
                                });

                                if (itemSelecionado) {
                                    var crtValor = itemSelecionado.text;  // O "text" aqui é o valor "crt"
                                    vself.vCrtFilial = vself.mtdFilialSimples(crtValor);  
                                }
                            } else {
                                console.error("Item não encontrado ou resposta inválida:", data);
                            }
                        },
                        error: function (error) {
                            console.error("Erro ao buscar o CRT:", error);
                        }
                    });
                });
          

                $("#cbfilialatribuirpro").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialatribuirpro = $("#cbfilialatribuirpro").val();             
                });

                  //filtromarca atr
                $("#cbmarcaatrfil").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbmarcas',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidmarcaatribuirfilial = $("#cbmarcaatrfil").val();
                });

                //filtrogrupo atr
                $("#cbgrupoatrfil").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidgrupoatribuirfilial = $("#cbgrupoatrfil").val();
                });

                   //filtrogrupo atr
                $("#cbsubgrupoatrfil").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsubgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsubgrupoatribuirfilial = $("#cbsubgrupoatrfil").val();
                });


                //filtrogrupo atr
                $("#cbsetoratrfil").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsetoresprodutos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsetoratribuirfilial = $("#cbsetoratrfil").val();
                });

                    //filtromarca atr
                $("#cbncmatrfil").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbmarcas',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidncmatribuirfilial = $("#cbncmatrfil").val();
                });

                //filtrogrupo atr
                $("#cbgrupoatrcb").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidgrupoatribuircb = $("#cbgrupoatrcb").val();
                });

                   //filtrogrupo atr
                $("#cbsubgrupoatrcb").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsubgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsubgrupoatribuircb = $("#cbsubgrupoatrcb").val();
                });


                //filtrogrupo atr
                $("#cbsetoratrcb").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsetoresprodutos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsetoratribuircb = $("#cbsetoratrcb").val();
                });

                $("#cbncmatrcb").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmatribuircb = $("#cbncmatrcb").val();
                });



                //filtromarca atr
                $("#cbmarcaatr").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbmarcas',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidmarcaatribuirclasse = $("#cbmarcaatr").val();
                });

                //filtrogrupo atr
                $("#cbgrupoatr").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidgrupoatribuirclasse = $("#cbgrupoatr").val();
                });

                   //filtrogrupo atr
                $("#cbsubgrupoatr").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsubgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsubgrupoatribuirclasse = $("#cbsubgrupoatr").val();
                });


                //filtrogrupo atr
                $("#cbsetoratr").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsetoresprodutos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsetoratribuirclasse = $("#cbsetoratr").val();
                });

                    //filtromarca atr
                $("#cbmarcaatrcb").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbmarcas',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidmarcaatribuircb = $("#cbmarcaatrcb").val();
                });

                //filtrogrupo atr
                $("#cbgrupoatrcb").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidgrupoatribuircb = $("#cbgrupoatrcb").val();
                });

                   //filtrogrupo atr
                $("#cbsubgrupoatrcb").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsubgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsubgrupoatribuircb = $("#cbsubgrupoatrcb").val();
                });


                //filtrogrupo atr
                $("#cbsetoratrcb").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbsetoresprodutos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }
                ).change(function () {
                    vself.vidsetoratribuircb = $("#cbsetoratrcb").val();
                });

                $("#cbncmatrcb").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmatribuircb = $("#cbncmatrcb").val();
                });

                $("#cbtabelaatribuircashback").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelacbatr = $("#cbtabelaatribuircashback").val();
                });
                // desc. qtd min
                $("#cbatribuidescqtdmin").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidatribuirdescontoqtdmin = $("#cbatribuidescqtdmin").val();
                });

                //atribuição de tabelas
                $("#cbtabelaatribuir").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelaatribuir = $("#cbtabelaatribuir").val();
                    if (vself.vidtabelaatribuir != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtabelaatribuir},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            vself.vmrgtabelaatribuir = parseFloat(response.data[0].margem);
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vmrgtabelaatribuir = 0;
                    }
                });
                $("#cbtabelaatribuirorigem").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelaatribuirorigem = $("#cbtabelaatribuirorigem").val();
                    vself.mtdConsultaTabelasAtribuir();
                });

                $("#cbtabelaatribuirdestino").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelaatribuirdestino = $("#cbtabelaatribuirdestino").val();
                    if (vself.vidtabelaatribuirdestino != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtabelaatribuirdestino},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            vself.vmrgtabelabaseoutra = parseFloat(response.data[0].margem);
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vmrgtabelabaseoutra = 0;
                    }
                });

                $('#mdatribuirtabela').on('shown.bs.modal', function (e) {
					$('#cbtabelaatribuir').select2('open');
                });
                
                //atribuição de campos
                $('#mdatribuircampos').on('shown.bs.modal', function (e) {
					$('#cbatribuirsituacao').focus();
                });
                $("#cbunidadecampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbunidades',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidunidadecampos = $("#cbunidadecampos").val();
                });
                $("#cbmarcacampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarcacampos = $("#cbmarcacampos").val();
                });
                $("#cbgrupocampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupocampos = $("#cbgrupocampos").val();
                });
                $("#cbsubgrupocampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupocampos = $("#cbsubgrupocampos").val();
                });
                $("#cbncmcampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmcampos = $("#cbncmcampos").val();
                });
                $("#cbcestcampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcests',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcestcampos = $("#cbcestcampos").val();
                });
                $("#cblocalizacaoatribuir").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tblocalizacoes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidlocalizacaoatribuir = $("#cblocalizacaoatribuir").val();
                });
                $("#cbfilialatribuirloc").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialatribuirloc = $("#cbfilialatribuirloc").val();
                });

                $("#cbsetorprodutoatribuir").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsetorprodutoatribuir = $("#cbsetorprodutoatribuir").val();
                });

                //gerarção do arquivos
                $("#cbncmarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmarquivo = $("#cbncmarquivo").val();
                });
                $("#cbclassearquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidclassearquivo = $("#cbclassearquivo").val();
                });
                $("#cbtabelaarquivo").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelaarquivo = $("#cbtabelaarquivo").val();
                });
                $("#cbmarcaarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarcaarquivo = $("#cbmarcaarquivo").val();
                });
                $("#cbgrupoarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupoarquivo = $("#cbgrupoarquivo").val();
                });
                $("#cbsubgrupoarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupoarquivo = $("#cbsubgrupoarquivo").val();
                });
                $("#cbsetorarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsetorarquivo = $("#cbsetorarquivo").val();
                });

                //operações com tabelas
                $("#cbtabelaatribuirop").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.oidtabelaatribuirop = $("#cbtabelaatribuirop").val();
                    if (vself.oidtabelaatribuirop != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.oidtabelaatribuirop},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            vself.omrgtabelaatribuirop = parseFloat(response.data[0].margem);
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.omrgtabelaatribuirop = 0;
                    }
                });
                $("#cbtabelaorigem").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.oidtabelaorigem = $("#cbtabelaorigem").val();
                    // vself.mtdConsultaOperacoesTabelas();
                });
                $("#cbmarcaatribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidmarcaatribuirop = $("#cbmarcaatribuirop").val();
                });
                $("#cbgrupoatribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidgrupoatribuirop = $("#cbgrupoatribuirop").val();
                });
                $("#cbsubgrupoatribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidsubgrupoatribuirop = $("#cbsubgrupoatribuirop").val();
                });
                $("#cbsetoratribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidsetoratribuirop = $("#cbsetoratribuirop").val();
                });

                $("#cbfilialcatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialcatalogo = $("#cbfilialcatalogo").val();
                    vself.vlink = '';
                });

                //Luiz Trindade - Multiplas marcas
                $("#cbmarcacatalogo").select2({
                        multiple: true, // Permite múltiplas seleções
                        placeholder: 'Selecione 1 ou mais marcas',
                        allowClear: true,
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarcacatalogo = $("#cbmarcacatalogo").val();
                    vself.vlink = '';
                });

                $("#cbgrupocatalogo").select2({
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupocatalogo = $("#cbgrupocatalogo").val();
                    vself.vlink = '';
                });
                $("#cbsubgrupocatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupocatalogo = $("#cbsubgrupocatalogo").val();
                    vself.vlink = '';
                });

                $("#cbtabelacatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbtabelasprecos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidtabelacatalogo = $("#cbtabelacatalogo").val();
                    vself.vlink = '';
                });

                $("#cbfilialarquivo").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialarquivo = $("#cbfilialarquivo").val();
                });

				$("#cbestoquearquivo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.videstoquearquivo = $("#cbestoquearquivo").val();
                });

                $('#mdoperacoestabelas').on('shown.bs.modal', function (e) {
					$('#mdoperacoestabelas').focus();
                });

                $('#mdgerararquivo').on('shown.bs.modal', function (e) {
					// $('#cbtabelaarquivo').select2('open');
                    $('#cbtipoarquivo').focus();
                });
                $('#mdconsultaporcodigo').on('show.bs.modal', function(e){
                    vself.pcodigoconsultar        = '';
                    vself.lstprodutoconsultacodigo = [];
                });
                $('#mdconsultaporcodigo').on('shown.bs.modal', function(e){
                    vself.pcodigoconsultar        = '';
                    vself.lstprodutoconsultacodigo = [];
                    $('#edcodigoconsultar').focus();
                });
                $("#mddetalhesproduto").on('show.bs.modal', function(){
                    $('.nav-tabs a[href="#dvdetalhes"]').tab('show');      
                });
                $("#mddetalhesproduto").on('hide.bs.modal', function(){
                    vself.vdetprodutos.id            = '';
                    vself.vdetprodutos.descricao     = '';
                    vself.vdetprodutos.referencia    = '';
                    vself.vdetprodutos.codigos       = [];
                    vself.vdetprodutos.localizacoes  = [];
                    vself.vdetprodutos.classes       = [];
                    vself.vdetprodutos.imagens       = [];
                    vself.vdetprodutos.observacoes   = '';
                    
                    vself.vdetprodutos.dtcadastro    = '';
                    vself.vdetprodutos.descmarca     = '';
                    vself.vdetprodutos.descgrupo     = '';
                    vself.vdetprodutos.descsubgrupo  = '';
                    vself.vdetprodutos.descsetor     = '';
                    vself.vdetprodutos.und           = '';
                    vself.vdetprodutos.especificacao = '';
                    vself.vdetprodutos.idncm         =  0;
                    vself.vdetprodutos.idcest        =  0;
                    vself.vdetprodutos.tipo          = '';
                    vself.vdetprodutos.fracionado    = '';
                    vself.vdetprodutos.stpro         = '';
                    vself.vdetprodutos.idultimavenda =  0;
                    vself.vdetprodutos.dtultimavenda = ''; 





                    vself.lstsimilares               = []
                });

                //classe do cálculo do imposto sobre o valor
                $('#mdimpostovalor').on('shown.bs.modal', function(e){
                    vself.ivalorbase = vself.vvltabela === 0 ? 0 : vself.vvltabela;
                    $('#edivalorbase').focus();
                });
                $("#cbiclasse").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.iidclasse = $("#cbiclasse").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and ci.id='+vself.iidclasse;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 99999999999},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.iclasse        = response.data[0];
                        vself.iclasse.campos = vself.iclasse.lstcampos;
                        console.log(vself.iclasse);
                        vself.mtdcalculavalorimpostoclasse();

                    }).catch(function (response) {
                        vself.iclasse = [];
                        loader.hide();
                    });
                });

                $("#cbfilialhisvendas").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
                                c1: 'codfil',
                                c2: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilialhisvendas = $("#cbfilialhisvendas").val();
                });

                $("#cbvendedorhisvendas").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidvendedorhisvendas = $("#cbvendedorhisvendas").val();
                });


                //calcular preço médio para o custo
                $('#mdatribuirmargem').on('shown.bs.modal', function(e){
                    vself.amargem       = vself.vmargemprcusto;
                    vself.avalor        = vself.vprvendamedio;
                    $('#edamargem').focus();
                });

                //informar o valor para o cálculo do percentual do desconto promocional
                $('#mdinformarvalordescpromocional').on('shown.bs.modal', function(e){
                    vself.avalorsemdescpromocional = vself.vvltabela;
                    vself.avalorcomdescpromocional = vself.vvltabela - (parseFloat(vself.vvltabela) * parseFloat(vself.vvldescpromocional) / 100);
                    vself.mtdcalcularvalordescpromocional();
                    $('#edvalorcomdescpromocional').focus();
                }); 
            },
            mtdmaisfiltros(){
                this.pdtini = util.DataAtual(true);
                this.pdtfim = util.DataAtual(true);
                this.pfiltrocadastropesq = 4;
                this.pfiltroncmpesq      = 2;
                this.pdiasemovimento     = 0;
                this.pfiltrodtvencimento = 3;
                if (this.pmaisfiltros === true){
                    this.pmaisfiltros = false;
                }else{
                    this.pmaisfiltros = true;
                }
            },
            mtdfiltropesquisa(){
                //console.log('iniciardep');
                let rfiltro = '';
                switch (parseInt(this.pfiltro)) {
                    case 0:
                        rfiltro = this.pconteudo === '' ? '' : ' and p.id='+this.pconteudo;
                    break;
                    case 1:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(p.descricao) like upper("'+this.pconteudo+'%")';
                    break;
                    case 2:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(p.referencia) like upper("'+this.pconteudo+'%")';
                    break;
                }
                if (parseInt(this.pstpro) < 2){
                    rfiltro = rfiltro + ' and p.stpro='+this.pstpro;
                }
                if (this.pidmarca !== null){
                    rfiltro = rfiltro + ' and p.idmarca='+this.pidmarca;
                }
                if (this.pidgrupo !== null){
                    rfiltro = rfiltro + ' and p.idgrupo='+this.pidgrupo;
                }
                if (this.pidsubgrupo !== null){
                    rfiltro = rfiltro + ' and p.idsubgrupo='+this.pidsubgrupo;
                }
                if (this.pidsetor !== null){
                    rfiltro = rfiltro + ' and p.idsetor='+this.pidsetor;
                }
                if (this.pidncm !== null){
                    rfiltro = rfiltro + ' and p.idncm='+this.pidncm;
                }
                if (parseInt(this.pfracionado) < 2){
                    rfiltro = rfiltro + ' and p.fracionado='+this.pfracionado;
                }
                if (this.pespecificacao){
                    rfiltro = rfiltro + ' and upper(p.especificacao) like upper("'+this.pespecificacao+'%")';
                }

                if((this.pidfiliallocalizacao !== null )&&(this.pidlocalizacao !== null)){
                    rfiltro = rfiltro + ' and p.id in (SELECT lp.idproduto from tblocalizacoesproduto lp where lp.idproduto = p.id and lp.idfilial = '+this.pidfiliallocalizacao+' and lp.idlocalizacao = '+this.pidlocalizacao+')'  
                }

                if (this.pmaisfiltros){
                    if (parseInt(this.pfiltrocadastropesq) < 4) {
                        if (parseInt(this.pfiltrocadastropesq) === 0) {
                            rfiltro = rfiltro + ' and p.dtcadastro between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                        } else if (parseInt(this.pfiltrocadastropesq) === 1) {
                            rfiltro = rfiltro + ' and p.dtchange between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                        } else if (parseInt(this.pfiltrocadastropesq) === 2) {
                            if (parseInt(this.pdiasemovimento) > 0) {//guga - 24/10/2024 - 🤠
                                const dataAtual = new Date();
                                const diasemovimento = parseInt(this.pdiasemovimento);
                        
                                const dataLimiteInferior = new Date();
                                dataLimiteInferior.setDate(dataAtual.getDate() - diasemovimento);

                                // const dataLimiteSuperior = new Date();
                                // dataLimiteSuperior.setDate(dataAtual.getDate() - diasemovimento + 1);

                                const formatoData = (data) => {
                                    const ano = data.getFullYear();
                                    const mes = String(data.getMonth() + 1).padStart(2, '0');
                                    const dia = String(data.getDate()).padStart(2, '0');

                                    return `${ano}-${mes}-${dia}`;
                                };

                                // Filtro para produtos com exatamente 'pdiasemovimento' dias sem vendas
                                rfiltro = rfiltro + ' and p.dtultimavenda < "' + formatoData(dataLimiteInferior) + ' 00:00:00" ';
                                // console.log(rfiltro);
                            }
                        }else if (parseInt(this.pfiltrocadastropesq) === 3) {
                            rfiltro = rfiltro + ' and p.dtvalidade between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                        }
                    }
                    if (parseInt(this.pfiltroncmpesq) < 2){
                        if (parseInt(this.pfiltroncmpesq) === 0){
                            rfiltro = rfiltro + ' and (p.idncm="" or p.idncm is null)';
                        }else{
                            rfiltro = rfiltro + ' and p.idncm<>""';
                        }
                    }
                }

                return rfiltro;
            },
            mtdexecutapesquisa(){
                // console.log('aqui');
                var vself           = this;
                if((this.pidfiliallocalizacao === null)&&(this.pidlocalizacao!== null)){
                    this.$toastr.w('Para filtrar por localização é necessário informar a filial!', 'Informação!');
                    $('#cbfiliallocalizacaopesq').select2('open');
                    return
                }
                if((this.pidfiliallocalizacao !== null)&&(this.pidlocalizacao=== null)){
                    this.$toastr.w('Informe a localização para completar a pesquisa!', 'Informação!');
                    $('#cbidlocalizacaopesq').select2('open');
                    return
                }
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor  : 'qtdregistros'},
                    {parametro: 'filtro',               valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    
                    if (parseInt(vself.pqtd_total_registros) > 1000 && parseInt(vself.pqtdregistros) > 1000) {
                        $.confirm({
                            title: 'Confirmação!',
                            content: 'Tem certeza que deseja listar todos os <strong>'+vself.pqtd_total_registros+'</strong> registros? Seu navegador pode não suportar essa quantidade de dados. Deseja mesmo continuar?',
                            icon: 'fa fa-question-circle',
                            escapeKey: true,
                            backgroundDismiss: false,
                            escapeKey: 'nao',
                            type: 'dark',
                            typeAnimated: true,
                            buttons: {
                                sim: {
                                    text: '<u>S</u>im',
                                    keys: ['s', 'S'],
                                    btnClass: 'btn-blue',
                                    action: function () {
                                        $('.btn-blue').prop('disabled', true);
                                        setTimeout(function(){
                                            vself.mtdcarregaprodutos(1);
                                        },200);
                                    },
                                },
                                nao: {
                                    text: '<u>N</u>ão',
                                    keys: ['n', 'N'],
                                    action: function () {
                                        vself.pqtdregistros = 10;
                                        $('#cbqtdreg').focus();
                                    }
                                }
                            }
                        });                        
                    }else{
                        vself.mtdcarregaprodutos(1);
                    }
                }).catch(function (response) {
                    this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdcarregaprodutos(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                vself.$refs.reflstprodutos.selected_items = [];//limpa os ítens selecionados na table
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac',             valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens',         valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                       valor : 'listagem'},
                    {parametro: 'idusuario',                valor : vself.$store.state.usuario.id},
                    {parametro: 'todastabelas',             valor : vself.$store.state.usuario.todastabelas},
                    {parametro: 'filtro',                   valor : filtro},
                    {parametro: 'idestoque',                valor : vself.$store.state.filialpadrao.idestoque},
                    {parametro: 'limit',                    valor : vself.pqtdregistros},
                    {parametro: 'offset',                   valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    {parametro: 'reserva',                  valor : util.opcaousuario('002Z.002M.020M', vself.$store.state.perfilusuario) ? 1 : 0},
                    {parametro: 'estoquegeralconsultas',    valor : vself.$store.state.usuario.estoquegeralconsultas},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    vself.lstprodutos = response.data;
                    // console.log(vself.lstprodutos);
                    loader.hide();
                }).catch(function (response) {
                    vself.lstprodutos = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.vid                     = '';
                this.vdescricao              = '';
                this.vreferencia             = '';
                this.vstpro                  = 1;
                this.vdtcadastro             = '';
                this.vdtultimavenda          = null,
                this.vidultimavenda          = 0;
                this.vecommerce              = false;
                this.vidmarca                = null;
                this.vidgrupo                = null;
                this.vidsubgrupo             = null;
                this.vidsetorproduto         = null;
                this.vund                    = null;
                this.vdiasvalidade           = 0;
                this.vreg                    = 0;
                this.vfracionado             = 0;
                this.vtipo                   = 0;
                this.vcontrolaserial         = 0;
                this.vestoqueminimo          = 0;
                this.vestoquemaximo          = 0;
                this.vespecificacao          = '';
                this.tpObjeto                = null;
                this.valtura                 = 0;
                this.vlargura                = 0;
                this.vprofundidade           = 0;
                this.vprcompra               = 0;
                this.vpipi                   = 0;
                this.vpicms                  = 0;
                this.vpfrete                 = 0;
                this.vppis                   = 0;
                this.vpcofins                = 0;
                this.vpoutros                = 0;
                this.vbcst                   = 0;
                this.vcalculasubstributaria  = 0;
                this.vpst                    = 0;
                this.vprodescala             = 0;
                this.vcnpjfabricante         = '';
                this.vvst                    = 0;
                this.vprcusto                = 0;
                this.vprvendamedio           = 0;
                this.vfatcomis               = 0;
                this.vcalcularprvendamedio   = false;
                this.vidncm                  = null;
                this.vidcest                 = null;
                this.vcbsituacaotributaria   = null;
                this.vtipoproduto            = 0;
                this.vorigemproduto          = 0;
                this.vprodutoespecifico      = 0;
                this.vpercglp                = 0;
                this.vpercgnn                = 0;
                this.vpercgni                = 0;
                this.vvlpartida              = 0;
                this.qtrib                   = 1;
                this.utrib                   = '';
                this.vprvendaminimo          = 0;
                this.vpathimagens            = '';
                this.vobservacoes            = '';
                this.lstTabelasPrecos        = [];
                this.lstCodigos              = [];
                this.lstLocalizacaoProduto   = [];
                this.lstClassesProduto       = [];
                this.lstsimilaridades        = [];
                this.lstImagens              = [];
                this.lstdestaquesprodutos    = [];
                this.variacoesProduto        = [];
                this.produtoAtualCor         = '';
                this.produtoAtualTamanho     = '';
                this.vfatorconver            = 0;
                this.vunimaior               = null;
                this.vdtvalidade             = '';
                this.vpeso                   = 0;
                this.vdiametro               = 0;
                this.vidtodastb              = false;
                this.vcbenef                 = '';

                //variáveis do cashback
                this.vvlcreditoacumulaavista = 0;
                this.vvlcreditoacumulaaprazo = 0;

                this.habdestab               = false;
                this.voptabela               = 1;


                this.vnovalocalizacao        = false;
                this.vdescricaolocalizacao   = '';
                this.vidnovalocalizacao      = '';

                this.vidanp                  = null;

                $('#cbunidade').val(null).trigger('change');
                $('#cbmarca').val(null).trigger('change');
                $('#cbgrupo').val(null).trigger('change');
                $('#cbsubgrupo').val(null).trigger('change');
                $('#cbtabelapreco').val(null).trigger('change');
                $('#cbfiliallocalizacao').val(null).trigger('change');
                $('#cbsetorlocalizacao').val(null).trigger('change');
                $('#cbsetorproduto').val(null).trigger('change');
                $('#cbsetor').val(null).trigger('change');
                $('#cblocalizacao').val(null).trigger('change');
                $('#cbncm').val(null).trigger('change');
                $('#cbcest').val(null).trigger('change');
                $('#classe').val(null).trigger('change');
                $('#cbfilialclasse').val(null).trigger('change');
                $('#cbanp').val(null).trigger('change');
                $('#edmaioruni').val(null).trigger('change');
            },
            mtddefault(){
                this.positionscroll = window.scrollY; // Pega a posição vertical atual do scroll - guga
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                $('.nav-tabs a[href="#dvproduto"]').tab('show');
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) === 1) {
                        $('#eddescricao').focus();
                    }
                    else if (parseInt(this.opcrud) === 2){
                        $('#cbstpro').focus();
                    }
                    else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.002M.001M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PRODUTOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.vpathimagens = util.GerarStringAleatoria();
                }
            },
            mtdcancelaredicao(){
                $('.nav-tabs a[href="#dvproduto"]').tab('show');
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                // setTimeout(function(){
                //     util.toTop();
                // }, 200);
            },
            mtdlimpar_listagem() {
                this.lstprodutos = [];
                this.$refs.reflstprodutos.selected_items = [];//limpa os ítens selecionados na table
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                
                // console.log(vself.vunimaior);
                // console.log(vself.fatorconver);
                // console.log("aqui");
                if (parseInt(vself.opcrud) < 3) {
                    if (this.vdiasvalidade === ''){
                        vself.$toastr.w('Campo da validade do produto deve ser informado!', 'Atenção!');
                        $('#eddiasvalidade').focus();
                        return;
                    }
                    if (parseFloat(vself.vestoqueminimo) > 0){
                        if (parseFloat(vself.vestoquemaximo) === 0 ){
                            vself.$toastr.w('Ao definir estoque mínimo, você deve informar o estoque máximo!', 'Atenção!');
                            $('#edestoquemaximo').focus();
                            return;
                        }
                    }
                    if(vself.lstTabelasPrecos.length > 0){
                        if(parseFloat(vself.vprvendaminimo) > 0 ){
                            for (let index = 0; index < vself.lstTabelasPrecos.length; index++) {
                                if(parseFloat(vself.lstTabelasPrecos[index].prtabela) < vself.vprvendaminimo){
                                    vself.$toastr.w('O preço da tabela '+ vself.lstTabelasPrecos[index].desctabela + ' é menor que o preço de venda minimo!', 'Atenção!');
                                    return;
                                }
                            }
                        }
                    }
                }
                let erroVariacao = false;
                if(this.variacoesProduto.length > 0){
                    // remove do array os itens que não tiverem cor, tamanho e produto selecionado
                    this.variacoesProduto = this.variacoesProduto.filter(variacao => {
                        return variacao.produto;
                    });
                    this.variacoesProduto.forEach(variacao => {
                        if(variacao.cor != '') {
                            if(this.produtoAtualCor == '') {
                                vself.$toastr.w('Produto com variação de cor, porém a cor do produto atual não foi informada! Verifique na aba [PROPRIEDADES].', 'Atenção!');
                                erroVariacao = true;
                                return;
                            }
                        }
                        if(variacao.tamanho != '') {
                            if(this.produtoAtualTamanho == '') {
                                vself.$toastr.w('Produto com variação de tamanho, porém o tamanho do produto atual não foi informada! Verifique na aba [PROPRIEDADES].', 'Atenção!');
                                erroVariacao = true;
                                return;
                            }
                        }
                        if(variacao.cor == '' && variacao.tamanho == '' && variacao.produto) {
                            vself.$toastr.w('É necessário adicionar o tipo de variação para o produto selecionado! Verifique na aba [PROPRIEDADES].', 'Atenção!');
                            erroVariacao = true;
                            return;
                        }
                        if(this.produtoAtualCor != ''){
                            if(variacao.cor == ''){
                                vself.$toastr.w('Produto atual possui cor informada, porém a variação não possui cor! Verifique na aba [PROPRIEDADES].', 'Atenção!');
                                erroVariacao = true;
                                return;
                            }
                        }
                        if(this.produtoAtualTamanho != ''){
                            if(variacao.tamanho == ''){
                                vself.$toastr.w('Produto atual possui tamanho informado, porém a variação não possui tamanho! Verifique na aba [PROPRIEDADES].', 'Atenção!');
                                erroVariacao = true;
                                return;
                            }
                        }
                    })
                }
                if(erroVariacao){
                    vself.$toastr.s('Validações concluídas com sucesso!', 'Sucesso!');
                    return;
                }

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    vself.mtdregistro();
                                },200);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id, clonar = false){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',               valor : 'listagem'},
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',           valor : filtro},
                    {parametro: 'limit',            valor : 1},
                    {parametro: 'offset',           valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    // console.log(response.data)
                    vself.mtdigualarcampos(response.data[0]);
                    if(clonar){
                        vself.vpathimagens   = util.GerarStringAleatoria();
                        vself.vid            = '';
                        vself.lstCodigos     = [];
                        vself.lstImagens     = [];
                    };
                    vself.$nextTick(function () {
                        if (parseInt(vself.opcrud) === 1) {
                            $('#eddescricao').focus();
                        }
                        else if (parseInt(vself.opcrud) === 2){
                            $('#cbstpro').focus();
                        }
                        else {
                            $('#btgravar').focus();
                        }
                    });
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.002M.002M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DO PRODUTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdclonar(item){
                let vself = this;
                if (!util.opcaousuario('002Z.002M.001M', this.$store.state.perfilusuario)){//mesmo código do perfil da inclusão do produto
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PRODUTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.mtdlocalizaregistro(item.id, true);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.002M.003M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DO PRODUTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                    this.habdestab = true;
                }
            },
            mtdigualarcampos(registro){
                this.vid                     = registro.id;
                this.vdescricao              = registro.descricao;
                this.vreferencia             = registro.referencia;
                this.vdtcadastro             = registro.dtcadastro;
                this.vdtultimavenda          = registro.dtultimavenda;
                this.vidultimavenda          = registro.idultimavenda;
                this.vecommerce              = parseInt(registro.ecommerce) === 0 ? false : true;
                this.vund                    = registro.und;
                this.vdiasvalidade           = registro.diasvalidade;
                this.vreg                    = registro.reg;
                this.vstpro                  = registro.stpro;
                this.vidmarca                = registro.idmarca;
                this.vidgrupo                = registro.idgrupo;
                this.vidsubgrupo             = registro.idsubgrupo;
                this.vidsetorproduto         = registro.idsetor;
                this.vfracionado             = registro.fracionado;
                this.vtipo                   = registro.tipo;
                this.vcontrolaserial         = registro.controlaserial;
                this.vestoqueminimo          = parseFloat(registro.estoqueminimo);
                this.vestoquemaximo          = parseFloat(registro.estoquemaximo);
                this.vespecificacao          = registro.especificacao;
                this.vprcompra               = parseFloat(registro.prcompra);
                this.vpipi                   = parseFloat(registro.pipi);
                this.vpicms                  = parseFloat(registro.picms);
                this.vpfrete                 = parseFloat(registro.pfrete);
                this.vppis                   = parseFloat(registro.ppis);
                this.vpcofins                = parseFloat(registro.pcofins);
                this.vpoutros                = parseFloat(registro.poutros);
                this.vbcst                   = parseFloat(registro.bcst);
                this.vcalculasubstributaria  = registro.calculasubstributaria;
                this.vpst                    = parseFloat(registro.pst);
                this.vvst                    = parseFloat(registro.vst);
                this.vprcusto                = parseFloat(registro.prcusto);
                this.vcalcularprvendamedio   = parseInt(registro.calcularprvendamedio) === 0 ? false : true;
                this.vprvendamedio           = parseFloat(registro.prvendamedio);
                this.vdtvalidade             = registro.dtvalidade;
                this.vpeso                   = parseFloat(registro.peso);
                this.vdiametro               = parseFloat(registro.diametro);
                this.vfatorconver            = parseFloat(registro.fatorconver);
                
                
                this.tpObjeto                = registro.tpobjeto;
                this.valtura                 = parseFloat(registro.altura);
                this.vlargura                = parseFloat(registro.largura);
                this.vprofundidade           = parseFloat(registro.profundidade);

                this.vidncm                  = registro.idncm;
                this.vidanp                  = registro.idanp  === '' ? null : registro.idanp;
                this.vidcest                 = registro.idcest === '' ? null : registro.idcest;
                this.vidsituacaotributaria   = registro.idsituacaotributaria === '' ? null : registro.idsituacaotributaria;
                this.vtipoproduto            = registro.tipoproduto;
                this.vprodescala             = registro.prodescala;
                this.vcnpjfabricante         = registro.cnpjfabricante;
                this.vunimaior               = registro.descunimaior;

                this.vcbenef                 = registro.cbenef; 


                this.vorigemproduto          = registro.origemproduto;
                this.vprodutoespecifico      = registro.produtoespecifico;
                this.vpercglp                = registro.percglp;
                this.vpercgnn                = registro.percgnn;
                this.vpercgni                = registro.percgni;
                this.vvlpartida              = registro.vlpartida
                this.vpathimagens            = registro.pathimagens  !== '' && registro.pathimagens !== null ? registro.pathimagens : util.GerarStringAleatoria();
                this.vobservacoes            = registro.observacoes;
                this.lstTabelasPrecos        = registro.tabelas;
                this.lstCodigos              = registro.codigos;
                this.lstLocalizacaoProduto   = registro.localizacoes;
                this.lstClassesProduto       = registro.classes;
                this.lstdestaquesprodutos    = registro.destaques;
                this.lstfiliaisproduto       = registro.filiaisprodutos;

                this.lstImagens              = this.mtdordenaimagens(registro.imagens);
                this.lstsimilaridades        = registro.similaridades;
                this.vfatcomis               = parseFloat(registro.fatcomissao);
                this.qtrib                   = parseFloat(registro.qtrib);
                this.utrib                   = registro.utrib;
                this.vprvendaminimo          = registro.prvendaminimo;
                //variáveis do cashback
                this.vvlcreditoacumulaavista = parseFloat(registro.vlcreditoacumulaavista);
                this.vvlcreditoacumulaaprazo = parseFloat(registro.vlcreditoacumulaaprazo);

                var defunidade  = new Option(registro.descunidade, this.vund, true, true);
                $('#cbunidade').append(defunidade).trigger('change');

                var defmarca    = new Option(registro.descmarca, this.vidmarca, true, true);
                $('#cbmarca').append(defmarca).trigger('change');

                var defgrupo    = new Option(registro.descgrupo, this.vidgrupo, true, true);
                $('#cbgrupo').append(defgrupo).trigger('change');

                var defsubgrupo = new Option(registro.descsubgrupo, this.vidsubgrupo, true, true);
                $('#cbsubgrupo').append(defsubgrupo).trigger('change');

                var defsetor = new Option(registro.descsetor, this.vidsetorproduto, true, true);
                $('#cbsetorproduto').append(defsetor).trigger('change');

                var defncm = new Option(registro.descncm, this.vidncm, true, true);
                $('#cbncm').append(defncm).trigger('change');

                var defftc = new Option(registro.descunimaior, this.vunimaior, true, true);
                $('#edmaioruni').append(defftc).trigger('change');

                if (this.vidanp !== null){
                    var defanp = new Option(registro.descanp, this.vidanp, true, true);
                    $('#cbanp').append(defanp).trigger('change');
                }else{
                    $('#cbanp').val(null).trigger('change'); 
                }

                if (this.vidcest !== null){
                    var defcest = new Option(registro.desccest, this.vidcest, true, true);
                    $('#cbcest').append(defcest).trigger('change');
                }else{
                    $('#cbcest').val(null).trigger('change');
                }

                if (this.vidsituacaotributaria !== null){
                    var defsituacaotributaria = new Option(registro.descsituacaotributaria, this.vidsituacaotributaria, true, true);
                    $('#cbsituacaotributaria').append(defsituacaotributaria).trigger('change');
                }else{
                    $('#cbsituacaotributaria').val(null).trigger('change');
                }
                this.mtdcalculaprvendamedio();
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let semverificacoes = util.opcaousuario('002Z.002M.003N', this.$store.state.perfilusuario) ? 1 : 0;
                // VERIFICAÇÃO DO CAMPO ANTES DO REGISTRO
                if (parseFloat(vself.qtrib) <= 0){
                    this.$toastr.w('O valor do Qtd.Trib deve ser maior que 1!', 'Atenção!');
					$('#qtrib').focus();
                    loader.hide();
					return;
                }
                let registrocrud = {
                    'id'                    : this.vid,
                    'descricao'             : this.vdescricao,
                    'referencia'            : this.vreferencia,
                    'stpro'                 : this.vstpro,
                    'idmarca'               : this.vidmarca,
                    'idgrupo'               : this.vidgrupo,
                    'idsubgrupo'            : this.vidsubgrupo,
                    'idsetor'               : this.vidsetorproduto,
                    'und'                   : this.vund,
                    'diasvalidade'          : this.vdiasvalidade,
                    'fracionado'            : this.vfracionado,
                    'tipo'                  : this.vtipo,
                    'controlaserial'        : this.vcontrolaserial,
                    'estoqueminimo'         : this.vestoqueminimo,
                    'estoquemaximo'         : this.vestoquemaximo,
                    'especificacao'         : this.vespecificacao,

                    'tpobjeto'              : this.tpObjeto,
                    'altura'                : this.valtura,
                    'largura'               : this.vlargura,
                    'profundidade'          : this.vprofundidade,

                    'prcompra'              : this.vprcompra,
                    'pipi'                  : this.vpipi,
                    'picms'                 : this.vpicms,
                    'pfrete'                : this.vpfrete,
                    'ppis'                  : this.vppis,
                    'pcofins'               : this.vpcofins,
                    'poutros'               : this.vpoutros,
                    'bcst'                  : this.vbcst,
                    'calculasubstributaria' : this.vcalculasubstributaria,
                    'pst'                   : this.vpst,
                    'vst'                   : this.vvst,
                    'prcusto'               : this.vprcusto,
                    'calcularprvendamedio'  : this.vcalcularprvendamedio === false ? 0 : 1,
                    'prvendamedio'          : this.vprvendamedio,
                    'idncm'                 : this.vidncm,
                    'idanp'                 : this.vidanp === null ? '' : this.vidanp,
                    'idcest'                : this.vidcest === null ? '' : this.vidcest,
                    'cbenef'                : this.vcbenef,
                    'idsituacaotributaria'  : this.vidsituacaotributaria === null ? '' : this.vidsituacaotributaria,
                    'tipoproduto'           : this.vtipoproduto,
                    'cnpjfabricante'        : this.vcnpjfabricante.replace(/[^0-9]/g,''),
                    'prodescala'            : this.vprodescala,
                    'origemproduto'         : this.vorigemproduto,
                    'produtoespecifico'     : this.vprodutoespecifico,
                    'percglp'               : this.vpercglp,
                    'percgnn'               : this.vpercgnn,
                    'percgni'               : this.vpercgni,
                    'vlpartida'             : this.vvlpartida,
                    'reg'                   : parseInt(this.vreg) === 0 ? 1 : 0,
                    'pathimagens'           : this.vpathimagens,
                    'observacoes'           : this.vobservacoes,
                    'tabelasprecos'         : this.lstTabelasPrecos,
                    'codigos'               : this.lstCodigos,
                    'localizacoes'          : this.lstLocalizacaoProduto,
                    'classes'               : this.lstClassesProduto,
                    'similaridades'         : this.lstsimilaridades,
                    'destaques'             : this.lstdestaquesprodutos,
                    'fatcomissao'           : this.vfatcomis,
                    'vlcreditoacumulaavista': this.vvlcreditoacumulaavista,
                    'vlcreditoacumulaaprazo': this.vvlcreditoacumulaaprazo,
                    'qtrib'                 : this.qtrib,
                    'utrib'                 : this.utrib,
                    'prvendaminimo'         : this.vprvendaminimo,
                    'fatorconver'           : this.vfatorconver,
                    'unimaior'              : this.vunimaior === null ? '' : this.vunimaior,
                    'dtvalidade'            : this.vdtvalidade,
                    'peso'                  : this.vpeso,
                    'diametro'              : this.vdiametro,
                    'filiaisproduto'        : this.lstfiliaisproduto,

                    'ecommerce'             : this.vecommerce ? 1 : 0,
                };
                
                // return;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'rotinacrud'},
                    {parametro: 'opcrud',           valor : vself.opcrud},
                    {parametro: 'semverificacoes',  valor : semverificacoes},
                    {parametro: 'registro',         valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : parseInt(this.opcrud) === 1 ? '002Z.002M.001M' : parseInt(this.opcrud) === 2 ? '002Z.002M.002M' : '002Z.002M.003M'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');   
                        vself.mtdcancelaredicao();
                        if((vself.opcrud !== 1)&&(vself.lstprodutos.length > 0)&&(util.findValInArray(vself.lstprodutos, 'id', vself.vid))){
                            vself.mtdprocessaretornocud(response.data);
                        }else{
                            vself.pconteudo     = response.data;
                            vself.pagina_atual  = 1;
                            vself.pmaisfiltros  = false;
                            vself.pfiltro       = 0;
                            vself.mtdcarregaprodutos(1);
                        }
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdgravartabela(){
                if (parseInt(this.voptabela) === 1){//inclusão da tabela
                    if (this.vidtabelapreco === null) {
                        if(this.vidtodastb == false){
                            this.$toastr.w('Tabela de preço deve ser informada!', 'Atenção!');
                            $('#cbtabelapreco').select2('open');
                            return;
                        }
                    }
                    if(this.vidtodastb == false || (this.vidtodastb && this.vtipoatribuicaotbpr == 1)){
                        if (this.vvltabela <= 0) {
                            this.$toastr.w('Preço de venda deve ser informado!', 'Atenção!');
                            $('#edvltabela').focus();
                            return;
                        }
                    }
                    if(!util.verificatabelausuario(this.vidtabelapreco, this.$store.state.usuario.tabelasusuario, this.$store.state.usuario.todastabelas)){
                        this.$toastr.w('Seu usuário não esta autorizado a operar esta tabela de preço!', 'Atenção!');
                        return;
                    }
                    if(this.vidtodastb == false){ //TABELAS INDIVIDUAIS
                        if (!util.findValInArray(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco)) {
                            let tabelapr = {
                                'idtabela'          : this.vidtabelapreco,
                                'desctabela'        : $('#cbtabelapreco').select2('data')[0]['text'],
                                'mrglucro'          : parseFloat(this.vmrgtabela),
                                'prtabela'          : parseFloat(this.vvltabela).toFixed(2),
                                'vlnf'              : parseFloat(this.vvlnf).toFixed(2),
                                'pcomissao'         : parseFloat(this.vcomissaotabela),
                                'qtdminima'         : parseFloat(this.vqtdmintabela),
                                'desconto'          : parseFloat(this.vdescontotabela),
                                'vlvisualiza'       : parseFloat(this.vvlvizu),
                                'vldescpromocional' : parseFloat(this.vvldescpromocional)
                            };
                            this.lstTabelasPrecos.push(tabelapr);
                            this.vidtabelapreco  = null;
                            this.vmrgtabela      = 0;
                            this.vvltabela       = 0;
                            this.vvlnf           = 0;
                            this.vcomissaotabela = 0;
                            this.vqtdmintabela   = 0;
                            this.vdescontotabela = 0;
                            this.vvldescpromocional = 0;
                            this.vvlvizu         = 0;
                            this.voptabela       = 1;
                            this.habdestab       = false;
                            $('#cbtabelapreco').val(null).trigger('change');
                            this.mtdcalculaprvendamedio();
                            }else{
                            this.$toastr.w('Tabela de preço já cadastrada!', 'Atenção!');
                        }
                    }else{ //TODAS AS TABELAS
                        this.todastabelas.forEach(tabela => {
                        if (!util.findValInArray(this.lstTabelasPrecos, 'idtabela', tabela.id)) {

                            let margemDecimal = parseFloat(tabela.margem);
                            if (margemDecimal > 1) { 
                                margemDecimal = margemDecimal / 100; 
                            }

                            let tabelapr = {};

                            if (this.vtipoatribuicaotbpr == 1) {
                                tabelapr = {
                                    'idtabela'          : tabela.id,
                                    'desctabela'        : tabela.descricao,
                                    'mrglucro'          : parseFloat(tabela.margem),
                                    'prtabela'          : parseFloat(this.vvltabela).toFixed(2),
                                    'vlnf'              : parseFloat(this.vvlnf).toFixed(2),
                                    'pcomissao'         : parseFloat(this.vcomissaotabela),
                                    'qtdminima'         : parseFloat(this.vqtdmintabela),
                                    'desconto'          : parseFloat(this.vdescontotabela),
                                    'vlvisualiza'       : parseFloat(this.vvlvizu),
                                    'vldescpromocional' : parseFloat(this.vvldescpromocional)
                                };
                            } else {
                                let precoTabela = this.vprcusto * (1 + margemDecimal);

                                let mrglucroReal = ((precoTabela - this.vprcusto) / this.vprcusto * 100).toFixed(2);

                                tabelapr = {
                                    'idtabela'          : tabela.id,
                                    'desctabela'        : tabela.descricao,
                                    'mrglucro'          : parseFloat(mrglucroReal), // margem real em %
                                    'prtabela'          : parseFloat(precoTabela).toFixed(2),
                                    'vlnf'              : parseFloat(this.vvlnf).toFixed(2),
                                    'pcomissao'         : parseFloat(this.vcomissaotabela),
                                    'qtdminima'         : parseFloat(this.vqtdmintabela),
                                    'desconto'          : parseFloat(this.vdescontotabela),
                                    'vlvisualiza'       : parseFloat(this.vvlvizu),
                                    'vldescpromocional' : parseFloat(this.vvldescpromocional)
                                };
                            }
                            this.lstTabelasPrecos.push(tabelapr);

                        } else {
                            this.$toastr.w('Tabela '+ tabela.descricao +' já cadastrada!', 'Atenção!');
                        }
                    });

                    this.vidtabelapreco  = null;
                    this.vmrgtabela      = 0;
                    this.vvltabela       = 0;
                    this.vvlnf           = 0;
                    this.vcomissaotabela = 0;
                    this.vqtdmintabela   = 0;
                    this.vdescontotabela = 0;
                    this.vvldescpromocional = 0;
                    this.vvlvizu         = 0;
                    this.voptabela       = 1;
                    this.habdestab       = false;
                    this.vidtodastb      = false;

                    $('#cbtabelapreco').val(null).trigger('change');
                    this.mtdcalculaprvendamedio();

                    }
                }else{//alteração da tabela
                    let indt = util.getArrayIndexForKey(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco);

                    this.lstTabelasPrecos[indt].mrglucro          = parseFloat(this.vmrgtabela);
                    this.lstTabelasPrecos[indt].prtabela          = parseFloat(this.vvltabela).toFixed(2);
                    this.lstTabelasPrecos[indt].vlnf              = parseFloat(this.vvlnf).toFixed(2);
                    this.lstTabelasPrecos[indt].pcomissao         = parseFloat(this.vcomissaotabela);
                    this.lstTabelasPrecos[indt].qtdminima         = parseFloat(this.vqtdmintabela);
                    this.lstTabelasPrecos[indt].desconto          = parseFloat(this.vdescontotabela);
                    this.lstTabelasPrecos[indt].vlvisualiza       = parseFloat(this.vvlvizu);
                    this.lstTabelasPrecos[indt].vldescpromocional = parseFloat(this.vvldescpromocional);
                    
                    this.vidtabelapreco  = null;
                    this.vmrgtabela      = 0;
                    this.vvltabela       = 0;
                    this.vvlnf           = 0;
                    this.vcomissaotabela = 0;
                    this.vqtdmintabela   = 0;
                    this.vdescontotabela = 0;
                    this.vvlvizu            = 0;
                    this.vvldescpromocional = 0;
                    this.voptabela       = 1;
                    this.habdestab       = false;
                    $('#cbtabelapreco').val(null).trigger('change');
                    this.mtdcalculaprvendamedio();
                    $('#cbtabelapreco').focus();
                }
            },
            mtdalterartabela(tabela){
                if (!this.ativadesativa) {
                    if(!util.verificatabelausuario(tabela.idtabela, this.$store.state.usuario.tabelasusuario, this.$store.state.usuario.todastabelas)){
                        this.$toastr.w('Seu usuário não esta autorizado a operar esta tabela de preço!', 'Atenção!');
                    }else{
                        this.voptabela  = 2;
                        this.habdestab  = true;
                        var deftab      = new Option(tabela.desctabela, tabela.idtabela, true, true);
                        $('#cbtabelapreco').append(deftab).trigger('change');
                        this.vmrgtabela         = tabela.mrglucro;
                        this.vvltabela          = tabela.prtabela;
                        this.vvlvizu            = tabela.vlvisualiza;
                        this.vvlnf              = tabela.vlnf;
                        this.vcomissaotabela    = tabela.pcomissao;
                        this.vqtdmintabela      = tabela.qtdminima;
                        this.vdescontotabela    = tabela.desconto;
                        this.vvldescpromocional = tabela.vldescpromocional;
                        $('#edvltabela').focus();
                    }
                }
            },
            mtdcancelartabela(){
                this.voptabela          = 1;
                this.habdestab          = false;
                this.vmrgtabela         = 0;
                this.vvltabela          = 0;
                this.vvlvizu            = 0;
                this.vvlnf              = 0;
                this.vcomissaotabela    = 0;
                this.vqtdmintabela      = 0;
                this.vdescontotabela    = 0;
                this.vvldescpromocional = 0;
                $('#cbtabelapreco').val(null).trigger('change');
                $('#cbtabelapreco').select2('open');
            },
            mtddeletatabela(index, op) {
                if(op ==1 ){
                    let vself = this
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja remover todas as tabelas de preço?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: true,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                $('.btn-blue').prop('disabled', true);
                                    vself.lstTabelasPrecos = [];
                                }
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                }else{
                    if (!this.ativadesativa) {
                       if(util.verificatabelausuario(this.lstTabelasPrecos[index].idtabela, this.$store.state.usuario.tabelasusuario, this.$store.state.usuario.todastabelas)){
                           this.lstTabelasPrecos.splice(index, 1);
                           this.mtdcalculaprvendamedio();
                           this.mtdcancelartabela();
                       }else{
                           this.$toastr.w('Seu usuário não esta autorizado a operar esta tabela de preço!', 'Atenção!');
                           return;
                       }
                   }
                }
            },
            mtdcalculaprvendamedio(){
                if (!this.vcalcularprvendamedio){
                    if (this.lstTabelasPrecos.length > 0){
                        let vsoma = 0;
                        for (let i = 0; i < this.lstTabelasPrecos.length; i++) {
                            vsoma = vsoma + parseFloat(this.lstTabelasPrecos[i]['prtabela']);
                        }
                        if (parseFloat(vsoma) > 0){
                            this.vprvendamedio = vsoma / this.lstTabelasPrecos.length;
                        }else{
                            this.vprvendamedio = 0;
                        }
                    }else{
                        this.vprvendamedio = 0;
                    }
                }
                let difpr = this.vprvendamedio - this.vprcusto;
                if (parseFloat(this.vprcusto) > 0){
                    this.vmargemprcusto = (difpr / this.vprcusto * 100).toFixed(2);
                }else{
                    this.vmargemprcusto = 0;
                }
            },
            mtdinccodigo(){
                //Verifica se o código digitado não é igual ao principal
                if (this.vid !== '' ){
                    if (this.vcodigoinc === this.vid){
                        this.$toastr.w('Código não pode ser igual ao código principal!', 'Atenção!');
                        $("#edcodigoadd").focus();
                        return;
                    }
                }
                if (this.vcodigoinc === '') {
                    this.$toastr.w('Código deve ser informado!', 'Atenção!');
                    $("#edcodigoadd").focus();
                    return;
                }
                let codigotmp = {
                    'codigo'               : this.vcodigoinc,
                    'padraoetiqueta'       : 0
                };
                if (!util.findValInArray(this.lstCodigos, 'codigo', codigotmp.codigo)){
                    this.lstCodigos.push(codigotmp);
                    this.vcodigoinc = '';
                    $('#edcodigoadd').focus();
                }else{
                    this.$toastr.w('Código já incluso para o produto!', 'Atenção!');
                    $('#edcodigoadd').focus();
                }
            },
            mtddelcodigo(index){
               this.lstCodigos.splice(index, 1);
            },
            mtdincreferenciasimilar(){
                if (this.vreferenciasimilarinc === '') {
                    this.$toastr.w('Referência deve ser informado!', 'Atenção!');
                    $("#edreferenciasimilar").focus();
                    return;
                }
                let referenciatmp = {
                    'referencia'               : this.vreferenciasimilarinc.toUpperCase()
                };
                if (!util.findValInArray(this.lstsimilaridades, 'referencia', referenciatmp.referencia)){
                    this.lstsimilaridades.push(referenciatmp);
                    this.vreferenciasimilarinc = '';
                    $('#edreferenciasimilar').focus();
                }else{
                    this.$toastr.w('Referência já inclusa nas similaridades!', 'Atenção!');
                    $('#edreferenciasimilar').focus();
                }
            },
            mtddelreferenciasimilar(index){
               this.lstsimilaridades.splice(index, 1);
            },
            mtdinclocalizacao(){
                if (this.vidfiliallocalizacao == null) {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialestoque").focus();
                    return;
                }
                if (this.videstoquelocalizacao == null) {
                    this.$toastr.w('Estoque deve ser informado!', 'Atenção!');
                    $("#cbestoquelocalizacao").focus();
                    return;
                }                
                if (this.vidlocalizacao == null) {
                    this.$toastr.w('Localização do estoque deve ser informada!', 'Atenção!');
                    $("#cblocalizacao").focus();
                    return;
                }
                let localizacaopro = {
                    'idfilial'             : this.vidfiliallocalizacao,
                    'fantasia'             : $('#cbfiliallocalizacao').select2('data')[0]['text'],
                    'idestoque'            : this.videstoquelocalizacao,
                    'descestoque'          : $('#cbestoquelocalizacao').select2('data')[0]['text'],                    
                    'idlocalizacao'        : this.vidlocalizacao,
                    'desclocalizacao'      : $('#cblocalizacao').select2('data')[0]['text']
                };
                if (!this.AchaLocalizacaoFil(this.lstLocalizacaoProduto, localizacaopro)){
                    this.lstLocalizacaoProduto.push(localizacaopro);

                    this.vdescricaolocalizacao   = '';
                    this.vidnovalocalizacao      = '';

                    this.vidfiliallocalizacao   = null;
                    this.videstoquelocalizacao  = null;
                    this.vidlocalizacao         = null;

                    $('#cbfiliallocalizacao').val(null).trigger('change');
                    $('#cbestoquelocalizacao').val(null).trigger('change');
                    $('#cblocalizacao').val(null).trigger('change');

                    $('#cbfiliallocalizacao').select2('open');

                }else{
                    this.$toastr.w('Já existe uma localização definida com essas configurações!', 'Atenção!');
                    $('#cbfiliallocalizacao').select2('open');
                }
            },
            mtddeletarlocalizacao(index){
                this.lstLocalizacaoProduto.splice(index, 1);
            },
            AchaLocalizacaoFil(arr, localizacao) {//verifica se existe um valor em uma chave de uma array
                if (arr){
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i]['idfilial'] == localizacao.idfilial && arr[i]['idlocalizacao'] == localizacao.idlocalizacao && arr[i]['idsetor'] == localizacao.idsetor) return true;
                        //if (arr[i]['idfilial'] == localizacao.idfilial) return true;
                    }
                }
                return false;
            },
            mtdincluirclasse(){
                if (this.vidclasse == null) {
                    this.$toastr.w('Classe deve ser informada!', 'Atenção!');
                    $("#cbclasse").focus();
                    return;
                }
                if (this.vidfilialclasse == null) {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialclasse").focus();
                    return false;
                }
                if (this.vRegimeClasse !== this.vCrtFilial) {
                    this.$toastr.w('A classe selecionada não corresponde à filial selecionada. Por favor, selecione outra classe.', 'Atenção!');
                    $("#cbclasse").val(null).trigger('change');
                    return;
                } 
                let classeproduto = {
                    'idclasse'     : this.vidclasse,
                    'descclasse'   : $('#cbclasse').select2('data')[0]['text'],
                    'idfilial'     : this.vidfilialclasse,
                    'fantasia'     : $('#cbfilialclasse').select2('data')[0]['text']
                }
                if (!this.AchaClasseFil2(this.lstClassesProduto, classeproduto.idfilial)){
                    this.lstClassesProduto.push(classeproduto);
                    this.vidclasse       = null;
                    this.vidfilialclasse = null;
                    $('#cbclasse').val(null).trigger('change');
                    $('#cbfilialclasse').val(null).trigger('change');
                    $('#cbclasse').focus();
                }else{
                    this.$toastr.w('Classe já inclusa para a filial!', 'Atenção!');
                    $('#cbclasse').focus();
                }
            },
            mtdexcluirclasse(index){
                this.lstClassesProduto.splice(index, 1);
            },
            AchaClasseFil(arr, idclasse, idfilial) {
                if (arr){
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i]['idclasse'] == idclasse && arr[i]['idfilial'] == idfilial) return true;
                    }
                }
                return false;
            },
            AchaClasseFil2(arr, idfilial) {
                if (arr){
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i]['idfilial'] == idfilial) return true;
                    }
                }
                return false;
            },
            mtdcalculaprtabela(){
                if (parseFloat(this.vprcusto) > 0){
                    let vladd       = parseFloat(this.vmrgtabela) * parseFloat(this.vprcusto)  / 100;
                    this.vvltabela  = parseFloat(this.vprcusto) + vladd;
                }else{
                    this.vvltabela  = 0;
                }
            },
            mtdcalculamrgtabela(){
                let dif = this.vvltabela - this.vprcusto;
                if (dif > 0){
                    if(this.vprcusto > 0){
                        let mrg = dif / this.vprcusto * 100;
                        this.vmrgtabela = mrg;
                    }else{
                        this.vmrgtabela = 0;
                    }
                }else{
                    this.vmrgtabela = 0;
                }
            },
            mtdrecalcularmargemtabelas(){
                if (this.lstTabelasPrecos.length > 0){
                    let lstcalc             = this.lstTabelasPrecos;
                    this.lstTabelasPrecos   = [];
                    if (lstcalc) {
                        for (var i = 0; i < lstcalc.length; i++) {
                            let dif = lstcalc[i]['prtabela'] - this.vprcusto;
                            if (dif > 0){
                                if(this.vprcusto > 0){
                                    let mrg = dif / this.vprcusto * 100;
                                    lstcalc[i]['mrglucro'] = parseFloat(mrg.toFixed(2));
                                }else{
                                    lstcalc[i]['mrglucro']     = 0;
                                }
                            }else{
                                lstcalc[i]['mrglucro']     = 0;
                            }
                        }
                    }
                    this.lstTabelasPrecos   = lstcalc;
                }
            },
            mtdajustarestoque(item){
                if (!util.opcaousuario('002Z.002M.004M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.vidproduto          = item.id;
                    this.vdescpro            = item.descricao;
                    this.vunidadepro         = item.und;
                    this.vqtdmov             = 1;
                    this.vvlmov              = item.prcusto;
                    this.vdtmov              = util.DataAtual(true);
                    this.vtpmov              = 0;
                    this.vperda              = 0;
                    this.vobsmov             = '';
                    this.vqtdanterior        = 0;
                    this.vundanterior        = item.und;
                    this.vprofracionado      = item.fracionado;

                    let defestoque           = new Option(this.$store.state.filialpadrao.descestoque, this.$store.state.filialpadrao.idestoque, true, true);
                    $('#cbestoque').append(defestoque).trigger('change');

                    var deffil                = new Option(this.$store.state.filialpadrao.descfil, this.$store.state.filialpadrao.codfil, true, true);
                    $('#cbfilialajuste').append(deffil).trigger('change');

                    $('#mdajuste').modal('show');
                }
            },
            mtdajustarestoquerapido(){
                
                this.mtddefaultajuste();

                let defestoque           = new Option(this.$store.state.filialpadrao.descestoque, this.$store.state.filialpadrao.idestoque, true, true);
                $('#cbestoquerap').append(defestoque).trigger('change');

                var deffil                = new Option(this.$store.state.filialpadrao.descfil, this.$store.state.filialpadrao.codfil, true, true);
                $('#cbfilialajusterap').append(deffil).trigger('change');

                $('#edidprodutoajuste').focus();

                $('#mdajusterapido').modal('show');
            },
            mtdconfirmarajuste() {
                if (this.videstoque === null || this.videstoque === undefined || this.videstoque === '') {
                    this.$toastr.w('Estoque do produto deve ser informado!', 'Atenção!');
                    return;
                }
                if (this.vdtmov === null || this.vdtmov === undefined || this.vdtmov === '') {
                    this.$toastr.w('Data do movimento deve ser informada!', 'Atenção!');
                    return;
                }
                if (this.vidfilialajuste === null || this.vidfilialajuste === undefined || this.vidfilialajuste === '') {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    return;
                }
                if (this.vqtdmov <= 0){
                    this.$toastr.w('Quantidade do movimento inválida!', 'Atenção!');
                    return;
                }
                if (parseInt(this.vprofracionado) === 0){
                    if (!Number.isInteger(util.formatarvalorDB(this.vqtdmov))){
                        this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                        return;
                    }
                }

                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                if(parseInt(vself.vtpmov) === 0){
                    vself.msgTitAjuste   = 'ENTRADA'
                }else{
                    vself.msgTitAjuste   = 'SAÍDA';
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a '+ vself.msgTitAjuste + ' do estoque?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    vself.mtdregistroajuste();
                                },200);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },
            mtdconfirmarajusterapido() {
                if (this.videstoquer === null || this.videstoquer === undefined || this.videstoquer === '') {
                    this.$toastr.w('Estoque do produto deve ser informado!', 'Atenção!');
                    return;
                }
                if (this.vdtmovr === null || this.vdtmovr === undefined || this.vdtmovr === '') {
                    this.$toastr.w('Data do movimento deve ser informada!', 'Atenção!');
                    return;
                }
                if (this.vidfilialajuster === null || this.vidfilialajuster === undefined || this.vidfilialajuster === '') {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    return;
                }
                if (this.vqtdmovr <= 0){
                    this.$toastr.w('Quantidade do movimento inválida!', 'Atenção!');
                    return;
                }
                if (parseInt(this.vprofracionador) === 0){
                    if (!Number.isInteger(util.formatarvalorDB(this.vqtdmov))){
                        this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                        return;
                    }
                }
                this.mtdregistroajusterapido();

            },
            mtdregistroajusterapido(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registroajuste = {
                    'idfilial'           : this.vidfilialajuster,
                    'idproduto'          : this.vidprodutor,
                    'idestoque'          : this.videstoquer,
                    'qtdmov'             : this.vqtdmovr,
                    'und'                : this.vunidadepror,
                    'vlmov'              : this.vvlmovr,
                    'dtmov'              : this.vdtmovr,
                    'tpmov'              : this.vtpmovr,
                    'perda'              : this.vperdar,
                    'obsmov'             : this.vobsmovr,
                    'idorigem'           : this.vtpmovr,
                    'idusuario'          : this.$store.state.usuario.id,
                    'qtdestoque'         : this.vqtdanteriorr,
                    'docmov'             : this.vdocmovr
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'rotinaajuste'},
                    {parametro: 'registro',         valor : JSON.stringify(registroajuste)},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : '002Z.002M.004M'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');

                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Ajuste realizado com sucesso!', 'Informação!');

                        setTimeout(function (){
                            if (vself.videstoquer != null) {
                                let loader      = vself.$loading.show();
                                let parametros  = [
                                    {parametro: 'op',           valor : 'buscarestoque'},
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'filtro',       valor : ' and idproduto='+vself.vidprodutor+ ' and idestoque='+vself.videstoquer},
                                    {parametro: 'limit',        valor : 1},
                                    {parametro: 'offset',       valor : 0},
                                ];
                                let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                                retorno.then(function (response) {
                                    vself.vqtdatualizada = parseFloat(response.data[0].quantidade);
                                    vself.$toastr.i('Estoque atualizado ' +vself.vqtdatualizada, 'Informação!');
                                    vself.mtddefaultajuste();
                                    loader.hide();
                                }).catch(function (response) {
                                    console.log(response);
                                    loader.hide();
                                });
                            } else {
                                vself.vqtdatualizada = 0;
                            }
                        }, 200);

                    }else{
                        let tpret = response.data.substring(0,1);

                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o ajuste. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdregistroajuste(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registroajuste = {
                    'idfilial'           : this.vidfilialajuste,
                    'idproduto'          : this.vidproduto,
                    'idestoque'          : this.videstoque,
                    'qtdmov'             : this.vqtdmov,
                    'und'                : this.vunidadepro,
                    'vlmov'              : this.vvlmov,
                    'dtmov'              : this.vdtmov,
                    'tpmov'              : this.vtpmov,
                    'perda'              : this.vperda,
                    'obsmov'             : this.vobsmov,
                    'idorigem'           : this.vtpmov,
                    'idusuario'          : this.$store.state.usuario.id,
                    'qtdestoque'         : this.vqtdanterior,
                    'docmov'             : this.vdocmov
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'rotinaajuste'},
                    {parametro: 'registro',         valor : JSON.stringify(registroajuste)},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : '002Z.002M.004M'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');

                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Ajuste realizado com sucesso!', 'Informação!');

                        setTimeout(function (){
                            if (vself.videstoque != null) {
                                let loader      = vself.$loading.show();
                                let parametros  = [
                                    {parametro: 'op',           valor : 'buscarestoque'},
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'filtro',       valor : ' and idproduto='+vself.vidproduto+ ' and idestoque='+vself.videstoque},
                                    {parametro: 'limit',        valor : 1},
                                    {parametro: 'offset',       valor : 0},
                                ];
                                let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                                retorno.then(function (response) {
                                    vself.vqtdatualizada = parseFloat(response.data[0].quantidade);
                                    vself.$toastr.i('Estoque atualizado ' +vself.vqtdatualizada, 'Informação!');
                                    loader.hide();
                                }).catch(function (response) {
                                    console.log(response);
                                    loader.hide();
                                });
                            } else {
                                vself.vqtdatualizada = 0;
                            }
                        }, 200);

                        $('#mdajuste').modal('hide');
                    }else{
                        let tpret = response.data.substring(0,1);

                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o ajuste. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdrotinaclasses(){
                if (!util.opcaousuario('002Z.002M.005M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (this.$refs.reflstprodutos.selected_items.length === 0){
                        this.$toastr.w('Selecione os produtos para a atribuição da classe!', 'Atenção!');
                        return;
                    }
                    this.vopcaoclasseatribuir  = 0;
                    this.vatribuitodosprodutos = false;
                    $('#cbclasseatribuir').val(null).trigger('change');
                    $('#cbfilialatribuir').val(null).trigger('change');
                    $('#mdatribuirclasse').modal('show');
                }
            },
            mtdatribuirclasse(){
                let vself = this;
				if (this.vidfilialatribuir === null){
					this.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilialatribuir').focus();
					return;
                }
				if (this.vidclasseatribuir === null){
					this.$toastr.w('Classe deve ser informada!', 'Atenção!');
					$('#cbclasseatribuir').focus();
					return;
				}
                if (vself.vRegimeClasse !== vself.vCrtFilial) {
                    vself.$toastr.w('A classe selecionada não corresponde à filial selecionada. Por favor, selecione outra classe.', 'Atenção!');
                    $("#cbclasseatribuir").val(null).trigger('change');
                    return;
                } 
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição da classe para os produtos selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){
                                    let lstprodutosatribuir = [];
                                    for (let produto of vself.$refs.reflstprodutos.selected_items) {
                                        lstprodutosatribuir.push(produto.id);
                                    }
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuirclasse'},
                                        {parametro: 'opcaoclasse',      valor : vself.vopcaoclasseatribuir},
                                        {parametro: 'produtos',         valor : JSON.stringify(lstprodutosatribuir)},
                                        {parametro: 'idclasseatribuir', valor : vself.vidclasseatribuir},
                                        {parametro: 'idfilialatribuir', valor : vself.vidfilialatribuir},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'todosprodutos',    valor : vself.vatribuitodosprodutos === false ? 0 : 1},
                                        {parametro: 'codop',            valor : '002Z.002M.005M'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuirclasse').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pagina_atual  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregaprodutos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },200);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },
            mtdrotinacampos(){
                if (!util.opcaousuario('002Z.002M.010M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (this.$refs.reflstprodutos.selected_items.length === 0){
                        this.$toastr.w('Selecione os produtos para a atribuição dos campos!', 'Atenção!');
                        return;
                    }
                    this.valcomis            = 0;
                    this.vatribuircomis      = false
                    this.vreferenciacampos   = '';
                    this.vfracionadocampos   = 1;
                    this.vsituacaocampos     = 1;
                    this.vatribuirsituacao   = false;
                    this.vatribuirreferencia = false;
                    this.vatribuirfracionado = false;
                    this.vatribuiridunidade  = false;
                    this.vatribuiridmarca    = false;
                    this.vatribuiridgrupo    = false;
                    this.vatribuiridsubgrupo = false;
                    this.vatribuiridncm      = false;
                    this.vatribuiridcest     = false;
                    this.vatribuirlocalizacao= false;
                    this.vatribuirsetor      = false;
                    this.vatribuirvalidade   = false;
                    this.vdiasvalidadeatr    = 0;
                    this.vatribuirecommerce  = false;
                    this.vecommerceatr       = 0;

                    $('#cbunidadecampos').val(null).trigger('change');
                    $('#cbmarcacampos').val(null).trigger('change');
                    $('#cbgrupocampos').val(null).trigger('change');
                    $('#cbsubgrupocampos').val(null).trigger('change');
                    $('#cbncmcampos').val(null).trigger('change');
                    $('#cbcestcampos').val(null).trigger('change');
                    $('#cbfilialatribuirloc').val(null).trigger('change');
                    $('#cbsetorprodutoatribuir').val(null).trigger('change');
                    $('#mdatribuircampos').modal('show');
                }
            },
            mtdatribuircampos(){
                let vself = this;
                if (!this.vatribuirreferencia && !this.vatribuirfracionado &&
                    !this.vatribuiridunidade && !this.vatribuiridmarca && !this.vatribuiridgrupo &&
                    !this.vatribuiridsubgrupo && !this.vatribuiridncm && !this.vatribuiridcest &&
                    !this.vatribuirlocalizacao && !this.vatribuirsituacao && !this.vatribuirsetor && 
                    !this.vatribuircomis && !this.vatribuirvalidade && !this.vatribuirecommerce && 
                    !this.vatribuircbavista && !this.vatribuircbaprazo){
					this.$toastr.w('Selecione ao menos um campo para a atribuição!', 'Atenção!');
					return;
                }
				if (this.vatribuiridunidade === true && this.vidunidadecampos === null){
					this.$toastr.w('Campo "Unidade" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbunidadecampos').focus();
					return;
                }
				if (this.vatribuiridmarca === true && this.vidmarcacampos === null){
					this.$toastr.w('Campo "Marca" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbmarcacampos').focus();
					return;
                }
				if (this.vatribuiridgrupo === true && this.vidgrupocampos === null){
					this.$toastr.w('Campo "Grupo" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbgrupocampos').focus();
					return;
                }
				if (this.vatribuiridsubgrupo === true && this.vidsubgrupocampos === null){
					this.$toastr.w('Campo "Subgrupo" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbsubgrupocampos').focus();
					return;
                }
				if (this.vatribuiridncm === true && this.vidncmcampos === null){
					this.$toastr.w('Campo "NCM" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbncmcampos').focus();
					return;
                }
				if (this.vatribuiridcest === true && this.vidcestcampos === null){
					this.$toastr.w('Campo "CEST" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbcestcampos').focus();
					return;
                }
                if (this.vatribuirvalidade === true && parseInt(this.vdiasvalidadeatr) <= 0){
					this.$toastr.w('Campo "VALIDADE" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbatribuirvalidade').focus();
					return;
                }
                if (this.vatribuircbavista === true && parseInt(this.valcashbackavista) <= 0){
					this.$toastr.w('Campo "CASHBACK À VISTA" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbatribuircb').focus();
					return;
                }
                if (this.vatribuircbaprazo === true && parseInt(this.vatribuircbaprazo) <= 0){
					this.$toastr.w('Campo "CASHBACK À PRAZO" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbatribuircbap').focus();
					return;
                }

				if (this.vatribuirlocalizacao === true){
                    if (this.vidfilialatribuirloc === null){
                        this.$toastr.w('Campo "Localização" foi selecionado, portanto, a filial deve ser informada!', 'Atenção!');
                        $('#cbfilialatribuirloc').select2('open');
                        return;
                    }
                    if (this.vidlocalizacaoatribuir === null){
                        this.$toastr.w('Campo "Localização" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                        $('#cblocalizacaoatribuir').select2('open');
                        return;
                    }
                }

                let stratribuir = "";

                if (this.vatribuirsituacao){
                    stratribuir = 'stpro='+this.vsituacaocampos+', ';
                }
                if (this.vatribuirreferencia){
                    stratribuir = stratribuir + 'referencia="'+this.vreferenciacampos+'", ';
                }
                if (this.vatribuirfracionado){
                    stratribuir = stratribuir + 'fracionado='+this.vfracionadocampos+', ';
                }
                if (this.vatribuiridunidade){
                    stratribuir = stratribuir + 'und="'+this.vidunidadecampos+'", ';
                }
                if (this.vatribuiridmarca){
                    stratribuir = stratribuir + 'idmarca='+this.vidmarcacampos+', ';
                }
                if (this.vatribuiridgrupo){
                    stratribuir = stratribuir + 'idgrupo='+this.vidgrupocampos+', ';
                }
                if (this.vatribuiridsubgrupo){
                    stratribuir = stratribuir + 'idsubgrupo='+this.vidsubgrupocampos+', ';
                }
                if (this.vatribuirsetor){
                    stratribuir = stratribuir + 'idsetor='+this.vidsetorprodutoatribuir+', ';
                }
                if (this.vatribuiridncm){
                    stratribuir = stratribuir + 'idncm="'+this.vidncmcampos+'", ';
                }
                if (this.vatribuiridcest){
                    stratribuir = stratribuir + 'idcest="'+this.vidcestcampos+'", ';
                }
                if (this.vatribuircomis){
                    stratribuir = stratribuir + 'fatcomissao='+this.valcomis+', ';
                }
                if (this.vatribuirvalidade){
                    stratribuir = stratribuir + 'diasvalidade='+this.vdiasvalidadeatr+', ';
                }
                if (this.vatribuirecommerce){
                    stratribuir = stratribuir + 'ecommerce='+this.vecommerceatr+', ';
                }
                if (stratribuir !== ""){
                    stratribuir = stratribuir.substring(0, stratribuir.length - 2);//remove a ", " do final da string
                }
                console.log("stratribuir:", stratribuir);

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição dos campos aos produtos selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){
                                    let lstprodutosatribuir = '';
                                    for (let produto of vself.$refs.reflstprodutos.selected_items) {
                                        lstprodutosatribuir = lstprodutosatribuir + produto.id + ', ';
                                    }
                                    lstprodutosatribuir = lstprodutosatribuir.substring(0, lstprodutosatribuir.length - 2);//remove a ", " do final da string
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuircampos'},
                                        {parametro: 'stratribuir',      valor : stratribuir},
                                        {parametro: 'atribuirloc',      valor : vself.vatribuirlocalizacao ? 1 : 0},
                                        {parametro: 'idfilialloc',      valor : vself.vidfilialatribuirloc},
                                        {parametro: 'idlocalizacao',    valor : vself.vidlocalizacaoatribuir},
                                        {parametro: 'pcashbackavista',  valor : vself.valcashbackavista},
                                        {parametro: 'pcashbackaprazo',  valor : vself.valcashbackaprazo},

                                        {parametro: 'produtos',         valor : lstprodutosatribuir},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',            valor : '002Z.002M.010M'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuircampos').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pagina_atual  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregaprodutos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },200);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },
            mtdrotinatabela(){
                // if (!util.opcaousuario('002Z.002M.005M', this.$store.state.perfilusuario)){
                //     this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                // }else {
                    if (this.$refs.reflstprodutos.selected_items.length === 0){
                        this.$toastr.w('Selecione os produtos para a atribuição da tabela!', 'Atenção!');
                        return;
                    }
                    this.vidtabelaatribuir               = null;
                    this.vmrgtabelaatribuir              = 0;
                    this.vprecoatribuir                  = 0;
                    this.vtipoatribuirtabela             = 0;
                    this.vcomissaotabelaatribuir         = 0;
                    this.vqtdmintabelaatribuir           = 0;
                    this.vdescontotabelaatribuir         = 0;
                    this.vopatribuicaotabela             = 0;
                    this.vidtabelaatribuirorigem         = null;
                    this.vidtabelaatribuirdestino        = null;
                    this.vmrgtabelabaseoutra             = 0;
                    this.vidatribuitodastb               = false;


                    $('#cbtabelaatribuir').val(null).trigger('change');
                    $('#cbtabelaatribuirorigem').val(null).trigger('change');
                    $('#cbtabelaatribuirdestino').val(null).trigger('change');
                    $('#mdatribuirtabela').modal('show');
                //}
            },
            mtdatribuirtabela(){
                let vself = this;
                console.log(vself.vqtdmintabelaatribuir);
                // ATRIBUIÇÃO DIRETA
                if(vself.vopatribuicaotabela  == 0){
                    if(vself.vopatribuicaotabela == 0){
                        if(vself.vidatribuitodastb == false){
                            if (this.vidtabelaatribuir === null){
                                this.$toastr.w('Tabela de preço deve ser informada!', 'Atenção!');
                                $('#cbtabelatribuir').select2('open');
                                return;
                            }
                        }
                        if (!util.verificatabelausuario(this.vidtabelaatribuir, this.$store.state.usuario.tabelasusuario, this.$store.state.usuario.todastabelas)){
                            this.$toastr.w('Seu usuário não esta autorizado a operar esta tabela de preço!', 'Atenção!');
                            $('#cbtabelaatribuir').val(null).trigger('change');
                            return;
                        }
                        if (parseInt(vself.vtipoatribuirtabela) === 1){
                            if (this.vprecoatribuir <= 0){
                                this.$toastr.w('O preço a ser atribuído deve ser informada!', 'Atenção!');
                                $('#edprecoatribuir').select2('open');
                                return;
                            }
                        }
                        $.confirm({
                            title: 'Confirmação!',
                            content: 'Confirma a atribuição da tabela de preços para os produtos selecionados?',
                            icon: 'fa fa-question-circle',
                            escapeKey: true,
                            backgroundDismiss: true,
                            escapeKey: 'nao',
                            type: 'dark',
                            typeAnimated: true,
                            buttons: {
                                sim: {
                                    text: '<u>S</u>im',
                                    keys: ['s', 'S'],
                                    btnClass: 'btn-blue',
                                    action: function () {
                                        this.buttons.sim.disable();
                                        setTimeout(function(){
                                            let lstprodutosatribuir = [];
                                            for (let produto of vself.$refs.reflstprodutos.selected_items) {
                                                let totalcustoitem = util.calculacustoproduto(vself, 
                                                    parseFloat(produto.pipi)/100,
                                                    parseFloat(produto.picms)/100,
                                                    parseFloat(produto.pfrete)/100,
                                                    parseFloat(produto.vst),
                                                    parseFloat(produto.ppis/100),
                                                    parseFloat(produto.pcofins/100),
                                                    parseFloat(produto.poutros/100),
                                                    parseFloat(produto.prcompra),
                                                    parseFloat(produto.prvendamedio),
                                                    vself.$store.state.filialpadrao.formulacustopro
                                                );
                                                produto.vprcusto = totalcustoitem;  
        
                                                lstprodutosatribuir.push(produto);
                                            }
                                            let loader = vself.$loading.show();
                                            let parametros = [];
                                            if(vself.vidatribuitodastb == false){
                                             parametros      = [
                                                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                                    {parametro: 'op',               valor : 'atribuirtabela'},
                                                    {parametro: 'tipoabribuicao',   valor : vself.vtipoatribuirtabela},
                                                    {parametro: 'produtos',         valor : JSON.stringify(lstprodutosatribuir)},
                                                    {parametro: 'idtabela', 		valor : vself.vidtabelaatribuir},
                                                    {parametro: 'mrglucro', 		valor : vself.vmrgtabelaatribuir},
                                                    {parametro: 'preco',            valor : vself.vprecoatribuir},
                                                    {parametro: 'pcomissao', 		valor : vself.vcomissaotabelaatribuir},
                                                    {parametro: 'qtdminima', 		valor : vself.vqtdmintabelaatribuir},
                                                    {parametro: 'desconto', 		valor : vself.vdescontotabelaatribuir},
                                                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                                    {parametro: 'optabela',         valor : vself.vopatribuicaotabela},
                                                    {parametro: 'atribuitodas',     valor : vself.vidatribuitodastb == false ? 0 : 1},
                                                    {parametro: 'codop',            valor : '002Z.002M.005M'},
                                                ];
                                            }else{
                                                parametros      = [
                                                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                                    {parametro: 'op',               valor : 'atribuirtabela'},
                                                    {parametro: 'tipoabribuicao',   valor : vself.vtipoatribuirtabela},
                                                    {parametro: 'produtos',         valor : JSON.stringify(lstprodutosatribuir)},
                                                    {parametro: 'tabelaspr',        valor : JSON.stringify(vself.todastabelas)},
                                                    {parametro: 'preco',            valor : vself.vprecoatribuir},
                                                    {parametro: 'pcomissao', 		valor : vself.vcomissaotabelaatribuir},
                                                    {parametro: 'qtdminima', 		valor : vself.vqtdmintabelaatribuir},
                                                    {parametro: 'desconto', 		valor : vself.vdescontotabelaatribuir},
                                                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                                    {parametro: 'optabela',         valor : vself.vopatribuicaotabela},
                                                    {parametro: 'atribuitodas',     valor : vself.vidatribuitodastb == false ? 0 : 1},
                                                    {parametro: 'codop',            valor : '002Z.002M.005M'},
                                                ];
                                            }
                                            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                            retorno.then(function (response) {
                                                loader.hide();
                                                if ($.isNumeric(response.data.status)){
                                                    $('#mdatribuirtabela').modal('hide');
                                                    vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                                    vself.pagina_atual  = 1;
                                                    vself.mtdcancelaredicao();
                                                    vself.mtdcarregaprodutos(1);
                                                }else{
                                                    let tpret = response.data.substring(0,1);
                                                    switch (tpret) {
                                                        case 'I':
                                                            vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                            break;
                                                        case 'E': default:
                                                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                            break;
                                                    }
                                                }
                                            }).catch(function (response) {
                                                loader.hide();
                                                vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                            });
                                        },200);
                                    },
                                },
                                nao: {
                                    text: '<u>N</u>ão',
                                    keys: ['n', 'N'],
                                    action: function () {
                                    }
                                }
                            }
                        });
                    }
                }else{ //ATRIBUIÇÃO COM BASE EM OUTRA TB
                    if(this.vidtabelaatribuirorigem === null){
                            this.$toastr.w('Tabela de origem deve ser informada!', 'Atenção!');
                            $('#cbtabelaatribuirorigem').select2('open');
                            return;
                        }
                    // if(this.vidtabelaatribuirdestino === null){
                    //     this.$toastr.w('Tabela de à atribuir deve ser informada!', 'Atenção!');
                    //         $('#cbtabelaatribuirdestino').select2('open');
                    //         return;
                    // }
                    if (vself.vidtabelaatribuirorigem === vself.vidtabelaatribuirdestino){
                        vself.$toastr.w('Tabelas não podem ser as mesmas!', 'Atenção!');
                        $('#cbtabelaatribuirdestino').select2('open');
                        return;
                    }
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma a atribuição da tabela de preços para os produtos selecionados?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: true,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    this.buttons.sim.disable();
                                    setTimeout(function(){
                                        let lstmargenspersonalizadas = vself.vdatatabelaatribuirdestino
                                            .filter(item => item.selecionado)
                                            .map(item => ({
                                                id: item.id,          
                                                descricao: item.descricao,
                                                margem: item.margem    
                                            }));

                                        let lstprodutosatribuir = [];
                                        lstprodutosatribuir = vself.$refs.reflstprodutos.selected_items.map(produto => produto.id);
                                        // console.log(lstprodutosatribuir);
                                        let loader = vself.$loading.show();
                                        let parametros      = [
                                            {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                            {parametro: 'op',               valor : 'atribuirtabela'},
                                            {parametro: 'produtos',         valor : JSON.stringify(lstprodutosatribuir)},
                                            {parametro: 'margenspersonalizadas', valor: JSON.stringify(lstmargenspersonalizadas)},
                                            {parametro: 'optabela',         valor : vself.vopatribuicaotabela},
                                            {parametro: 'idtabelaorigem',   valor : vself.vidtabelaatribuirorigem},
                                            // {parametro: 'idtabeladestino',  valor : vself.vidtabelaatribuirdestino },
                                            // {parametro: 'idtabeladestino',  valor : vself.vdatatabelaatribuirdestino.filter(item => item.selecionado)[0].id},
                                            {parametro: 'margem', 		    valor : vself.vmrgtabelabaseoutra},
                                            {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                            {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                            {parametro: 'codop',            valor : '002Z.002M.005M'},
                                        ];
                                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                        retorno.then(function (response) {
                                            loader.hide();
                                            if ($.isNumeric(response.data.status)){
                                                $('#mdatribuirtabela').modal('hide');
                                                vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                                vself.pagina_atual  = 1;
                                                vself.mtdcancelaredicao();
                                                let lstidprodutos = response.data.lstprodutos.map(idproduto => `'${idproduto}'`).join(',');
                                                let filtro      = "and p.id IN ("+lstidprodutos+")";
                                                let parametros  = [
                                                    {parametro: 'idclientesac',             valor : vself.$store.state.filialpadrao.idcliente},
                                                    {parametro: 'diretorioimagens',         valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                                                    {parametro: 'op',                       valor : 'listagem'},
                                                    {parametro: 'idusuario',                valor : vself.$store.state.usuario.id},
                                                    {parametro: 'todastabelas',             valor : vself.$store.state.usuario.todastabelas},
                                                    {parametro: 'filtro',                   valor : filtro},
                                                    {parametro: 'idestoque',                valor : vself.$store.state.filialpadrao.idestoque},
                                                    {parametro: 'limit',                    valor : 99999999999},
                                                    {parametro: 'offset',                   valor : (parseInt(1) -1) * 999999},
                                                    {parametro: 'reserva',                  valor : util.opcaousuario('002Z.002M.020M', vself.$store.state.perfilusuario) ? 1 : 0},
                                                    {parametro: 'estoquegeralconsultas',    valor : vself.$store.state.usuario.estoquegeralconsultas},
                                                ];
                                                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                                retorno.then(function (response) {
                                                    if(response.data.length > 0){
                                                        vself.lstprodutos = response.data;
                                                    }
                                                    loader.hide();
                                                }).catch(function (response) {
                                                    vself.lstprodutos = [];
                                                    loader.hide();
                                                });
                                                vself.$refs.reflstprodutos.selected_items = [];
                                                loader.hide();
                                            }else{
                                                let tpret = response.data.substring(0,1);
                                                switch (tpret) {
                                                    case 'I':
                                                        vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                        break;
                                                    case 'E': default:
                                                        vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                        break;
                                                }
                                            }
                                        }).catch(function (response) {
                                            loader.hide();
                                            vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                        });
                                    },200);
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });


                }
                
            },

            mtdvisualizarestoque(produto){
                this.idprodutoestoque   = produto.id;
                this.descproestoque     = produto.descricao;
                $('#mdestoqueproduto').modal('show');
            },
            mtdvisualizarfornecedores(produto){
                this.idprodutofornecedores   = produto.id;
                this.descprofornecedores     = produto.descricao;
                $('#mdfornecedores').modal('show');
            },
            mtdpreparafiltrohisvendas(){
                let vself = this;
                console.log(vself.pdtinivenda);
                let rfiltro = ` AND tip.idproduto=${vself.vidprodutohisvendas}`;

                if(parseInt(vself.pfiltrodatavenda) === 1){
                    rfiltro +=` AND tp.dtfatura BETWEEN '${util.InverterData(vself.pdtinivenda)} 00:00:00' AND '${util.InverterData(vself.pdtfimvenda)} 23:59:59'`;
                }

                if (vself.vidfilialhisvendas !== null){
                    rfiltro += ` AND tp.idfilial=${vself.vidfilialhisvendas}`;
                }

                if (vself.vidvendedorhisvendas !== null){
                    rfiltro += ` AND tp.idvendedor=${vself.vidvendedorhisvendas}`;
                }
                // console.log(rfiltro)
                return rfiltro;
            },
            mtdvisualizarvendas(produto) {
                this.lstVendasProduto       = [];
                this.prodAtualHisVendas     = produto;
                this.vidprodutohisvendas    = produto.id;
                this.vdescprodutohisvendas  = produto.descricao;
                this.isLoadingHisVendas     = true;
                this.pfiltrodatavenda       = "1"
                this.pdtinivenda            = util.DataAtual(true, false);
                this.pdtfimvenda            = util.DataAtual(true, false);
                $('#cbfilialhisvendas').val(null).trigger('change');
                $('#cbvendedorhisvendas').val(null).trigger('change');
                this.pagruparhisvendas      = "0";
                $('#mdlvendas').modal('show');
                this.mtdpesquisahistoricovendas();
            },
            mtdpesquisahistoricovendas(){
                let vself = this;
                let filtro = vself.mtdpreparafiltrohisvendas();
                vself.isLoadingHisVendas = true;
                let parametros      = [
                    {parametro: 'idclientesac',  valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',            valor : 'vendasdeproduto'},
                    {parametro: 'idproduto',     valor : vself.vidprodutohisvendas},
                    {parametro: 'filtro',        valor : filtro},
                    {parametro: 'agrupar',       valor : vself.pagruparhisvendas},
                ];

                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    vself.lstVendasProduto = response.data;
                    setTimeout(function (){
                            vself.isLoadingHisVendas = false;
                    }, 1000);
                    
                }).catch(function (response) {
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.isLoadingHisVendas = false;
                });
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('002Z.002M.015M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'IMPORTAÇÃO DE CADASTRO DE PRODUTOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado     = null;
                    this.vlimpardados       = false;
                    this.vimportarcodigos   = false;
                    this.vreconstruirchaves = false;
                    $('#pnimportacao').fadeIn(700);
                }
            },
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizimportarprodutos.xls', '_blank');
            },
            mtdselecionararquivo(event){
                let vself            = this;
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstprodutos    = [];
                        vself.pqtd_paginas   = 0;
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let opcodigos        = vself.vimportarcodigos === false ? '0' : '1';
                        let opreconstruir    = vself.vreconstruirchaves === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarprodutos.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&importarcodigos='+opcodigos+'&codop=002Z.002M.015M'+
                                               '&reconstruirchaves='+opreconstruir;
                        vself.arqselecionado = null;
                        window.open(url, '_blank');
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });
            },
            mtdbaixaretiquetador(){
                window.open('https://www.rillsoft-app.cloud/arquivos/manager/programas/instaladorlabelcreator.exe', '_blank');
            },
            mtdrotinaarquivo(){
                // if (!util.opcaousuario('002Z.002M.005M', this.$store.state.perfilusuario)){
                //     this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                // }else {
                    // if (this.$refs.reflstprodutos.selected_items.length === 0){
                    //     this.$toastr.w('Selecione os produtos para geração do arquivo!', 'Atenção!');
                    //     return;
                    // }
                    this.vtipoarquivo       = 0;
                    this.vidfilialarquivo   = null;
                    this.vidncmarquivo      = null;
                    this.vidclassearquivo   = null;
                    this.videstoquearquivo  = null;
                    this.vidtabelaarquivo   = null;
                    this.vidmarcaarquivo    = null,
                    this.vidgrupoarquivo    = null,
                    this.vidsubgrupoarquivo = null,
                    this.vidsetorarquivo    = null,
                    this.vstproarquivo      = 1;
                    this.vfracionadoarquivo = 2;
                    this.vlayoutbalanca     = 1;
                    this.vestoquearquivo    = 2;
                    this.lstprodutosexportar= [];
                    $('#cbfilialarquivo').val(null).trigger('change');
                    $('#cbncmarquivo').val(null).trigger('change');
                    $('#cbclassearquivo').val(null).trigger('change');
                    $('#cbestoquearquivo').val(null).trigger('change');
                    $('#cbtabelaarquivo').val(null).trigger('change');
                    $('#cbmarcaarquivo').val(null).trigger('change');
                    $('#cbgrupoarquivo').val(null).trigger('change');
                    $('#cbsubgrupoarquivo').val(null).trigger('change');
                    $('#cbsetorarquivo').val(null).trigger('change');
                    $('#mdgerararquivo').modal('show');
                //}
            },
            mtdgerararquivo(){
                let vself = this;

                if (parseInt(vself.vtipoarquivo) === 2){
                    if (parseInt(vself.vestoquearquivo) < 2 && vself.videstoquearquivo === null){
                        vself.$toastr.w('Estoque deve ser informado!', 'Atenção!');
                        $('cbestoquearquivo').select2('open');
                        return;
                    }
                }
                if (parseInt(vself.vtipoarquivo) < 2){
                    if (vself.vidtabelaarquivo === null){
                        vself.$toastr.w('Tabela de preços deve ser informada!', 'Atenção!');
                        $('cbtabelaarquivo').select2('open');
                        return;
                    }
                }else{
                    if (vself.vidfilialarquivo === null){
                        vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                        $('cbfilialarquivo').select2('open');
                        return;
                    }
                }
                let rfiltro = '';
                if (parseInt(this.vstproarquivo) < 2){
                    rfiltro = rfiltro + ' and p.stpro='+this.vstproarquivo;
                }
                if (this.vidmarcaarquivo !== null){
                    rfiltro = rfiltro + ' and p.idmarca='+this.vidmarcaarquivo;
                }
                if (this.vidgrupoarquivo !== null){
                    rfiltro = rfiltro + ' and p.idgrupo='+this.vidgrupoarquivo;
                }
                if (this.vidsubgrupoarquivo !== null){
                    rfiltro = rfiltro + ' and p.idsubgrupo='+this.vidsubgrupoarquivo;
                }
                if (this.vidsetorarquivo !== null){
                    rfiltro = rfiltro + ' and p.idsetor='+this.vidsetorarquivo;
                }
                if (parseInt(this.vfracionadoarquivo) < 2){
                    rfiltro = rfiltro + ' and p.fracionado='+this.vfracionadoarquivo;
                }
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : parseInt(vself.vtipoarquivo) < 2 ? 'arquivoprodutos' : 'listagemexportacao'},
                    {parametro: 'tipoarquivo',      valor : vself.vtipoarquivo},
                    {parametro: 'filtro',           valor : rfiltro},
                    {parametro: 'idfilial', 		valor : vself.vidfilialarquivo},
                    {parametro: 'idclasse', 		valor : vself.vidclassearquivo  === null ? 0 : vself.vidclassearquivo},
                    {parametro: 'idestoque', 		valor : vself.videstoquearquivo === null ? 0 : vself.videstoquearquivo},
                    {parametro: 'estoque', 		    valor : vself.vestoquearquivo},
                    {parametro: 'idtabela', 		valor : vself.vidtabelaarquivo},
                    {parametro: 'layoutbalanca',    valor : vself.vlayoutbalanca},

                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    // return
                    if (parseInt(vself.vtipoarquivo) < 2){
                        let vconteudoarquivo = response.data;
                        if (parseInt(vself.vtipoarquivo) === 0){
                            if (parseInt(vself.vlayoutbalanca) === 0){
                                util.download(vconteudoarquivo, 'CADTXT.TXT');
                            }else{
                                util.download(vconteudoarquivo, 'TXITENS.TXT');
                            }
                        }else{
                            util.download(vconteudoarquivo, 'PRICETAB.TXT');
                        }
                    }else{
                        vself.lstprodutosexportar = response.data;
                        console.log(vself.lstprodutosexportar);
                        setTimeout(() => {
                            vself.mtdexportarexcel();
                        }, 500);
                    }
                    $('#mdgerararquivo').modal('hide');
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar a solicitação. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdrotinaconsultaprodutoscodigo(){
                $('#mdconsultaporcodigo').modal('show');
            },
            mtdlistarprodutosporcodigo(){
                var vself           = this;
                if (vself.pcodigoconsultar.trim() !== ''){
                    $("#myInputID").blur();
                    let loader      = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor  : 'consultarcodigo'},
                        {parametro: 'codigo',       valor  : vself.pcodigoconsultar}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.lstprodutoconsultacodigo = response.data;

                        if(vself.lstprodutoconsultacodigo.length === 0){
                            $.confirm({
                                title: 'Confirmação!',
                                content: 'O código <strong>'+vself.pcodigoconsultar+'</strong> não foi encontrado. deseja cadastrar?',
                                icon: 'fa fa-question-circle',
                                escapeKey: true,
                                backgroundDismiss: false,
                                escapeKey: 'nao',
                                type: 'dark',
                                typeAnimated: true,
                                buttons: {
                                    sim: {
                                        text: '<u>S</u>im',
                                        keys: ['s', 'S'],
                                        btnClass: 'btn-blue',
                                        action: function () {
                                            setTimeout(function(){
                                                vself.mtdprocessanovocomcodigo();
                                            },200);
                                        },
                                    },
                                    nao: {
                                        text: '<u>N</u>ão',
                                        keys: ['n', 'N'],
                                        action: function () {
                                        }
                                    }
                                }
                            });
                        }
                    }).catch(function (response) {
                        this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        loader.hide();
                    });
                }
            },
            mtdrotinaoperacoestabelas(){
                if (!util.opcaousuario('002Z.002M.012M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (this.$refs.reflstprodutos.selected_items.length > 0){
                        this.$toastr.w('Há produtos selecionados, este módulo não funciona por seleção!', 'Atenção!');
                        return;
                    }
                    this.mtdConsultaOperacoesTabelas();
                    this.otpoperacao             = 0;
                    this.oidtabelaorigem         = null;
                    this.oidtabelaatribuirop     = null;
                    this.omrgtabelaatribuirop    = 0;
                    this.oidmarcaatribuirop      = null;
                    this.oidgrupoatribuirop      = null;
                    this.oidsubgrupoatribuirop   = null;
                    this.oidsetoratribuirop      = null;
                    this.ofatortabelaajuste      = 0;
                    this.otpfatorajuste          = 0;

                    $('#cbtabelaorigem').val(null).trigger('change');
                    $('#cbtabelaatribuirop').val(null).trigger('change');
                    $('#cbmarcaatribuirop').val(null).trigger('change');
                    $('#cbgrupoatribuirop').val(null).trigger('change');
                    $('#cbsubgrupoatribuirop').val(null).trigger('change');
                    $('#cbsetoratribuirop').val(null).trigger('change');

                    $('#mdoperacoestabelas').modal('show');

                }
            },
            mtdconfirmaroperacaotabelas(){
                let vself = this;
                if (parseInt(vself.otpoperacao) === 0){
                    if (vself.oidtabelaorigem === null){
                        vself.$toastr.w('Tabela de origem deve ser informada!', 'Atenção!');
                        $('#cbtabelaorigem').select2('open');
                        return;
                    }
                }
                if (parseInt(vself.otpoperacao) === 0 ){
                    // if (vself.oidtabelaatribuirop === null){
                    //     vself.$toastr.w('Tabela à abribuir deve ser informada!', 'Atenção!');
                    //     $('#cbtabelaatribuirop').select2('open');
                    //     return;
                    // }
                    //Nilson 25/01/2023 - Comentei pois pode ser usado para criar tabela de promoção
                    //e o valor de alguns itens podem ser o mesmo de uma tabela convencional
                    // if (vself.omrgtabelaatribuirop === 0){
                    //     vself.$toastr.w('Informe o percentual da margem!', 'Atenção!');
                    //     $('#edmargematribuirop').focus();
                    //     return;
                    // }
                    if (vself.oidtabelaorigem === vself.oidtabelaatribuirop){
                        vself.$toastr.w('Tabelas não podem ser as mesmas!', 'Atenção!');
                        $('#cbtabelaatribuirop').select2('open');
                        return;
                    }
                }
                if (parseInt(vself.otpoperacao) === 1){
                    if (vself.oidtabelaatribuirop === null){
                        vself.$toastr.w('Tabela à abribuir deve ser informada!', 'Atenção!');
                        $('#cbtabelaatribuirop').select2('open');
                        return;
                    }
                }

                if (parseInt(vself.otpoperacao) === 3){
                    if (vself.oidtabelaorigem === null){
                        vself.$toastr.w('Tabela de origem deve ser informada!', 'Atenção!');
                        $('#cbtabelaorigem').select2('open');
                        return;
                    }
                    if (vself.ofatortabelaajuste === 0){
                        vself.$toastr.w('Fator de ajuste deve ser informado!', 'Atenção!');
                        $('#edfatoratribuirop').focus();
                        return;
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma "'+$('#cbtpoperacao :selected').text()+'"?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                $('#mdoperacoestabelas').modal('hide');
                                setTimeout(function(){
                                    vself.mtdatribuiroperacaotabelas();
                                },200);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },
            mtdatribuiroperacaotabelas(){
                let vself           = this;
                let filtroprodutos  = "";

                if (vself.oidmarcaatribuirop !== null){
                    filtroprodutos = " and p.idmarca="+vself.oidmarcaatribuirop;
                }

                if (vself.oidgrupoatribuirop !== null){
                    filtroprodutos = filtroprodutos + " and p.idgrupo="+vself.oidgrupoatribuirop;
                }

                if (vself.oidsubgrupoatribuirop !== null){
                    filtroprodutos = filtroprodutos + " and p.idsubgrupo="+vself.oidsubgrupoatribuirop;
                }

                if (vself.oidsetoratribuirop !== null){
                    filtroprodutos = filtroprodutos + " and p.idsetor="+vself.oidsetoratribuirop;
                }
                let lstmargenspersonalizadasoptabelas = vself.vdataoperacoestabela
                                            .filter(item => item.selecionado)
                                            .map(item => ({
                                                id: item.id,          
                                                descricao: item.descricao,
                                                margem: item.margem    
                                            }));

                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'operacoestabelas'},
                    {parametro: 'tpoperacao', 		valor : vself.otpoperacao},
                    {parametro: 'margenspersonalizadas', valor: JSON.stringify(lstmargenspersonalizadasoptabelas)},
                    {parametro: 'idtabelaorigem',   valor : vself.oidtabelaorigem},
                    {parametro: 'idtabelaatribuir', valor : vself.oidtabelaatribuirop },
                    {parametro: 'filtroprodutos',   valor : filtroprodutos},
                    {parametro: 'margem',           valor : vself.omrgtabelaatribuirop},
                    {parametro: 'tpfatorajuste',    valor : vself.otpfatorajuste},
                    {parametro: 'fatorajuste',      valor : vself.ofatortabelaajuste},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : '002Z.002M.012M'}
                ];
                
                // console.log(filtroprodutos);
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Procedimento realizado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = '';
                        vself.pagina_atual  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdexecutapesquisa();
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar a solicitação. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdnovalocalizacao(){
                if (!util.opcaousuario('001Z.009Y.001Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (this.vidfiliallocalizacao == null) {
                        this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                        $("#cbfilialestoque").select2('open');
                        return;
                    }
                    this.vnovalocalizacao        = true;
                    this.vdescricaolocalizacao   = '';
                    this.vidnovalocalizacao      = '';
                    setTimeout(() => {
                        $('#eddescricaolocalizacao').focus();
                    }, 200);
                }
            },
            mtdconfirmarnovalocalizacao(){
                let vself  = this;

                if (vself.vidfiliallocalizacao == null) {
                    vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialestoque").select2('open');
                    return;
                }

                if (vself.vdescricaolocalizacao == '') {
                    vself.$toastr.w('Descrição da localização deve ser informada!', 'Atenção!');
                    $("#eddescricaolocalizacao").focus();
                    return;
                }

                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : '',
                    'descricao'         : vself.vdescricaolocalizacao.toUpperCase(),
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : 1},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '001Z.009Y.001Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlocalizacoes.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Localização cadastrada com sucesso!', 'Informação!');
                        vself.idnovalocalizacao     = response.data;
                        var defloc  = new Option(vself.vdescricaolocalizacao.toUpperCase(), vself.idnovalocalizacao, true, true);
                        $('#cblocalizacao').append(defloc).trigger('change');
                        setTimeout(() => {
                           vself.mtdinclocalizacao();
                        }, 200);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.idnovalocalizacao     = response.data.substring(4, 8);
                                var defloc  = new Option(vself.vdescricaolocalizacao.toUpperCase(), vself.idnovalocalizacao, true, true);
                                $('#cblocalizacao').append(defloc).trigger('change');
                                setTimeout(() => {
                                vself.mtdinclocalizacao();
                                }, 200);
                            break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                setTimeout(() => {
                                    $('#eddescricaolocalizacao').focus();
                                }, 200);
                            break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdcancelarnovalocalizacao(){
                this.vnovalocalizacao        = false;
                this.vdescricaolocalizacao   = '';
                this.vidnovalocalizacao      = '';
                setTimeout(() => {
                    $("#cblocalizacao").select2('open');
                }, 200);
            },
            mtdexportarexcel(){
                $('#btexportarexcel').click();
            },
            mtdarquivocodigos() {
                //limpa o arquivo do input file
                const file               = document.querySelector('#btselecionararquivo');
                file.value               = '';
                this.vnomearquivo        = '';
                ///////////////////////////////
                $('#btselecionararquivo').trigger('click');
            },
            mtdrotinaprocessacodigos(){
                let vself = this;

                let varquivo                = document.getElementById("btselecionararquivo").files[0];
                vself.vnomearquivo          = varquivo.name;

                let extarq = varquivo.name.substring(varquivo.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.$toastr.w("O arquivo selecionado não possui formato válido!", 'Atenção!');
                }else{
                    let loader      = vself.$loading.show();
                    let localsalvar = vself.$store.state.configpaths.pathconferencias + vself.$store.state.filialpadrao.idcliente;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : varquivo},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : varquivo.name}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            $('#btselecionararquivo').val('');
                            vself.mtdprocessararquivocodigos(vself.$store.state.configpaths.pathconferencias + vself.$store.state.filialpadrao.idcliente+'/'+vself.vnomearquivo);
                        }else{
                            $('#btselecionararquivo').val('');
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        $('#btselecionararquivo').val('');
                    });
                }
            },
            mtdprocessararquivocodigos(arquivo){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'processararquivocodigos'},
                    {parametro: 'arquivo',      valor : arquivo}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Arquivo processado com sucesso!', 'Informação!');
                    }else{
                        vself.$toastr.e(response.data, 'Erro!');
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdbaixarmatrizcodigos(){
                window.open(this.$store.state.configpaths.pathcontrole+'arquivosimportacao/manager/matrizes/matrizimportarcodigos.xls', '_blank');
            },
            mtddefinecodigoetqpadrao(codigo, atribuir, indice){
                for (let i = 0; i < this.lstCodigos.length; i++) {
                    if (this.lstCodigos[i].codigo === codigo){
                        this.lstCodigos[i].padraoetiqueta = atribuir;
                    }else{
                        this.lstCodigos[i].padraoetiqueta = 0;
                    }
                }
            },
            mtdcalculavalorimpostoclasse(){
                let vself   = this;
                let ret     = util.itemcomimposto(vself.iclasse, parseFloat(vself.ivalorbase), 1, 0, 0);

                vself.ivalorimposto    = ret.totalimpostoitem;
                vself.ivalorcomimposto = ret.vltotalitem;
            },
            mtdvisualizarimpostovalor(){
                if (parseInt(this.opcrud) < 3){
                    this.ivalorbase              = 0;
                    this.iidclasse               = null;
                    this.iclasse                 = [];
                    this.ivalorimposto           = 0;
                    this.ivalorcomimposto        = 0;
                    $('#cbiclasse').val(null).trigger('change');
                    $('#mdimpostovalor').modal('show');
                }
            },
            mtdselecionavalorbase(){
                this.vvltabela = this.ivalorbase;
                this.mtdcalculamrgtabela();
                this.iclasse   = [];
                this.vvlvizu   = this.ivalorcomimposto;
                $('#mdimpostovalor').modal('hide');
            },
            mtddefinirmargemprvenda(){
                $('#mdatribuirmargem').modal('show');
            },
            mtdcalculamargemprvendamedio(){
                let vlmrg   = parseFloat(this.vprcusto) * parseFloat(this.amargem) / 100;
                this.avalor = (parseFloat(this.vprcusto) + vlmrg).toFixed(2);
            },
            mtdaplicarvalorprvenda(){
                this.vprvendamedio = this.avalor;
                this.vmargemprcusto= this.amargem;
                $('#mdatribuirmargem').modal('hide');
            },
            mtdinformarvalordescpromocional(){
                if (parseFloat(this.vvltabela) > 0){
                    $('#mdinformarvalordescpromocional').modal('show');
                }
            },
            mtdcalcularvalordescpromocional(){
                let dif = parseFloat(this.avalorsemdescpromocional) - parseFloat(this.avalorcomdescpromocional);
                if (parseFloat(this.avalorsemdescpromocional) > 0){
                    this.amargemdescpromocional = (parseFloat(dif) / parseFloat(this.avalorsemdescpromocional) * 100).toFixed(2);
                }else{
                    this.amargemdescpromocional = 0;
                }
            },
            mtdaplicarpercentualdescpromocional(){
                if (parseFloat(this.amargemdescpromocional) > 0){
                    this.vvldescpromocional = this.amargemdescpromocional;
                    $('#mdinformarvalordescpromocional').modal('hide');
                }else{
                    this.$toastr.w('Margem deve ser maior que 0(zero)!', 'Informação!');
                    $('#edvalorcomdescpromocional').focus();
                }
            },
			mtdimprimirpedido(idpedido, tp){
				$('#mdmenupedido').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
							this.$store.state.usuario.id, '_blank');
			},
            mtdlimpaespecifico(){
                let vself = this;
                if (parseInt(vself.vprodutoespecifico) !== 4) {
                        $('#cbanp').val(null).trigger('change');
                        vself.vidanp = null;
                        vself.vpercglp = 0;
                        vself.vpercgnn = 0;
                        vself.vpercgni = 0;
                        vself.vvlpartida = 0;
                }           
            },
            mtdinfohistvendas(idpedido){
				this.vidpedidodet = 0;
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
            },
            mtdimprimirhistvendas(idpedido){
                window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp='+0+'&idu='+
							this.$store.state.usuario.id, '_blank');	
            },
            mtdrotinadescontoqtdmin(){
                    if (this.$refs.reflstprodutos.selected_items.length === 0){
                            this.$toastr.w('Selecione os produtos para a atribuição do desconto qtd. min!', 'Atenção!');
                            return;
                    }

                    this.vidatribuirdescontoqtdmin       = null;
                    this.vdescontodescatribuir           = 0;
                    this.vqtdmindescatribuir             = 0;
                    $('#cbatribuidescqtdmin').val(null).trigger('change');

                    $('#mdatribuiqtdmin').modal('show');
                    $('#cbatribuidescqtdmin').select2('open');
            },
            mtdatribuirdescqtdmin(){
                let vself = this;
                let idprodutos = vself.$refs.reflstprodutos.selected_items.map(item => item.id);
                // console.log(idprodutos);

                if (this.vidatribuirdescontoqtdmin === null){
					this.$toastr.w('Tabela de preço deve ser informada!', 'Atenção!');
					$('#cbatribuidescqtdmin').select2('open');
					return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição desconto qtd. min para os produtos selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();

                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuirdescontoqntmin'},
                                        {parametro: 'idtabela',         valor : vself.vidatribuirdescontoqtdmin},
                                        {parametro: 'desconto',         valor : vself.vdescontodescatribuir},
                                        {parametro: 'qtdminima',        valor : vself.vqtdmindescatribuir},
                                        {parametro: 'idprodutos',       valor : JSON.stringify(idprodutos)},
                                    ];

                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuiqtdmin').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pagina_atual  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregaprodutos(1);
                                            
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
                
            },
            mdlimportaprodutosnfentrada(){
                 if (util.verificasessao(this)) {
                     let vself = this;
                     vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                     let loader          = vself.$loading.show();
                     let parametros = [
                         {parametro : 'op',           valor : 'dadosusuario'},
                         {parametro : 'idclientesac', valor : vself.$store.state.usuario.idclientesac},
                         {parametro : 'idusuario',    valor : vself.$store.state.usuario.id}
                     ];
                     let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                     retorno.then(function (response) {
                         loader.hide();
                         vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                         vself.planocliente  = response.data.plnc;
                         if (util.opcaousuario('010Z.010Z', vself.$store.state.perfilusuario)) {
                             $('#mdlconsultaprodutosnotafor').modal('show');
                         } else {
                             vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                             setTimeout(function(){
                                 return;
                             },1000);
                         }
                     }).catch(function (response) {
                         loader.hide();
                         console.log(response.message);
                     });
                 }
                
            },
            mtdexportarnota(){
                let vself = this;

                $("#mdlexportanota").modal('hide');
                $("#mdnotasfor").modal('show');
            },
            mtdbuscaprodutosnota(lstidprodutos){
                var vself       = this;
                
                let loader      = this.$loading.show();;
                let filtro      = "and p.id IN ("+lstidprodutos+")";
                let parametros  = [
                    {parametro: 'idclientesac',             valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens',         valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                       valor : 'listagem'},
                    {parametro: 'idusuario',                valor : vself.$store.state.usuario.id},
                    {parametro: 'todastabelas',             valor : vself.$store.state.usuario.todastabelas},
                    {parametro: 'filtro',                   valor : filtro},
                    {parametro: 'idestoque',                valor : vself.$store.state.filialpadrao.idestoque},
                    {parametro: 'limit',                    valor : 99999999999},
                    {parametro: 'offset',                   valor : (parseInt(1) -1) * 999999},
                    {parametro: 'reserva',                  valor : util.opcaousuario('002Z.002M.020M', vself.$store.state.perfilusuario) ? 1 : 0},
                    {parametro: 'estoquegeralconsultas',    valor : vself.$store.state.usuario.estoquegeralconsultas},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    if(response.data.length > 0){
                        vself.lstprodutos = response.data;
                        $("#mdnotasfor").modal('hide');
                    }else{
                        vself.$toastr.i('Não há produtos vinculados a essa nota', 'Informação!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    vself.lstprodutos = [];
                    loader.hide();
                });

            },
            mtdselecionatodastbprvenda(){
                let vself = this;
                vself.$nextTick(() => { //carrega o toggle de mensagem
                    $('[data-toggle="tooltip"]').tooltip();
                });

                if(vself.vidtodastb == true || vself.vidatribuitodastb){
                    $('#cbtabelapreco').val(null).trigger('change');
                    $('#cbtabelaatribuir').val(null).trigger('change');
                    let loader      = this.$loading.show();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagemsimplestbprecos'},
                        {parametro: 'limit',        valor : 9999999},
                        {parametro: 'offset',       valor : (parseInt(1) -1) * parseInt(vself.pqtdregistros)},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                    retorno.then(function (response) {
                        vself.todastabelas = response.data;
                        loader.hide();
                    }).catch(function (response) {
                        console.log(response.message);
                        vself.todastabelas = [];
                        loader.hide();
                    });
                }else{
                    vself.todastabelas = [];
                }
            },
            mtdenviarcoletor(produto){
                this.produtocoletor   = produto;
                this.qtdenviarcoletor = parseFloat(produto.quantidade) === 0 ? 1 : parseFloat(produto.quantidade);
                $('#mdenviaprodutocoletor').modal('show');
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$nextTick(() => {
                      $('[data-toggle="tooltip"]').tooltip();
                    });
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.002M', vself.$store.state.perfilusuario)) {
                        vself.pathimgview           = vself.$store.state.configpaths.pathimagens;                        
                        vself.produtosporfilial     = vself.$store.state.filialpadrao.produtosporfilial;
                        $('#pnlista').fadeIn(700);
                        // vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                        $("#mdajuste").on('shown.bs.modal', function(){
                            $(this).find('#edqtdmov').focus();
                        });

                        $(document).keydown(function (e) {
                            if(e.which === 27) {
                                $('#mdajuste').modal('hide');
                            }
                        });
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });   
            }
        },
        computed:{
            validou() {
                if (parseInt(this.vprodutoespecifico) === 4){
                    if (this.vidanp === null){
                        return true;
                    }
                }
                return this.vdescricao === ''|| this.vidmarca == null ||
                this.vidgrupo == null || this.vidsubgrupo == null ||
                this.vidsetorproduto == null || this.vund == null ||
                this.vidncm == null; //|| this.lstTabelasPrecos.length == 0;
            },
            calculacusto:function () {
                //$('#cbtabelapreco').val(null).trigger('change');
                this.vmrgtabela         = 0;
                this.vvltabela          = 0;
                this.vcomissaotabela    = 0;
                this.vqtdmintabela      = 0;
                this.vdescontotabela    = 0;
                this.vvldescpromocional = 0;
                this.vprcusto = util.calculacustoproduto(this, this.vpipi/100,
                    this.vpicms/100,
                    this.vpfrete/100,
                    this.vvst,
                    this.vppis/100,
                    this.vpcofins/100,
                    this.vpoutros/100,
                    this.vprcompra,
                    this.vprvendamedio,
                    this.$store.state.filialpadrao.formulacustopro);
                this.mtdrecalcularmargemtabelas();
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
        },
        watch:{
            vopcaocbatribuir(val){
                if(val !== 0){
                    this.vatribuircbaprazomassa = false;
                    this.vatribuircbavistamassa = false;
                }
            },
            pmaisfiltros(val){
                let vself = this;

                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';			

                if(val){// Esses selects 2 vão aqui, pois assim facilita com a reatividade do V-IF - guga
                    setTimeout(() => {
                        $("#cbfiliallocalizacaopesq").select2({
                        id: function (e) {return e.codfil},
                        ajax: {						
                            url: vself.$store.state.configpaths.pathselect2sql,						
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q		: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    sqlini	: sqliniusuario,
                                    sqlfim	: sqlfimusuario,
                                    cpid	: 'codfil',
                                    cpdesc	: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                    ).change(function () {
                        vself.pidfiliallocalizacao = $("#cbfiliallocalizacaopesq").val();
                        vself.mtdlimpar_listagem();
                    });
                     $("#cbidlocalizacaopesq").select2({
                        id: function (e) {return e.id},
                            ajax: {
                                url: vself.$store.state.configpaths.pathselect2,
                                dataType: 'json',
                                delay: 250,
                                data: function (params) {
                                    return {
                                        q: params.term,
                                        idclientesac : vself.$store.state.filialpadrao.idcliente,
                                        tb: 'tblocalizacoes',
                                        c1: 'id',
                                        c2: 'descricao'
                                    };
                                },
                                processResults: function (data) {
                                    return {
                                        results: data
                                    };
                                },
                                cache: true
                            },
                            minimumInputLength: 0,
                            theme: 'bootstrap',
                            language: "pt-BR",
                            templateResult: util.formatResult,
                            templateSelection: util.formatSelection
                        }
                    ).change(function () {
                        vself.pidlocalizacao = $("#cbidlocalizacaopesq").val();
                        vself.mtdlimpar_listagem();
                    });
                        
                    }, 200);
                }else{
                    vself.pidfiliallocalizacao = null;
                    vself.pidlocalizacao       = null;
                    ('#cbfiliallocalizacaopesq').val(null).trigger('change');
                    ('#cbidlocalizacaopesq').val(null).trigger('change');
                }
            },
            pagina_atual(val){
                this.mtdcarregaprodutos(val);
            },
            vlimpardados(val){
                this.vimportarcodigos   = false;
                this.vreconstruirchaves = false;
            },
            oppreco(){
                this.vlink = '';
            },
            opvalor(){
                this.vlink = '';
            },
            pagruparhisvendas() {
                if (this.pagruparhisvendas == 0) {
                    this.columns2[4].label = 'Data da Venda'
                } else {
                    this.columns2[4].label = 'Dt. Última Venda'
                }
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
                    if (this.vid == val){
                        this.$toastr.i('Você já está alterando este produto!', 'Informação!');
                        return;
                    }
                    let exit = false;
                    this.variacoesProduto.forEach(variacao => {
                        if(variacao?.produto?.id == val){
                            this.$toastr.i('Esse produto já foi selecionado!', 'Informação!');
                            exit = true;
                        }
                    });

                    if(!exit){
                        this.mtdlocalizarprodutovariacao(val);
                    }
                }
            },
            otpoperacao(val){
                if(val == 0 || val == 2){
                    // reseta select2 tabela origem
                    this.oidtabelaorigem         = null;
                    $('#cbtabelaorigem').val(null).trigger('change');
                    this.mtdConsultaOperacoesTabelas();
                }
            }

        }
    }
</script>
<style>
    .formato-icon {
        width: 100px;
        height: 100px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        transition: background-image 0.2s ease;
    }

    /* Caixa */
    .caixa-btn .formato-icon {
        background-image: url('~@/assets/caixadefault.png');
    }

    .caixa-btn:hover:not(.active) .formato-icon {
        background-image: url('~@/assets/caixahover.png');
    }

    .caixa-btn.active .formato-icon {
        background-image: url('~@/assets/caixacheck.png'); 
    }

    /* Envelope */
    .envelope-btn .formato-icon {
        background-image: url('~@/assets/envelopedefault.png');
    }

    .envelope-btn:hover:not(.active) .formato-icon {
        background-image: url('~@/assets/envelopehover.png');
    }

    .envelope-btn.active .formato-icon {
        background-image: url('~@/assets/envelopecheck.png'); 
    }

    /* Rolo */
    .rolo-btn .formato-icon {
        background-image: url('~@/assets/rolodefault.png');
    }

    .rolo-btn:hover:not(.active) .formato-icon {
        background-image: url('~@/assets/rolohover.png');
    }

    .rolo-btn.active .formato-icon {
        background-image: url('~@/assets/rolocheck.png'); 
    }

    .formato-btn.active {
        background-color: rgba(0, 123, 255, 0.1) !important;
        border-radius: 8px;
    }
    .Azul{
        color: #4250f2;
    }
    .Amarelo{
        color: #ffbc00;
    }
    .Verde{
        color: #0acf97;
    }
    .Vermelho{
        color: #f82b54;
    }
	#dv-btn-camera{
			display: none;
	}
	@media screen and (max-width: 767px) {
		#dv-btn-camera{
			display: block;
		}
    }
    .dp-impressao-pedido{
        position: absolute!important;
        top: 28px;
        right: 20px;
    }
    .icon-imprimir-pedido{
        cursor: pointer;
        font-size: 22px;
        color: #4250f2;
    }
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-opcoes-produto{
        width: 60px !important;
    }
    .def-col-opcoes-hist-vendas{
        width: 100px !important;
    }
    .img-produto{
        /* width: 180px !important; */
        height: 180px !important;
    }
    .btn-del-imgproduto{
        position: absolute;
        top: 10px;
        left: 25px;
    }
    .def-col-slot-precos{
        width: 160px !important;
    }
    .def-col-img-lst-produto{
        width: 50px !important 
    }
    .img-lst-produto{
        transition: 0.2s;
        border-radius: 25px;
        width: 40px;
        height: 40px;
    } 
    .img-lst-produto-none{
        border-radius: 25px;
        width: 40px;
        height: 40px;
    } 
    .img-lst-produto:hover{
        transition: 0.2s;
        transform: scale(4.1, 4.1);
    }
    .ver{
        background-color: rgb(75, 165, 165) !important;
    }
    .modal-hist-vendas{
        max-width: 950px !important;
    }
    .slot_detalhes{
        width: 50px;
    }	
    #mddetalhespro .vm--modal{
        overflow: auto;
    }
    
    .lds-ellipsis,
    .lds-ellipsis div {
        box-sizing: border-box;
    }
    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 40px;
        height: 40px;
    }
    .lds-ellipsis div {
        position: absolute;
        top: 16.66667px;
        width: 6.66667px;
        height: 6.66667px;
        border-radius: 50%;
        background: currentColor;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 4px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 4px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 16px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 28px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(12px, 0);
        }
    }

    .tooltip-variacao-cor {
        width: 150px;
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%) translateY(-10px);
        background-color: #ffffff;
        border: 2px solid #e2e8f0; 
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        border-radius: 0.75rem; 
        z-index: 99999;
        opacity: 0;
        animation: tooltipAppear 0.5s ease-out forwards;
        
        img {
            /* padding: 10px; */
            border-radius: 10px;
            background-color: #ffffff;
            height: 150px;
            width: 150px;
            object-fit: cover;
            border: 4px solid #e7e7e7;
            animation: imageFloat 0.5s ease-out forwards;
        }
    }



    @keyframes tooltipAppear {
        0% {
            opacity: 0;
            transform: translateX(-50%) translateY(30px) scale(0.7);
        }
        100% {
            opacity: 1;
            transform: translateX(-50%) translateY(-10px) scale(1);
        }
    }

    @keyframes imageFloat {
        0% {
            transform: scale(0.15) translateY(180px);
            border-radius: 50%;
        }
        70% {
            transform: scale(1.1) translateY(-5px);
            border-radius: 15px;
        }
        100% {
            transform: scale(1) translateY(0px);
            border-radius: 10px;
        }
    }

    div .tooltip-variacao-cor div {
        background-color: #f8f9fa;
        padding: 8px;
        width: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        animation: textSlideUp 0.5s ease-out 0.2s forwards;
        opacity: 0;
    }
    div .tooltip-variacao-cor div span {
        font-weight: bold; 
        color: #333;
        animation: textSlideUp 0.4s ease-out 0.15s forwards;
        opacity: 0;
        transform: translateY(20px);
    }
    div .tooltip-variacao-cor div p {
        font-size: 16px;
        color: #555;
        font-weight: 500;
        margin: 4px 0 0 0;
        text-align: center;
        line-height: 1.3;
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
        width: 100%;
        max-width: 160px;
        animation: textSlideUp 0.4s ease-out 0.25s forwards;
        opacity: 0;
        transform: translateY(20px);
    }

    @keyframes textSlideUp {
        0% {
            opacity: 0;
            transform: translateY(20px) scale(0.8);
        }
        100% {
            opacity: 1;
            transform: translateY(0px) scale(1);
        }
    }

    @keyframes tooltipDisappear {
        0% {
            opacity: 1;
            transform: translateX(-50%) translateY(-10px) scale(1);
        }
        100% {
            opacity: 0;
            transform: translateX(-50%) translateY(30px) scale(0.7);
        }
    }

    @keyframes imageShrinkDown {
        0% {
            transform: scale(1) translateY(0px);
            border-radius: 10px;
        }
        30% {
            transform: scale(1.05) translateY(-3px);
            border-radius: 15px;
        }
        100% {
            transform: scale(0.15) translateY(180px);
            border-radius: 50%;
        }
    }

    @keyframes textSlideDown {
        0% {
            opacity: 1;
            transform: translateY(0px) scale(1);
        }
        100% {
            opacity: 0;
            transform: translateY(20px) scale(0.8);
        }
    }

    /* Efeitos do botão quando o tooltip está ativo */
    .btn-produto-variacao {
        transition: all 0.3s ease !important;
    }

    .btn-produto-variacao:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    .btn-tooltip-active {
        transform: translateY(-3px) scale(0.95);
        opacity: 0.7;
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    }

    .btn-tooltip-active img {
        opacity: 0.5;
        filter: blur(1px);
    }

    .btn-tooltip-active span {
        opacity: 0.6;
        transform: scale(0.9);
    }

    .cont-tooltip-var-cor-img img {
        width: 25px;
    }

    .cont-tooltip-var-cor{
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        cursor: default;
    }

    /* Permitir que o tooltip apareça fora dos limites da tabela */
    /* .table-responsive2 {
        overflow: visible !important;
    }
    
    .table-responsive2 table {
        position: relative;
        z-index: 1;
    } */
    
    .cont-tooltip-var-cor:hover ~ *,
    .cont-tooltip-var-cor:hover .table-responsive2 {
        overflow: visible !important;
    }

    .cont-tooltip-var-cor span {
        text-align: center;
        font-size: 14px;
        color: #666666;
        font-weight: 600;
    }

    .cont-tooltip-var-cor p {
        text-align: center;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
    }

    .cont-tooltip-var-cor i{
        animation: piscar 1s infinite;
    }

    /* Tooltip apenas com imagem para variações */
    .tooltip-variacao-imagem {
        width: 200px;
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%) translateY(-10px);
        background-color: #ffffff;
        border: 2px solid #e2e8f0; 
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        border-radius: 0.75rem; 
        z-index: 99999;
        opacity: 0;
        animation: tooltipAppear 0.3s ease-out forwards;
        padding: 10px;
        
        img {
            border-radius: 10px;
            background-color: #ffffff;
            height: 180px;
            width: 180px;
            object-fit: cover;
            border: 2px solid #e7e7e7;
            animation: imageFloat 0.3s ease-out forwards;
        }
    }

    .sem-imagem {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 180px;
        width: 180px;
        background-color: #f8f9fa;
        border: 2px dashed #dee2e6;
        border-radius: 10px;
        
        p {
            margin: 8px 0 0 0;
            color: #999;
            font-size: 14px;
        }
    }

    .produto-variacao-linha {
        transition: all 0.2s ease;
        padding: 8px;
        border-radius: 5px;
        border: 1px solid transparent;
    }

    .produto-variacao-linha:hover {
        background-color: #f8f9fa;
        border: 1px solid #007bff;
        transform: translateY(-1px);
    }

    .produto-linha-completa {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
    }

    .miniatura-produto {
        flex-shrink: 0;
        width: 35px;
        height: 35px;
    }

    .img-miniatura {
        width: 35px;
        height: 35px;
        border-radius: 4px;
        object-fit: cover;
        border: 1px solid #dee2e6;
    }

    .sem-miniatura {
        width: 35px;
        height: 35px;
        background-color: #f8f9fa;
        border: 1px dashed #dee2e6;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        font-size: 12px;
    }

    .info-produto {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    .produto-id-inline {
        color: #808080;
        font-weight: bold;
        font-size: 13px;
        flex-shrink: 0;
    }

    .separador {
        color: #666;
        margin: 0 5px;
        flex-shrink: 0;
    }

    .produto-desc-inline {
        color: #121212;
        font-size: 13px;
        font-weight: bold;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        min-width: 0;
    }
</style>